(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <announcement-rotator> — 告知の回転切替。
   * 方針:
   *   - 前後ボタンは hidden で出力されている。JS が動いたときだけ外す。
   *   - prefers-reduced-motion では自動切替しない（矢印は生きる。WCAG 2.3.3）。
   *   - hover / focus の間は自動切替を止める（WCAG 2.2.2 の「一時停止」を
   *     ポインタとキーボードの双方で満たす）。
   *   - 自動で回っている間だけ aria-live を off にし、止まったら polite に戻す
   *     （7秒ごとに読み上げ続けるとスクリーンリーダーが使えなくなるため）。
   * ------------------------------------------------------------------------ */
  (function () {
    if (customElements.get('announcement-rotator')) return;

    class AnnouncementRotator extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-ann-slide]'));
        this.viewport = this.querySelector('[data-ann-viewport]');
        if (this.slides.length < 2) return;

        this.index = Math.max(0, this.slides.findIndex(function (s) {
          return s.dataset.active === 'true';
        }));
        this.held = false;

        var prev = this.querySelector('[data-ann-prev]');
        var next = this.querySelector('[data-ann-next]');
        if (prev) {
          prev.hidden = false;
          prev.addEventListener('click', this.go.bind(this, -1));
        }
        if (next) {
          next.hidden = false;
          next.addEventListener('click', this.go.bind(this, 1));
        }

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        var seconds = parseFloat(this.dataset.annInterval || '7');
        this.interval = (isNaN(seconds) ? 7 : seconds) * 1000;
        this.auto = !reduce.matches;

        if (this.auto) {
          ['mouseenter', 'focusin'].forEach(function (t) {
            this.addEventListener(t, this.hold.bind(this, true));
          }, this);
          ['mouseleave', 'focusout'].forEach(function (t) {
            this.addEventListener(t, this.hold.bind(this, false));
          }, this);
          this.start();
        }
        this.syncLive();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        this.stop();
        var self = this;
        this.timer = window.setInterval(function () {
          if (self.held || document.hidden) return;
          self.go(1);
        }, this.interval);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      hold(state) {
        this.held = state;
        this.syncLive();
      }

      syncLive() {
        if (!this.viewport) return;
        var rotating = this.auto && !this.held;
        this.viewport.setAttribute('aria-live', rotating ? 'off' : 'polite');
      }

      go(dir) {
        var count = this.slides.length;
        this.slides[this.index].removeAttribute('data-active');
        this.index = (this.index + dir + count) % count;
        this.slides[this.index].setAttribute('data-active', 'true');
      }
    }

    customElements.define('announcement-rotator', AnnouncementRotator);
  })();

  /* ---------------------------------------------------------------------------
   * <announcement-locale> — 言語・通貨フォーム。
   * 告知ブロックの有無とは独立に動く（split だけで出るので既定には出ない）。
   * JSなしでも「適用」ボタンで送信できる。JS が届いたら change で送信し、
   * ボタンは隠す（二度手間をなくす）。
   * ------------------------------------------------------------------------ */
  (function () {
    if (customElements.get('announcement-locale')) return;

    class AnnouncementLocale extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        var form = this.querySelector('form');
        if (!form) return;

        var submit = this.querySelector('[data-ann-loc-submit]');
        if (submit) submit.hidden = true;

        Array.prototype.forEach.call(form.querySelectorAll('select'), function (select) {
          select.addEventListener('change', function () {
            form.submit();
          });
        });
      }
    }

    customElements.define('announcement-locale', AnnouncementLocale);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-video"] && !Shopify.designMode) return;
  try {
    
/* 状態クラスの付け外しだけを担当する薄い層。
   スクロール進捗の計算そのものは assets/motion.js（data-mo-scrub="pin"）が持っていて、
   ここは scroll イベントも requestAnimationFrame も一切持たない。
   motion.js は --mo-progress を「インライン style」に書くので、
   style 属性の変化を MutationObserver で見れば 1 フレームに 1 回だけ通知が来る。 */
(function () {
  'use strict';

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    if (root.hasAttribute('data-bgv-ready')) return;
    root.setAttribute('data-bgv-ready', '');

    /* 「視差効果を減らす」端末では背景動画を自動再生しない（WCAG 2.2.2 の趣旨）。 */
    var video = root.querySelector('video');
    if (video && reduceQuery.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    /* この属性が付いて初めて、CSS 側の初期状態（縮小・テキスト非表示）が有効になる。
       付かない環境＝JS が動いていない環境では、等倍の動画と読めるテキストが出る。 */
    root.setAttribute('data-bgv-live', '');

    var threshold = parseFloat(root.getAttribute('data-bgv-threshold'));
    if (!(threshold > 0)) threshold = 0.2;

    var observer = new MutationObserver(function () {
      var progress = parseFloat(root.style.getPropertyValue('--mo-progress'));
      if (!(progress >= 0)) progress = 0;
      root.classList.toggle('is-complete', progress >= threshold);
    });
    observer.observe(root, { attributes: true, attributeFilter: ['style'] });

    /* motion.js が届かなかったときの保険。layout/theme.liquid が html.mo-js を外すのと
       同じ考え方で、演出を捨てて素の見た目に着地させる（縮んだまま固まるのを防ぐ）。 */
    window.setTimeout(function () {
      if (!window.Motion) root.removeAttribute('data-bgv-live');
    }, 2500);
  }

  function init(scope) {
    var list = (scope || document).querySelectorAll('[data-bgv]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* テーマエディタでセクションを差し替えたとき */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  /**
   * ba-compare — Before/After の境界コントロール
   *
   * 操作は3経路。どれも同じ apply() に集約する。
   *   1. ポインタドラッグ（pointerdown/move/up + setPointerCapture）
   *   2. キーボード（実体が <input type="range"> なので矢印・Home/End はネイティブ）
   *   3. タッチ（pointer events が兼ねる）
   *
   * 書き込みは requestAnimationFrame で1フレーム1回にまとめる。
   * pointermove は1フレームに複数回飛ぶことがあり、そのたび style を書くと
   * 同じフレームのために無駄なスタイル計算が積む。
   * --ba-percent には transition を掛けない（毎フレーム書く値と補間は排他）。
   *
   * ネイティブ range のポインタ挙動（クリックでつまみが飛ぶ）は
   * pointerdown の preventDefault で止め、位置決めは自前の計算に一本化する。
   * preventDefault はフォーカス移動も止めるので focus() を明示的に呼ぶ。
   */
  (function () {
    'use strict';

    class BaCompare extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.range = this.querySelector('.ba__range');
        if (!this.range) return;

        // CSS はこの属性を見てつまみを出す
        this.dataset.ready = 'true';
        this.range.hidden = false;

        this.labelBefore = this.range.getAttribute('data-label-before') || 'Before';
        this.labelAfter = this.range.getAttribute('data-label-after') || 'After';
        this.dragging = false;
        this.raf = 0;
        this.pending = 50;
        this.value = 50;

        this.onInput = this.onInput.bind(this);
        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);
        this.flush = this.flush.bind(this);

        this.range.addEventListener('input', this.onInput);
        this.addEventListener('pointerdown', this.onDown);
        this.addEventListener('pointermove', this.onMove);
        this.addEventListener('pointerup', this.onUp);
        this.addEventListener('pointercancel', this.onUp);

        this.apply(Number(this.range.value));
      }

      disconnectedCallback() {
        if (this.raf) {
          window.cancelAnimationFrame(this.raf);
          this.raf = 0;
        }
      }

      /** 値を受け取り、実際の書き込みは次フレームにまとめる */
      apply(value) {
        var p = Math.round(value);
        if (!isFinite(p)) p = 50;
        this.pending = Math.max(0, Math.min(100, p));
        if (this.raf) return;
        this.raf = window.requestAnimationFrame(this.flush);
      }

      flush() {
        this.raf = 0;
        var p = this.pending;
        if (p === this.value) return;
        this.value = p;

        this.style.setProperty('--ba-percent', p + '%');
        if (Number(this.range.value) !== p) this.range.value = String(p);
        this.range.setAttribute(
          'aria-valuetext',
          this.labelBefore + ' ' + p + '% / ' + this.labelAfter + ' ' + (100 - p) + '%'
        );
      }

      onInput() {
        this.apply(Number(this.range.value));
      }

      onDown(e) {
        if (e.button > 0) return;
        e.preventDefault();

        this.dragging = true;
        this.classList.add('is-dragging');
        try {
          this.setPointerCapture(e.pointerId);
        } catch (err) {
          /* 捕捉できない環境ではバブリングのまま続行する */
        }
        try {
          this.range.focus({ preventScroll: true });
        } catch (err) {
          this.range.focus();
        }
        this.fromPointer(e);
      }

      onMove(e) {
        if (!this.dragging) return;
        e.preventDefault();
        this.fromPointer(e);
      }

      onUp(e) {
        if (!this.dragging) return;
        this.dragging = false;
        this.classList.remove('is-dragging');
        try {
          this.releasePointerCapture(e.pointerId);
        } catch (err) {
          /* 既に解放済み */
        }
      }

      fromPointer(e) {
        var r = this.getBoundingClientRect();
        if (!r.width) return;
        var rtl = window.getComputedStyle(this).direction === 'rtl';
        var x = rtl ? r.right - e.clientX : e.clientX - r.left;
        this.apply((x / r.width) * 100);
      }
    }

    if (!customElements.get('ba-compare')) customElements.define('ba-compare', BaCompare);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-bundle-products"] && !Shopify.designMode) return;
  try {
    
  /**
   * <by-bundle> — 画像の印と商品行の連動、および `items` 一括追加。
   * 印 → 行は共有 `<by-hotspots>` の select イベントに乗る。行 → 印は openSpot()。
   * 送信は /cart/add.js（失敗したら form.submit() ＝ 素の POST にフォールバック）。
   */
  (function () {
    'use strict';

    if (document.documentElement.dataset.design !== 'beyours') return;
    if (!window.customElements || customElements.get('by-bundle')) return;

    class ByBundle extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';
        var self = this;

        this.spots = this.querySelector('by-hotspots');
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-bundle-item]'));
        this.form = this.querySelector('[data-bundle-form]');
        this.error = this.querySelector('[data-bundle-error]');

        if (this.spots) {
          this.spots.addEventListener('select', function (e) {
            self.highlight(e.detail.index);
          });
        }

        this.items.forEach(function (item, i) {
          var open = function () {
            self.highlight(i);
            if (self.spots && typeof self.spots.openSpot === 'function') self.spots.openSpot(i);
          };
          item.addEventListener('mouseenter', open);
          item.addEventListener('focusin', open);
        });

        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      highlight(index) {
        this.items.forEach(function (item, i) {
          item.classList.toggle('is-active', i === index);
        });
      }

      onSubmit(e) {
        if (!window.fetch || !window.FormData) return;
        var self = this;
        var form = this.form;
        var button = form.querySelector('button[type="submit"]');

        e.preventDefault();
        if (this.error) {
          this.error.hidden = true;
          this.error.textContent = '';
        }
        if (button) button.disabled = true;

        var items = [];
        Array.prototype.forEach.call(form.querySelectorAll('input[name$="[id]"]'), function (input) {
          items.push({ id: input.value, quantity: 1 });
        });
        if (!items.length) {
          if (button) button.disabled = false;
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('http-' + res.status);
            return res.json();
          })
          .then(function (data) {
            if (button) button.disabled = false;
            if (window.BeYours) window.BeYours.publish(window.BeYours.EVENTS.cartUpdate, data);
          })
          .catch(function () {
            /* Ajax が通らない環境では素の POST に落とす（規約9） */
            if (button) button.disabled = false;
            self.fallback();
          });
      }

      fallback() {
        if (this.form.dataset.byFallback === 'true') return;
        this.form.dataset.byFallback = 'true';
        this.form.submit();
      }
    }

    customElements.define('by-bundle', ByBundle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-cookie-banner"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <by-cookie-banner data-delay="2" [data-test-mode]>
   *   共有ランタイム（beyours.js）には同意バーの機構が無いので、ここで定義する。
   *   実測（JS機構 §5.2）: delay 秒後に出す・閉じアニメ 500ms・テストモードは
   *   記録を毎回消す。記録先だけ localStorage に変えている（🔷1）。
   * ------------------------------------------------------------------------ */
  (function () {
    if (document.documentElement.dataset.design !== 'beyours') return;
    if (!window.customElements || customElements.get('by-cookie-banner')) return;

    var KEY = 'by:cookie-consent';
    var CLOSE_MS = 500;

    function read() {
      try {
        return window.localStorage.getItem(KEY);
      } catch (e) {
        return null;
      }
    }

    function write(value) {
      try {
        window.localStorage.setItem(KEY, value);
      } catch (e) {
        /* プライベートモード等で書けなくても表示だけは正しく閉じる */
      }
    }

    /** Consent Tracking API が使える環境では同意結果をそちらにも渡す。 */
    function pushConsent(accepted) {
      try {
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (privacy && typeof privacy.setTrackingConsent === 'function') {
          privacy.setTrackingConsent(accepted, function () {});
        }
      } catch (e) {
        /* API が無い / 失敗しても UI は完結させる */
      }
    }

    class ByCookieBanner extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';

        var self = this;
        var test = this.hasAttribute('data-test-mode');
        if (test) write('');
        if (!test && read()) {
          this.remove();
          return;
        }

        var delay = parseFloat(this.dataset.delay);
        if (isNaN(delay)) delay = 2;

        this.timer = setTimeout(function () {
          self.hidden = false;
        }, delay * 1000);

        this.addEventListener('click', function (e) {
          var accept = e.target.closest('[data-cookie-accept]');
          var decline = e.target.closest('[data-cookie-decline]');
          if (!accept && !decline) return;
          self.answer(!!accept);
        });
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.closeTimer);
      }

      answer(accepted) {
        write(accepted ? 'accepted' : 'declined');
        pushConsent(accepted);
        var self = this;
        this.classList.add('is-closing');
        this.closeTimer = setTimeout(function () {
          self.hidden = true;
        }, CLOSE_MS);
      }
    }

    customElements.define('by-cookie-banner', ByCookieBanner);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-footer"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <by-footer>
   *   768px 以上ではメニュー列の <details> を開いたままにし、summary をフォーカス
   *   対象から外す（見出しとして扱う）。767px 以下では閉じてアコーディオンに戻す。
   *   CSS だけで details の中身を開いたままにする方法は Chrome では効かない
   *   （UA が shadow 側の slot を隠すため）ので、ここは JS でやる（🔷1）。
   *   JS が落ちた場合は markup の open がそのまま残る＝全段が開いて読める。
   * ------------------------------------------------------------------------ */
  (function () {
    if (document.documentElement.dataset.design !== 'beyours') return;
    if (!window.customElements || customElements.get('by-footer')) return;

    class ByFooter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';

        this.items = Array.prototype.slice.call(this.querySelectorAll('details.by-footer__block'));
        if (!this.items.length) return;

        this.mql = window.matchMedia('(min-width: 768px)');
        this.apply = this.apply.bind(this);
        this.apply();
        if (this.mql.addEventListener) this.mql.addEventListener('change', this.apply);
        else if (this.mql.addListener) this.mql.addListener(this.apply);
      }

      disconnectedCallback() {
        if (!this.mql) return;
        if (this.mql.removeEventListener) this.mql.removeEventListener('change', this.apply);
        else if (this.mql.removeListener) this.mql.removeListener(this.apply);
      }

      apply() {
        var wide = this.mql.matches;
        this.items.forEach(function (item) {
          var summary = item.querySelector('summary');
          item.open = wide;
          if (!summary) return;
          if (wide) summary.setAttribute('tabindex', '-1');
          else summary.removeAttribute('tabindex');
        });
      }
    }

    customElements.define('by-footer', ByFooter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-header"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <by-header>… ではなく by-sticky-header（core）に載せる補助スクリプト。
   *   1. sticky で畳んだナビのトグル（core は [data-header-toggle] の click 後
   *      250ms だけスクロール反応を止める。クラスの付け外しはここが持つ）
   *   2. メガメニューの Escape 閉じ（開くのは CSS。閉じるだけ JS が要る）
   *   3. ドロワーとモーダルが開いている間の背景スクロールは core が持つ
   * JS が落ちても、ナビは常時表示・メガは hover / :focus-within で開く。
   * ------------------------------------------------------------------------ */
  (function () {
    if (document.documentElement.dataset.design !== 'beyours') return;

    /* core の by-sticky-header は ResizeObserver / resize で measure() を呼ぶ。
       固定表示中（position: fixed / sticky）に呼ばれると rect が viewport 基準に
       なり、閾値がその時の scrollY 分だけ膨らむ（＝一度隠れたあと上スクロールで
       戻らなくなる）。スモークで実測: 閾値 218px → 670px。
       ここでは「最上部にいる＝固定されていない」ときの値を控えて、膨らんだら
       戻す。core 側で「固定中は測らない」ようにできればこの補正は不要になる。 */
    function pinThreshold(host) {
      if (typeof host.measure !== 'function') return;
      var saved = host.bottom || host.getBoundingClientRect().bottom + window.pageYOffset;

      function restore() {
        if (window.pageYOffset <= 0) {
          saved = host.getBoundingClientRect().bottom + window.pageYOffset;
          return;
        }
        if (saved) host.bottom = saved;
      }

      /* core より後に作った ResizeObserver / resize リスナは core の measure() の
         直後に呼ばれるので、膨らんだ閾値をその場で戻せる（次のスクロール判定に
         間に合う）。scroll では戻さない — core の判定の方が先に走るため。 */
      if ('ResizeObserver' in window) new ResizeObserver(restore).observe(host);
      window.addEventListener('resize', restore, { passive: true });
      window.addEventListener(
        'scroll',
        function () {
          if (window.pageYOffset <= 0) saved = host.getBoundingClientRect().bottom;
        },
        { passive: true }
      );
    }

    function init(root) {
      if (!root || root.dataset.byHeaderReady === 'true') return;
      root.dataset.byHeaderReady = 'true';

      var section = root.closest('.shopify-section') || root;
      pinThreshold(root);

      var toggle = root.querySelector('[data-header-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var open = section.classList.toggle('by-header-menu-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      /* Escape で開いているパネルを閉じる。ポインタが動く／フォーカスが入ると
         is-closed を外して、同じ項目にもう一度ホバーできるようにする。 */
      var closed = false;
      function clear() {
        if (!closed) return;
        closed = false;
        Array.prototype.forEach.call(root.querySelectorAll('.by-header__item--panel.is-closed'), function (el) {
          el.classList.remove('is-closed');
        });
      }

      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!e.target || typeof e.target.closest !== 'function') return;
        var item = e.target.closest('.by-header__item--panel');
        if (!item) return;
        var link = item.querySelector('.by-header__link');
        if (link) link.focus();
        item.classList.add('is-closed');
        closed = true;
      });
      root.addEventListener('focusin', clear);
      root.addEventListener('pointerover', clear);
    }

    function boot() {
      Array.prototype.forEach.call(document.querySelectorAll('by-sticky-header.by-header-wrap'), init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-main-product"]) return;
  try {
    
  /**
   * <by-recent-writer> — 最近見た商品の履歴を書くだけの要素。
   *
   * 契約（読み手 = sections/by-recently-viewed.liquid）
   *   localStorage['beyours:recently-viewed'] = '["handle-a","handle-b", ...]'（新しい順）
   * プライベートブラウズでは localStorage のアクセス自体が throw するので必ず包む。
   */
  (function () {
    'use strict';

    var KEY = 'beyours:recently-viewed';
    var MAX = 12;

    function push(handle) {
      if (!handle) return;
      try {
        var raw = window.localStorage.getItem(KEY);
        var list = raw ? JSON.parse(raw) : [];
        if (!Array.isArray(list)) list = [];
        list = list.filter(function (h) {
          return typeof h === 'string' && h !== handle;
        });
        list.unshift(handle);
        window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
      } catch (e) {
        /* 保存できない環境では履歴を諦める（表示側にフォールバックがある） */
      }
    }

    class ByRecentWriter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';
        push(this.dataset.handle);
      }
    }

    if (window.customElements && !customElements.get('by-recent-writer')) {
      customElements.define('by-recent-writer', ByRecentWriter);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-multicolumn"] && !Shopify.designMode) return;
  try {
    
  /**
   * <by-mc-modal> — このセクション専用のモーダル。
   * 共有ランタイム（beyours.js）にモーダルの JS が無く、共通層は変更しない
   * 約束のためセクション内に閉じて持つ。開閉は共有 CSS の .is-open に委ねる。
   * JS が落ちてもモーダルは閉じたまま＝カード本文だけで内容が読める設計にしてある。
   */
  (function () {
    'use strict';

    if (document.documentElement.dataset.design !== 'beyours') return;
    if (!window.customElements || customElements.get('by-mc-modal')) return;

    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]),' +
      ' textarea:not([disabled]), video[controls], [tabindex]:not([tabindex="-1"])';

    class ByMcModal extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';
        var self = this;

        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-by-mc-close]')) self.close();
        });

        this.onKeydown = function (e) {
          if (!self.classList.contains('is-open')) return;
          if (e.key === 'Escape') {
            self.close();
            return;
          }
          if (e.key !== 'Tab') return;
          var items = self.querySelectorAll(FOCUSABLE);
          if (!items.length) return;
          var first = items[0];
          var last = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        };
        document.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
      }

      open(opener) {
        this.opener = opener || null;
        this.classList.add('is-open');
        document.body.classList.add('by-drawer-open');
        var focusable = this.querySelector(FOCUSABLE);
        if (focusable) focusable.focus();
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.body.classList.remove('by-drawer-open');
        Array.prototype.forEach.call(this.querySelectorAll('video'), function (v) {
          v.pause();
        });
        if (this.opener) this.opener.focus();
      }
    }

    customElements.define('by-mc-modal', ByMcModal);

    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-by-mc-open]') : null;
      if (!opener) return;
      var modal = document.querySelector(opener.getAttribute('data-by-mc-open'));
      if (!modal || typeof modal.open !== 'function') return;
      e.preventDefault();
      modal.open(opener);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-popup"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <by-popup data-delay="7" data-expiry="30" [data-test-mode]>
   *   共有ランタイム（beyours.js）にポップアップの機構が無いのでここで定義する。
   *   実測（JS機構 §5.2）: delay 秒後に開く・閉じ 500ms・記録は expiry 日で失効・
   *   テストモードは記録を毎回消す・フォームエラーがあれば即開く。
   *   記録先を localStorage に変えている（🔷1）。開閉は :target でも成立するので、
   *   ここは「自動で開く」「アニメの後始末」「フォーカス管理」だけを足す。
   * ------------------------------------------------------------------------ */
  (function () {
    if (document.documentElement.dataset.design !== 'beyours') return;
    if (!window.customElements || customElements.get('by-popup')) return;

    var KEY = 'by:promo-popup';
    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])';

    function seen() {
      try {
        var raw = window.localStorage.getItem(KEY);
        if (!raw) return false;
        return parseInt(raw, 10) > Date.now();
      } catch (e) {
        return false;
      }
    }

    function remember(days) {
      try {
        window.localStorage.setItem(KEY, String(Date.now() + days * 86400000));
      } catch (e) {
        /* 書けない環境でも開閉自体は成立させる */
      }
    }

    function forget() {
      try {
        window.localStorage.removeItem(KEY);
      } catch (e) {
        /* noop */
      }
    }

    class ByPopup extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';

        var self = this;
        this.panel = this.querySelector('.by-popup');
        if (!this.panel) return;

        this.expiry = parseFloat(this.dataset.expiry);
        if (isNaN(this.expiry)) this.expiry = 30;
        if (this.hasAttribute('data-test-mode')) forget();

        this.onKeydown = function (e) {
          if (e.key === 'Escape') self.close();
          else if (e.key === 'Tab') self.trap(e);
        };

        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-popup-close]')) {
            e.preventDefault();
            self.close();
            return;
          }
          if (e.target.closest('[data-popup-open]')) {
            e.preventDefault();
            self.open();
            return;
          }
          var toggle = e.target.closest('[data-social-toggle]');
          if (toggle) {
            var box = toggle.parentNode;
            var on = box.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
          }
        });

        /* フォームにエラーが出て戻ってきた場合は待たずに開く（実測と同じ） */
        var hasError = !!this.querySelector('[role="alert"]');
        var delay = parseFloat(this.dataset.delay);
        if (isNaN(delay)) delay = 7;
        if (hasError) {
          this.open();
        } else if (!seen()) {
          this.timer = setTimeout(function () {
            self.open();
          }, delay * 1000);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('keydown', this.onKeydown);
      }

      open() {
        if (this.panel.classList.contains('is-open')) return;
        this.opener = document.activeElement;
        this.panel.classList.add('is-open');
        document.addEventListener('keydown', this.onKeydown);
        /* 見出しのハイライトは <by-animate> ではなく開いた瞬間に自分で発火させる */
        var hl = this.querySelector('.by-hl');
        if (hl) hl.setAttribute('animate', '');
        var first = this.panel.querySelector('.by-popup__wrapper ' + FOCUSABLE);
        if (first) first.focus({ preventScroll: true });
      }

      close() {
        if (!this.panel.classList.contains('is-open')) {
          /* :target で開いていた場合はハッシュを外すだけで閉じる */
          if (window.location.hash === '#ByPopup') window.location.hash = '';
          return;
        }
        this.panel.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKeydown);
        remember(this.expiry);
        if (window.location.hash === '#ByPopup') window.location.hash = '';
        if (this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
      }

      trap(e) {
        var items = Array.prototype.filter.call(this.panel.querySelectorAll(FOCUSABLE), function (el) {
          return el.offsetParent !== null;
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('by-popup', ByPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-product-recommendations"]) return;
  try {
    
  /**
   * <by-recs> — Shopify のレコメンドを後から取りに行き、グリッドを差し替える。
   *
   * 来る前（JS 無し）: 同じコレクションの他の商品が既に並んでいる。
   * 来た後: 画面に近づいたら Section Rendering API を1回だけ叩き、
   *         返ってきた HTML の .by-recs__grid で今のグリッドを置き換える。
   * 失敗・0件・fetch 非対応のときは何もしない（フォールバックが残る）。
   */
  (() => {
    'use strict';

    class ByRecs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        const url = this.dataset.url;
        if (!url || !window.fetch) return;
        this.dataset.byReady = 'true';

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.io.disconnect();
              this.io = null;
              this.load(url);
            },
            { rootMargin: '200px' }
          );
          this.io.observe(this);
        } else {
          this.load(url);
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      load(url) {
        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.querySelector('.by-recs__grid');
            if (!next) return;
            const current = this.querySelector('.by-recs__grid');
            if (current) current.replaceWith(next);
            else this.appendChild(next);
          })
          .catch(() => {
            /* 取れなければフォールバックのまま。段は消さない */
          });
      }
    }

    if (window.customElements && !customElements.get('by-recs')) {
      customElements.define('by-recs', ByRecs);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  /**
   * <by-recently-viewed> — 履歴（localStorage）を読んで段の中身を差し替える。
   *
   * ここが1行も動かなくても、サーバー側で描いたフォールバックがそのまま残る。
   *   localStorage['beyours:recently-viewed'] = '["handle-a","handle-b", ...]'（新しい順）
   * 取り直しは Section Rendering API:
   *   /search?section_id=<id>&type=product&q=handle:a OR handle:b
   */
  (() => {
    'use strict';

    const KEY = 'beyours:recently-viewed';
    const MAX_TERMS = 12;

    function readHistory(exclude) {
      try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) return [];
        const list = JSON.parse(raw);
        if (!Array.isArray(list)) return [];
        const out = [];
        for (let i = 0; i < list.length; i += 1) {
          const h = list[i];
          if (typeof h !== 'string') continue;
          if (!/^[a-z0-9-]+$/i.test(h)) continue;
          if (h === exclude || out.indexOf(h) !== -1) continue;
          out.push(h);
          if (out.length >= MAX_TERMS) break;
        }
        return out;
      } catch (e) {
        return [];
      }
    }

    function reorder(inner, handles) {
      const list = inner.querySelector('.by-rv__grid');
      if (!list) return;
      Array.prototype.slice
        .call(list.querySelectorAll('[data-rv-handle]'))
        .sort((a, b) => {
          const ia = handles.indexOf(a.getAttribute('data-rv-handle'));
          const ib = handles.indexOf(b.getAttribute('data-rv-handle'));
          return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
        })
        .forEach((cell) => list.appendChild(cell));
    }

    class ByRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';
        if (!window.fetch || !window.DOMParser) return;

        this.handles = readHistory(this.dataset.exclude);
        if (!this.handles.length) return;

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.io.disconnect();
              this.io = null;
              this.load();
            },
            { rootMargin: '200px' }
          );
          this.io.observe(this);
        } else {
          this.load();
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      load() {
        const limit = parseInt(this.dataset.limit, 10) || 4;
        const terms = this.handles
          .slice(0, limit + 2)
          .map((h) => 'handle:' + h)
          .join(' OR ');

        fetch(this.dataset.url + encodeURIComponent(terms))
          .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.querySelector('[data-rv-inner]');
            if (!next || !next.querySelector('[data-rv-handle]')) return;
            reorder(next, this.handles);
            const current = this.querySelector('[data-rv-inner]');
            if (current) current.replaceWith(next);
          })
          .catch(() => {
            /* 取れなければフォールバックのまま */
          });
      }
    }

    if (window.customElements && !customElements.get('by-recently-viewed')) {
      customElements.define('by-recently-viewed', ByRecentlyViewed);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-reveal-banner"] && !Shopify.designMode) return;
  try {
    
  /**
   * <by-rb-modal> — reveal-banner の動画モーダル。
   * 共有ランタイムにモーダルの JS が無いためセクション内に閉じて持つ。
   * 開閉は共有 CSS の .is-open に委ねる。JS が落ちてもバナー本体は全部読める。
   */
  (function () {
    'use strict';

    if (document.documentElement.dataset.design !== 'beyours') return;
    if (!window.customElements || customElements.get('by-rb-modal')) return;

    var FOCUSABLE =
      'a[href], button:not([disabled]), video[controls], iframe, [tabindex]:not([tabindex="-1"])';

    class ByRbModal extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';
        var self = this;

        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-by-rb-close]')) self.close();
        });

        this.onKeydown = function (e) {
          if (!self.classList.contains('is-open')) return;
          if (e.key === 'Escape') {
            self.close();
            return;
          }
          if (e.key !== 'Tab') return;
          var items = self.querySelectorAll(FOCUSABLE);
          if (!items.length) return;
          var first = items[0];
          var last = items[items.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        };
        document.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
      }

      open(opener) {
        this.opener = opener || null;
        this.classList.add('is-open');
        document.body.classList.add('by-drawer-open');
        var focusable = this.querySelector(FOCUSABLE);
        if (focusable) focusable.focus();
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.body.classList.remove('by-drawer-open');
        Array.prototype.forEach.call(this.querySelectorAll('video'), function (v) {
          v.pause();
        });
        if (this.opener) this.opener.focus();
      }
    }

    customElements.define('by-rb-modal', ByRbModal);

    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-by-rb-open]') : null;
      if (!opener) return;
      var modal = document.querySelector(opener.getAttribute('data-by-rb-open'));
      if (!modal || typeof modal.open !== 'function') return;
      e.preventDefault();
      modal.open(opener);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-scrolling-promotion"] && !Shopify.designMode) return;
  try {
    
  /**
   * 帯の一時停止（WCAG 2.2.2）。走行そのものは assets/beyours.js の <by-marquee> が持ち、
   * 停止は共通層の .is-paused（animation-play-state: paused）に委ねる。
   * これが動かなくても帯は流れ続ける＝機能の追加であって前提ではない。
   */
  (() => {
    'use strict';

    const PLAY = '流れを動かす';

    function bind(button) {
      if (button.dataset.byPauseBound === 'true') return;
      button.dataset.byPauseBound = 'true';

      const marquee = button.closest('by-marquee');
      if (!marquee) return;

      const label = button.querySelector('[data-promo-pause-label]');
      const pausedText = label ? label.textContent : '';

      button.addEventListener('click', () => {
        // <by-marquee> 自身が画面外判定で .is-paused を付け外しするため、利用者の
        // 意思は別クラス（CSS 側で (0,3,0)）に持つ。IO の付け外しに消されない。
        const paused = marquee.classList.toggle('by-promo--user-paused');
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (label) label.textContent = paused ? PLAY : pausedText;
      });
    }

    function init(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-promo-pause]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  /**
   * スライダー change → 対応ホットスポットを点灯（実測 §F-6 の Flickity change →
   * `.focus` 付け替え）。共有 JS は hotspot → slider の片方向しか持たないので、
   * 逆向きだけをここで足す。往復ループは「すでに開いていれば何もしない」で止まる。
   */
  (function () {
    'use strict';

    if (document.documentElement.dataset.design !== 'beyours') return;
    if (!window.customElements || customElements.get('by-stl-link')) return;

    class ByStlLink extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.dataset.byReady = 'true';

        var spots = this.querySelector('by-hotspots');
        var slider = this.querySelector('by-slider');
        if (!spots || !slider) return;

        slider.addEventListener('change', function (e) {
          /* 共有 <by-hotspots> は document の click で closeAll() する。ドットを
             押した場合、change → openSpot は bubbling の途中で走るので直後に
             消される。マクロタスクへ逃がして closeAll の後に点け直す。 */
          window.setTimeout(function () {
            var list = spots.querySelectorAll('.by-hotspot');
            var spot = list[e.detail.index];
            if (!spot || spot.classList.contains('is-open')) return;
            if (typeof spots.openSpot === 'function') spots.openSpot(e.detail.index);
          }, 0);
        });
      }
    }

    customElements.define('by-stl-link', ByStlLink);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-similar-products"] && !Shopify.designMode) return;
  try {
    
  /**
   * <by-similar-products> — カード右上の「類似商品」から開くドロワー。
   *
   * 前提（JS が無いとき）: トリガは素の <a href="コレクションURL"> なので、押せば
   * そのコレクションへ遷移する。ここでは fetch が使えるときだけ横取りする。
   *
   * 取得: data-url（= /recommendations/products?section_id=…&limit=…&intent=related）に
   *       &product_id= を足して取り、応答の [data-similar-result] だけを流し込む。
   *       商品ID 別に Map でキャッシュ（同じカードを2回押しても往復しない）。
   */
  (() => {
    'use strict';

    class BySimilarProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.byReady === 'true') return;
        this.drawer = this.querySelector('by-drawer');
        this.content = this.querySelector('[data-similar-content]');
        if (!this.drawer || !this.content || !window.fetch) return;

        this.dataset.byReady = 'true';
        this.cache = new Map();
        this.statusHtml = this.content.innerHTML;

        document.addEventListener('click', (event) => {
          const trigger = event.target.closest ? event.target.closest('[data-similar-product-id]') : null;
          if (!trigger) return;
          if (typeof this.drawer.open !== 'function') return;
          event.preventDefault();
          this.openFor(trigger.getAttribute('data-similar-product-id'), trigger);
        });
      }

      openFor(productId, opener) {
        this.drawer.open(opener);

        const cached = this.cache.get(productId);
        if (cached) {
          this.content.innerHTML = cached;
          return;
        }

        this.content.innerHTML = this.statusHtml;

        const url = `${this.dataset.url}&product_id=${encodeURIComponent(productId)}`;
        fetch(url, { headers: { Accept: 'text/html' } })
          .then((res) => {
            if (!res.ok) throw new Error(`http-${res.status}`);
            return res.text();
          })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const result = doc.querySelector('[data-similar-result]');
            if (!result) throw new Error('no-result');
            this.cache.set(productId, result.innerHTML);
            this.content.innerHTML = result.innerHTML;
          })
          .catch(() => {
            // 取得できなければ「見つからなかった」と言い切らず、素の導線へ戻す
            if (opener && opener.href) {
              window.location.href = opener.href;
            }
          });
      }
    }

    if (window.customElements && !customElements.get('by-similar-products')) {
      customElements.define('by-similar-products', BySimilarProducts);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-slideshow"] && !Shopify.designMode) return;
  try {
    
/* by-slideshow: スライドが切り替わるたびにテキストの連鎖を撃ち直す。
   共通層の <by-animate> は「一度きり」（実測どおり）なので、そのままだと
   2枚目以降のテキストが動かない。自セクションのスコープだけで [animate] を
   外して次フレームで付け直す。reduced-motion では触らない（常時 animate のまま）。 */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('change', function (event) {
    var slider = event.target;
    if (!slider || !slider.classList || !slider.classList.contains('by-ss__text')) return;
    if (reduced.matches) return;

    var slides = slider.querySelectorAll('.by-ss__text-slide');
    var index = event.detail && typeof event.detail.index === 'number' ? event.detail.index : 0;
    var current = slides[index];
    if (!current) return;

    var box = current.querySelector('.by-ss__animate');
    if (!box) return;
    box.removeAttribute('animate');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        box.setAttribute('animate', '');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["by-testimonials"] && !Shopify.designMode) return;
  try {
    
  /**
   * 顔写真の列に「選択中 / 前 / 次」の印を付け、写真そのものを押せるようにする。
   *
   * 走行と2トラック同期そのものは assets/beyours.js の <by-slider>（data-sync）が持つ。
   * ここが動かなくても、矢印・スワイプ・引用の切り替えは成立する（拡大の演出だけが出ない）。
   */
  (() => {
    'use strict';

    function mark(slider) {
      const faces = Array.from(slider.querySelectorAll('.by-testi__face'));
      if (!faces.length) return;
      const total = faces.length;
      const current = typeof slider.index === 'number' ? slider.index : 0;
      const prev = (current - 1 + total) % total;
      const next = (current + 1) % total;

      faces.forEach((face, i) => {
        face.classList.toggle('is-selected', i === current);
        face.classList.toggle('is-previous', total > 2 && i === prev);
        face.classList.toggle('is-next', total > 2 && i === next);
      });

      // レールを現在の番号ぶんだけ送る（CSS 側が transform で受ける）
      slider.style.setProperty('--by-testi-i', String(current));
    }

    function bind(slider) {
      if (slider.dataset.byTestiBound === 'true') return;
      slider.dataset.byTestiBound = 'true';

      // 横スクロールしない列なので、共通層の位置監視（IO）は止める。
      // 残したままだと「0.5 以上見えているうち最も先頭寄り」が現在位置を
      // 2つ手前に書き戻し、選択と表示が振動する。
      if (slider.io && typeof slider.io.disconnect === 'function') {
        slider.io.disconnect();
        slider.io = null;
      }
      const track = slider.querySelector('.by-slider__track');
      if (track) track.removeAttribute('tabindex');

      slider.addEventListener('change', () => mark(slider));

      slider.querySelectorAll('[data-testi-select]').forEach((button) => {
        button.addEventListener('click', () => {
          const index = parseInt(button.getAttribute('data-testi-select'), 10);
          // カスタム要素がまだ upgrade されていない場合に備えて毎回確かめる
          if (typeof slider.select === 'function') slider.select(index);
          else mark(slider);
        });
      });

      mark(slider);
    }

    function init(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.by-testi__faces').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * collection-carousel
   * - タブ切替（クリック / ←→↑↓ / Home / End）
   * - 矢印による scrollBy（端で disabled + aria-disabled）
   * - 端フェードの ON/OFF
   * - マウスでトラックを掴んで送るドラッグ（指・ペンは触らない＝iOSの慣性と競合しない）
   * JSが動かない場合はこのクラスが定義されず data-ccar-ready も付かないため、
   * CSS側は「全パネル表示・矢印非表示」のまま＝内容は全部読める。
   * ドラッグも付かないだけで、ネイティブの横スクロールはそのまま効く。
   */
  if (!customElements.get('collection-carousel')) {
    customElements.define(
      'collection-carousel',
      class CollectionCarousel extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ccarReady !== undefined) return;

          this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
          if (!this.tabs.length) return;

          this.panels = this.tabs.map(function (tab) {
            return document.getElementById(tab.getAttribute('aria-controls'));
          });
          this.arrows = Array.prototype.slice.call(this.querySelectorAll('[data-ccar-dir]'));
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.index = 0;
          this.ticking = false;
          this.drag = null;
          this.dragged = false;

          this.onTabClick = this.onTabClick.bind(this);
          this.onTabKey = this.onTabKey.bind(this);
          this.onArrowClick = this.onArrowClick.bind(this);
          this.onScroll = this.onScroll.bind(this);
          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerEnd = this.onPointerEnd.bind(this);
          this.onDragStart = this.onDragStart.bind(this);
          this.onTrackClick = this.onTrackClick.bind(this);
          this.sync = this.sync.bind(this);

          var list = this.querySelector('[role="tablist"]');
          if (list) {
            list.addEventListener('click', this.onTabClick);
            list.addEventListener('keydown', this.onTabKey);
          }
          this.arrows.forEach(
            function (btn) {
              btn.addEventListener('click', this.onArrowClick);
            }.bind(this)
          );
          this.panels.forEach(
            function (panel) {
              var track = panel && panel.querySelector('.ccar__track');
              if (!track) return;
              track.addEventListener('scroll', this.onScroll, { passive: true });
              track.addEventListener('pointerdown', this.onPointerDown);
              track.addEventListener('pointermove', this.onPointerMove);
              track.addEventListener('pointerup', this.onPointerEnd);
              track.addEventListener('pointercancel', this.onPointerEnd);
              track.addEventListener('dragstart', this.onDragStart);
              // 捕捉フェーズ。ドラッグ直後のクリックが商品リンクに届く前に止める
              track.addEventListener('click', this.onTrackClick, true);
            }.bind(this)
          );

          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.sync);
            this.ro.observe(this);
          } else {
            window.addEventListener('resize', this.sync);
          }

          this.dataset.ccarReady = '';
          this.select(0, false);
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
        }

        track(i) {
          var panel = this.panels[i === undefined ? this.index : i];
          return panel ? panel.querySelector('.ccar__track') : null;
        }

        select(index, moveFocus) {
          this.index = index;
          this.tabs.forEach(
            function (tab, i) {
              var on = i === index;
              tab.setAttribute('aria-selected', on ? 'true' : 'false');
              tab.tabIndex = on ? 0 : -1;
              var panel = this.panels[i];
              if (!panel) return;
              if (on) panel.removeAttribute('data-ccar-inactive');
              else panel.setAttribute('data-ccar-inactive', '');
            }.bind(this)
          );
          if (moveFocus) this.tabs[index].focus();
          this.sync();
        }

        onTabClick(event) {
          var tab = event.target.closest('[role="tab"]');
          if (!tab) return;
          var i = this.tabs.indexOf(tab);
          if (i < 0) return;
          // JSなし時のアンカー移動を上書きする（URLハッシュも増やさない）
          event.preventDefault();
          this.select(i, false);
        }

        onTabKey(event) {
          var last = this.tabs.length - 1;
          var next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = this.index === last ? 0 : this.index + 1;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = this.index === 0 ? last : this.index - 1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = last;
          if (next === null) return;
          event.preventDefault();
          this.select(next, true);
        }

        onArrowClick(event) {
          var btn = event.currentTarget;
          if (btn.disabled) return;
          var track = this.track();
          if (!track) return;

          var item = track.querySelector('.ccar__item');
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap) || 0;
          var unit = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
          // 選択カード型は Pearl 実測どおり1回1枚。テキストタブ型は1画面ぶんまとめて送る
          var count = 1;
          if (!this.classList.contains('ccar--cards')) {
            count = Math.max(1, Math.floor(track.clientWidth / unit));
          }
          var delta = unit * count * (btn.dataset.ccarDir === 'prev' ? -1 : 1);

          track.scrollBy({ left: delta, behavior: this.reduced.matches ? 'auto' : 'smooth' });
        }

        /**
         * ここから4つがドラッグ送り。
         * 方針: 指とペンには一切触らない。iOS/Android のネイティブ横スクロールは
         * 慣性・バウンス・snap まで込みで自前実装より質が高く、割り込むと必ず劣化する。
         * マウスだけが「掴んで送る」手段を持っていないので、そこだけ足す。
         */
        onPointerDown(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          var track = event.currentTarget;
          // ネイティブの横スクロールバーを掴んだときは邪魔しない
          // （clientHeight はスクロールバーを含まないので、その下＝バー上と判る）
          if (event.clientY - track.getBoundingClientRect().top > track.clientHeight) return;

          this.dragged = false;
          this.drag = {
            track: track,
            id: event.pointerId,
            x: event.clientX,
            left: track.scrollLeft,
            active: false
          };
        }

        onPointerMove(event) {
          var d = this.drag;
          if (!d || event.pointerId !== d.id) return;
          // ボタンを離したのに pointerup を取りこぼした場合の保険
          if (event.buttons === 0) {
            this.onPointerEnd(event);
            return;
          }

          var dx = event.clientX - d.x;
          if (!d.active) {
            // 5px 未満は「クリックのときの手ブレ」。ここで動かすとカード内リンクを誤爆する
            if (Math.abs(dx) < 5) return;
            d.active = true;
            this.dragged = true;
            // 吸着とスムーススクロールを切ってから動かす（CSS側の [data-ccar-dragging]）
            d.track.setAttribute('data-ccar-dragging', '');
            if (d.track.setPointerCapture) {
              try {
                d.track.setPointerCapture(d.id);
              } catch (err) {
                /* 捕捉できない環境ではトラック上のドラッグだけ効く */
              }
            }
          }
          d.track.scrollLeft = d.left - dx;
        }

        onPointerEnd(event) {
          var d = this.drag;
          if (!d || (event && event.pointerId !== d.id)) return;
          this.drag = null;
          if (d.track.releasePointerCapture) {
            try {
              d.track.releasePointerCapture(d.id);
            } catch (err) {
              /* 未捕捉なら何もしなくてよい */
            }
          }
          // 属性を外すと吸着が復帰し、いちばん近いカードに収まる
          d.track.removeAttribute('data-ccar-dragging');
        }

        onDragStart(event) {
          // 画像のネイティブドラッグ（ゴースト画像）がカルーセルの操作を奪うのを止める
          if (this.drag && this.drag.active) event.preventDefault();
        }

        onTrackClick(event) {
          if (!this.dragged) return;
          // detail 0 = キーボードの Enter 起点。ドラッグの残骸で潰してはいけない
          if (event.detail === 0) return;
          this.dragged = false;
          event.preventDefault();
          event.stopPropagation();
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(
            function () {
              this.ticking = false;
              this.sync();
            }.bind(this)
          );
        }

        sync() {
          var track = this.track();
          if (!track) return;
          var max = track.scrollWidth - track.clientWidth;
          var x = track.scrollLeft;
          var canPrev = x > 1;
          var canNext = x < max - 1;

          track.toggleAttribute('data-ccar-can-prev', canPrev);
          track.toggleAttribute('data-ccar-can-next', canNext);
          this.toggleAttribute('data-ccar-static', max <= 1);

          this.arrows.forEach(
            function (btn) {
              var enabled = btn.dataset.ccarDir === 'prev' ? canPrev : canNext;
              // 無効化する矢印にフォーカスが乗っていたら、反対側へ逃がす（フォーカス消失の防止）
              if (!enabled && document.activeElement === btn) {
                var other = this.arrows.find(function (b) {
                  // cards では左カラム側の1組が display:none。そこへ飛ばすとフォーカスが消える
                  return b !== btn && !b.disabled && b.offsetParent !== null;
                });
                if (other) other.focus();
              }
              btn.disabled = !enabled;
              btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
            }.bind(this)
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * concept-cart-drawer
   *
   * 方針
   *   1. 描画は必ず Liquid（セクションレンダリングAPI）に戻す。JS で金額文字列を
   *      組み立てない＝通貨・ロケール・税表示の設定に自動追随する。
   *   2. document 委譲だけでヘッダー側のマークアップを一切変更せずに動く。
   *   3. 失敗したら必ず「素の遷移」に落とす（fetch 失敗 / 422 / API 応答不正）。
   *   4. JS が無ければドロワーは一度も可視化されず、素の POST がそのまま動く。
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    var FOCUSABLE =
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

    /* --- 画面ロック（複数オーバーレイの入れ子でも壊れないよう参照カウント） --- */
    window.CsOverlayKit =
      window.CsOverlayKit ||
      (function () {
        var depth = 0;
        var prev = '';
        var gutter = !!(window.CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable'));

        function lock() {
          depth += 1;
          if (depth > 1) return;
          var root = document.documentElement;
          prev = root.style.overflow;
          if (!gutter) {
            var bar = window.innerWidth - root.clientWidth;
            if (bar > 0) document.body.style.paddingInlineEnd = bar + 'px';
          }
          root.style.overflow = 'hidden';
        }

        function unlock() {
          depth -= 1;
          if (depth > 0) return;
          depth = 0;
          document.documentElement.style.overflow = prev;
          document.body.style.paddingInlineEnd = '';
        }

        function visible(el) {
          return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        }

        function trap(root, event) {
          if (event.key !== 'Tab') return;
          var list = Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), visible);
          if (!list.length) return;
          var first = list[0];
          var last = list[list.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        return { lock: lock, unlock: unlock, trap: trap, visible: visible };
      })();

    var kit = window.CsOverlayKit;

    /* イベント対象が Element でない場合（document 等）に落ちないようにする */
    function near(target, selector) {
      return target && target.closest ? target.closest(selector) : null;
    }

    function sameRoute(href, route) {
      if (!href) return false;
      var a = document.createElement('a');
      a.href = href;
      if (a.host !== window.location.host) return false;
      var p = a.pathname.replace(/\/$/, '');
      var q = String(route || '').replace(/\/$/, '');
      return p === q;
    }

    function count(cart) {
      return cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    }

    /* ヘッダー側のカート数バッジを、ヘッダーのコードを触らずに追随させる。
       対象が無いときは何もしない（他班のマークアップ変更に依存しない）。
       ★ リンク先がカートのものだけに限る。クラス名だけで拾うと検索・アカウントの
         アイコンにまで数字が付く（2026-08-27 のフィクスチャ検証で実際に発生）。 */
    function syncHeaderBadge(n, cartUrl) {
      try {
        var links = document.querySelectorAll('a.concept-header__iconlink[href]');
        Array.prototype.forEach.call(links, function (link) {
          if (!sameRoute(link.getAttribute('href'), cartUrl)) return;
          var badge = link.querySelector('.concept-header__count');
          if (n > 0 && !badge) {
            badge = document.createElement('span');
            badge.className = 'concept-header__count';
            link.appendChild(badge);
          }
          if (!badge) return;
          if (n > 0) {
            badge.textContent = String(n);
            badge.hidden = false;
          } else {
            badge.hidden = true;
          }
        });
      } catch (e) {
        /* バッジ同期は装飾。失敗しても購買動線には影響させない */
      }
    }

    class CsCartDrawer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.panel = this.querySelector('[data-cd-panel]');
        this.opener = null;
        this.onKeydown = this.onKeydown.bind(this);

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        installGlobal(this);
      }

      get sectionId() {
        return this.dataset.sectionId || '';
      }

      onClick(event) {
        var close = near(event.target, '[data-cd-close], [data-cd-scrim]');
        if (close) {
          event.preventDefault();
          this.close();
          return;
        }

        var step = near(event.target, '[data-cd-qty]');
        if (step) {
          event.preventDefault();
          this.change(step.getAttribute('data-cd-line'), step.getAttribute('data-cd-to'));
          return;
        }

        var remove = near(event.target, '[data-cd-remove]');
        if (remove) {
          event.preventDefault();
          this.change(remove.getAttribute('data-cd-line'), 0);
        }
      }

      onChange(event) {
        var input = near(event.target, '[data-cd-input]');
        if (!input) return;
        var next = parseInt(input.value, 10);
        if (isNaN(next) || next < 0) next = 0;
        this.change(input.getAttribute('data-cd-line'), next);
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.stopPropagation();
          this.close();
          return;
        }
        kit.trap(this.panel || this, event);
      }

      open(opener) {
        /* 開くたびに最新のカートへ同期する。フォーム送信の傍受を通らない追加
           （別タブ・JS API・PDPの素のPOST後の戻り等）があると、初期描画のまま
           「カートは空です」を見せてしまう（2026-08-28 実機で確認）。 */
        this.refresh().catch(function () { /* 失敗時は現状表示のまま */ });
        if (this.classList.contains('is-open')) return;
        this.opener = opener || document.activeElement;
        this.classList.add('is-open');
        kit.lock();
        document.addEventListener('keydown', this.onKeydown);
        var self = this;
        window.requestAnimationFrame(function () {
          var target = self.querySelector('[data-cd-close]');
          if (target) target.focus();
        });
        window.dispatchEvent(new CustomEvent('concept:overlay-open', { detail: { id: 'cart' } }));
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        kit.unlock();
        document.removeEventListener('keydown', this.onKeydown);
        if (this.opener && document.contains(this.opener) && kit.visible(this.opener)) {
          this.opener.focus();
        }
        this.opener = null;
      }

      busy(on) {
        this.classList.toggle('is-busy', !!on);
      }

      /* セクションレンダリングAPIで中身だけ差し替える。開閉状態は保持される。 */
      refresh() {
        var self = this;
        var url =
          window.location.pathname +
          '?sections=' +
          encodeURIComponent(this.sectionId) +
          '&_=' +
          Date.now();
        return fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok) throw new Error('sections ' + res.status);
            return res.json();
          })
          .then(function (data) {
            var html = data[self.sectionId];
            if (typeof html !== 'string') throw new Error('section missing');
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-cd-inner]');
            var here = self.querySelector('[data-cd-inner]');
            if (!next || !here) throw new Error('marker missing');
            here.innerHTML = next.innerHTML;
          });
      }

      change(line, quantity) {
        if (!line) return;
        var self = this;
        this.busy(true);
        fetch(this.dataset.cartChangeUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('change ' + res.status);
            return res.json();
          })
          .then(function (cart) {
            return self.refresh().then(function () {
              self.announce(cart);
            });
          })
          .catch(function () {
            window.location.href = self.dataset.cartUrl;
          })
          .then(function () {
            self.busy(false);
          });
      }

      announce(cart) {
        var n = count(cart);
        syncHeaderBadge(n, this.dataset.cartUrl);
        window.dispatchEvent(
          new CustomEvent('concept:cart-updated', { detail: { count: n, cart: cart } })
        );
      }

      add(form) {
        var self = this;
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.setAttribute('aria-busy', 'true');

        fetch(this.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add ' + res.status);
            return res.json();
          })
          .then(function () {
            return fetch(self.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            return self.refresh().then(function () {
              self.announce(cart);
              if (self.dataset.openOnAdd !== 'false') self.open(submit);
            });
          })
          .catch(function () {
            form.submit();
          })
          .then(function () {
            if (submit) submit.removeAttribute('aria-busy');
          });
      }
    }

    /* --- document 委譲（ヘッダー等のマークアップは一切変更しない） ----------- */
    var installed = false;

    function installGlobal(drawer) {
      if (installed) return;
      installed = true;

      document.addEventListener(
        'submit',
        function (event) {
          var form = near(event.target, 'form[action*="/cart/add"]');
          if (!form || form.hasAttribute('data-cd-skip')) return;
          if (event.defaultPrevented) return;
          event.preventDefault();
          drawer.add(form);
        },
        false
      );

      document.addEventListener('click', function (event) {
        var link = near(event.target, 'a[href]');
        if (!link || event.defaultPrevented) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        if (link.target && link.target !== '_self') return;
        if (!sameRoute(link.getAttribute('href'), drawer.dataset.cartUrl)) return;
        event.preventDefault();
        drawer.open(link);
      });

      window.addEventListener('concept:cart-open', function (event) {
        drawer.open(event.detail && event.detail.opener);
      });

      /* 別のオーバーレイが開いたら自分は畳む（同時に2枚出さない） */
      window.addEventListener('concept:overlay-open', function (event) {
        if (!event.detail || event.detail.id === 'cart') return;
        drawer.close();
      });
    }

    if (!window.customElements.get('cs-cart-drawer')) {
      window.customElements.define('cs-cart-drawer', CsCartDrawer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-collection-tabs"] && !Shopify.designMode) return;
  try {
    
  /**
   * <ctb-tabs> — 「リンク列」を「タブ」に格上げするだけの薄い要素。
   *
   * 来る前（＝JS 無し）の状態:
   *   ・タブは素の <a href="コレクションURL">。押せばそのコレクションへ移動する。
   *   ・最初のパネルだけが CSS で表示されている。
   *   ・前/次の丸ボタンは :defined 待ちで隠れている。
   * 来た後にやること:
   *   1. role="tablist" / "tab" / "tabpanel" と aria-* を後付けする
   *      （no-JS 環境に「タブだと名乗るのに切り替わらない」嘘を残さないため、
   *        マークアップ側には一切書かない）
   *   2. クリックを横取りしてパネルを差し替える（ページ遷移しない）
   *   3. ← → Home End のローピングタブ移動
   *   4. 前/次ボタンで表示中トラックを 0.9 画面ぶんスクロールし、端で disabled にする
   *
   * どこで失敗しても「リンク列＋最初のパネル」に落ちるだけで、内容は失われない。
   */
  (() => {
    'use strict';

    class CtbTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.tablist = this.querySelector('[data-ctb-tablist]');
        this.tabs = Array.from(this.querySelectorAll('[data-ctb-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-ctb-panel]'));

        // 対応が崩れているときは何もしない（＝リンク列のまま。壊れるより黙って退く）
        if (!this.tablist || this.tabs.length === 0 || this.tabs.length !== this.panels.length) {
          return;
        }

        this.dataset.ready = 'true';

        this.prevBtn = this.querySelector('[data-ctb-prev]');
        this.nextBtn = this.querySelector('[data-ctb-next]');

        let start = this.tabs.findIndex((t) => t.classList.contains('is-active'));
        if (start < 0) start = 0;
        this.index = start;

        this.sync = this.sync.bind(this);
        this.onKey = this.onKey.bind(this);

        this.tablist.setAttribute('role', 'tablist');

        this.tabs.forEach((tab, i) => {
          const panel = this.panels[i];
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);

          tab.addEventListener('click', (e) => {
            e.preventDefault();
            this.select(i, false);
          });
          tab.addEventListener('keydown', this.onKey);
        });

        this.panels.forEach((panel) => {
          const track = panel.querySelector('[data-ctb-track]');
          if (track) track.addEventListener('scroll', this.sync, { passive: true });
        });

        window.addEventListener('resize', this.sync, { passive: true });

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

        this.select(this.index, false, true);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.sync);
        this.dataset.ready = 'false';
      }

      get track() {
        const panel = this.panels[this.index];
        return panel ? panel.querySelector('[data-ctb-track]') : null;
      }

      /** RTL では「次」が物理的に左向きになる */
      get sign() {
        return getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      }

      select(i, moveFocus, initial) {
        if (i < 0 || i >= this.tabs.length) return;
        this.index = i;

        this.tabs.forEach((tab, n) => {
          const on = n === i;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          // ローピングタブ移動: タブ列全体で Tab キーの止まり先はひとつだけ
          tab.tabIndex = on ? 0 : -1;
        });

        this.panels.forEach((panel, n) => {
          panel.classList.toggle('is-active', n === i);
        });

        if (moveFocus) this.tabs[i].focus();

        // 表示直後は幅がまだ 0 のことがあるので、次フレームでも測り直す
        this.sync();
        if (!initial) requestAnimationFrame(this.sync);
      }

      onKey(e) {
        let next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = this.index + 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = this.index - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;

        e.preventDefault();
        const last = this.tabs.length - 1;
        if (next < 0) next = last;
        if (next > last) next = 0;
        this.select(next, true);
      }

      step(dir) {
        const track = this.track;
        if (!track) return;
        track.scrollBy({ left: track.clientWidth * 0.9 * dir * this.sign, behavior: 'smooth' });
      }

      sync() {
        const track = this.track;
        // 端の判定は絶対値で行う（RTL で scrollLeft が負になる実装があるため）
        const x = track ? Math.abs(track.scrollLeft) : 0;
        const max = track ? track.scrollWidth - track.clientWidth : 0;
        const atStart = !track || x <= 2;
        const atEnd = !track || x >= max - 2;

        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;
      }
    }

    if (!customElements.get('ctb-tabs')) customElements.define('ctb-tabs', CtbTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-comparison-table"] && !Shopify.designMode) return;
  try {
    
  /**
   * cct-table — 商品比較表の「固定帯」と「横スクロール」の面倒を見る。
   *
   * やることは3つだけ。
   *   1. 見出し行がヘッダーの下へ隠れたら固定帯を出す（is-stuck）
   *   2. 横スクロール量を --cct-sx に流し、帯の列位置を表と一致させる
   *   3. 実際に横へ溢れているときだけスクロール領域をフォーカス可能にする
   *      （WCAG 2.1.1。溢れていないのに Tab 順を1つ増やさない）
   *
   * 帯の中身は表の見出し行の複製（aria-hidden）なので、この JS が届かなくても
   * 情報は1つも失われない。
   */
  (function () {
    'use strict';

    class CctTable extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.scroller = this.querySelector('[data-cct-scroll]');
        this.bar = this.querySelector('[data-cct-bar]');
        this.clip = this.bar ? this.bar.parentElement : null;
        // 行 <tr> は display:contents で箱を持たないため、位置は見出しセルで測る
        this.headCell = this.querySelector('[data-cct-headcell]');
        if (!this.scroller) return;

        this.dataset.ready = 'true';
        this.frame = null;

        this.onScrollX = this.onScrollX.bind(this);
        this.sync = this.sync.bind(this);
        this.schedule = this.schedule.bind(this);

        this.scroller.addEventListener('scroll', this.onScrollX, { passive: true });
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule, { passive: true });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.schedule);
          this.ro.observe(this);
        }

        this.onScrollX();
        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.schedule);
        window.removeEventListener('resize', this.schedule);
        if (this.scroller) this.scroller.removeEventListener('scroll', this.onScrollX);
        if (this.ro) {
          this.ro.disconnect();
          this.ro = null;
        }
        if (this.frame !== null) {
          cancelAnimationFrame(this.frame);
          this.frame = null;
        }
        this.dataset.ready = 'false';
      }

      schedule() {
        if (this.frame === null) this.frame = requestAnimationFrame(this.sync);
      }

      /** 横スクロール: 端の状態 + 帯の列合わせ */
      onScrollX() {
        var max = this.scroller.scrollWidth - this.scroller.clientWidth;
        // RTL では scrollLeft が負になるブラウザがあるので絶対値で持ち、
        // 向きは CSS 側の --cs-logical に任せる。
        var x = Math.abs(this.scroller.scrollLeft);

        this.classList.toggle('is-start', x > 2);
        this.classList.toggle('is-end', x < max - 2);
        if (this.bar) this.bar.style.setProperty('--cct-sx', Math.round(x) + 'px');
      }

      sync() {
        this.frame = null;
        if (!this.scroller) return;

        // 溢れているときだけフォーカス可能にする
        var scrollable = this.scroller.scrollWidth - this.scroller.clientWidth > 2;
        if (scrollable) {
          if (this.scroller.getAttribute('tabindex') !== '0') {
            this.scroller.setAttribute('tabindex', '0');
            this.scroller.setAttribute('role', 'region');
            this.scroller.setAttribute('aria-label', '商品比較表（横にスクロールできます）');
          }
        } else if (this.scroller.hasAttribute('tabindex')) {
          this.scroller.removeAttribute('tabindex');
          this.scroller.removeAttribute('role');
          this.scroller.removeAttribute('aria-label');
        }

        this.onScrollX();

        if (!this.bar || !this.clip || !this.headCell) return;

        // 刈り込み枠をスクロール領域の見えている幅（縦スクロールバーを除く）に合わせる。
        // 帯本体は CSS の width:100% でこの幅を継ぐので、表と同じ列幅が解ける。
        this.clip.style.width = this.scroller.clientWidth + 'px';

        var headerH =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--cs-header-h')
          ) || 0;
        var head = this.headCell.getBoundingClientRect();
        var frame = this.getBoundingClientRect();
        var barH = this.clip.offsetHeight || 0;

        // 見出し行が隠れ、かつ表がまだ十分に画面へ残っている間だけ出す
        var on = head.bottom <= headerH && frame.bottom > headerH + barH + 24;
        this.classList.toggle('is-stuck', on);
      }
    }

    if (!customElements.get('cct-table')) customElements.define('cct-table', CctTable);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-featured-product"] && !Shopify.designMode) return;
  try {
    
  /**
   * ギャラリーの上乗せ。前提ではない:
   *   サムネイルは #フラグメントのアンカーなので、この JS が動かなくても
   *   ブラウザがスライドをスクロールイン表示する。JS が動くときは preventDefault して
   *   ページ縦位置を動かさず、横（レール側は縦）だけ動かす。
   * 追加でやること:
   *   - スウォッチを選んだらそのバリアントの画像へメインを差し替える
   *   - 「Color: ◯◯」の現在値ラベルを更新する
   *   - サムネイルのレールを1枚ぶん送るシェブロンを有効化する（それまでは CSS で非表示）
   */
  (function () {
    if (customElements.get('cfp-gallery')) return;

    class CfpGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.track = this.querySelector('[data-cfp-track]');
        if (!this.track) return;

        this.root = this.closest('.cfp');
        this.rail = this.querySelector('[data-cfp-rail]');
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-cfp-thumb]'));

        this.onScroll = this.onScroll.bind(this);
        this.sync = this.sync.bind(this);

        this.thumbs.forEach(
          function (thumb, i) {
            thumb.addEventListener('click', this.goTo.bind(this, i));
          }.bind(this)
        );

        const next = this.querySelector('[data-cfp-rail-next]');
        if (next && this.rail) {
          next.addEventListener(
            'click',
            function () {
              const first = this.rail.querySelector('.cfp__thumbs-item');
              const step = first ? first.getBoundingClientRect().height + 16 : 128;
              const atEnd = this.rail.scrollTop + this.rail.clientHeight >= this.rail.scrollHeight - 2;
              if (atEnd) this.rail.scrollTo({ top: 0 });
              else this.rail.scrollBy({ top: step });
            }.bind(this)
          );
        }

        // スウォッチ（1オプション商品のみ。2つ以上は商品ページへ送っているので存在しない）
        this.label = this.parentElement ? null : null;
        if (this.root) {
          this.label = this.root.querySelector('[data-cfp-optvalue]');
          const swatches = Array.prototype.slice.call(this.root.querySelectorAll('[data-cfp-swatch]'));
          swatches.forEach(
            function (input) {
              input.addEventListener(
                'change',
                function () {
                  if (this.label && input.dataset.cfpValue) this.label.textContent = input.dataset.cfpValue;
                  const id = input.dataset.cfpMediaId;
                  if (!id) return;
                  const index = this.slides.findIndex(function (slide) {
                    return slide.dataset.cfpMediaId === id;
                  });
                  if (index >= 0) this.goTo(index);
                }.bind(this)
              );
            }.bind(this)
          );
        }

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.sync, { passive: true });

        if (this.root && this.thumbs.length) this.root.setAttribute('data-cfp-ready', '');
        this.sync();
      }

      get slides() {
        return Array.prototype.slice.call(this.track.children);
      }

      goTo(i, event) {
        const slide = this.slides[i];
        if (!slide) return;
        if (event) event.preventDefault();
        // behavior は渡さない（= CSS の scroll-behavior に従う）。
        // concept.css が reduced-motion のとき .cs-slider を scroll-behavior: auto に
        // 落としているので、動きの可否は CSS 側の 1 箇所だけが決める。
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft });
      }

      onScroll() {
        // 「保留中なら捨てて取り直す」。`if (this.frame) return;` にすると、
        // rAF が発火しない状況（背面タブ等）で ID が残り、以後の同期が永久に止まる。
        if (this.frame) window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(this.sync);
      }

      sync() {
        const origin = this.track.offsetLeft;
        const mid = this.track.scrollLeft + this.track.clientWidth / 2;
        let active = 0;
        this.slides.forEach(function (slide, i) {
          if (slide.offsetLeft - origin <= mid) active = i;
        });
        this.thumbs.forEach(function (thumb, i) {
          if (i === active) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('cfp-gallery', CfpGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-footer-bottom"] && !Shopify.designMode) return;
  try {
    
  /**
   * .site-footer が実際に position:fixed のときだけ、この行も一緒に画面下へ固定する。
   * 同時に自分の高さを --concept-fb-h として配り、フッター本体に下パディングを予約させる。
   * （Concept 以外のプリセット / 767px 以下 / JS 無しでは通常フローのまま）
   */
  (function () {
    var root = document.documentElement;
    var frame = 0;

    function apply() {
      frame = 0;
      var bars = document.querySelectorAll('.concept-footer-bottom');
      if (!bars.length) return;

      var footer = document.querySelector('.site-footer');
      var pinned = false;
      if (footer && window.getComputedStyle) {
        pinned = window.getComputedStyle(footer).position === 'fixed';
      }

      for (var i = 0; i < bars.length; i++) {
        bars[i].classList.toggle('is-pinned', pinned);
      }

      if (pinned) {
        var h = Math.round(bars[bars.length - 1].offsetHeight);
        if (root.style.getPropertyValue('--concept-fb-h') !== h + 'px') {
          root.style.setProperty('--concept-fb-h', h + 'px');
        }
      } else {
        root.style.removeProperty('--concept-fb-h');
      }
    }

    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame ? window.requestAnimationFrame(apply) : setTimeout(apply, 16);
    }

    function boot() {
      apply();
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('load', schedule);
      document.addEventListener('shopify:section:load', schedule);
      if ('ResizeObserver' in window) {
        var bars = document.querySelectorAll('.concept-footer-bottom');
        var ro = new ResizeObserver(schedule);
        for (var i = 0; i < bars.length; i++) ro.observe(bars[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-footer"] && !Shopify.designMode) return;
  try {
    
  /**
   * 〜767px だけ <details> をアコーディオンに戻す。
   * マークアップは open で出しているので、この JS が動かなくても全リンクは読める。
   */
  (function () {
    var DESKTOP = window.matchMedia('(min-width: 768px)');

    function sync() {
      var menus = document.querySelectorAll('.concept-footer__menu');
      for (var i = 0; i < menus.length; i++) {
        if (DESKTOP.matches) {
          menus[i].setAttribute('open', '');
        } else {
          menus[i].removeAttribute('open');
        }
      }
    }

    function boot() {
      sync();
      if (DESKTOP.addEventListener) {
        DESKTOP.addEventListener('change', sync);
      } else if (DESKTOP.addListener) {
        DESKTOP.addListener(sync);
      }
      document.addEventListener('shopify:section:load', sync);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-header"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * concept-header の JS は「開閉の補助」だけ。
   * スクロール監視（.is-scrolled / .is-hidden / --cs-header-h）は共有の
   * <cs-header>（assets/concept.js）が担当するので、ここには一切書かない。
   *
   * ここで足すもの:
   *   1. マウス（pointer:fine）かつ 1024px 以上のときだけ hover でドロップダウン／
   *      メガメニューを開く。開閉とも 150ms の意図判定を挟む（通り過ぎで開かない）
   *   2. Esc で開いている <details> を閉じ、フォーカスを summary に戻す
   *   3. ヘッダーの外をクリック / フォーカスが外へ抜けたら閉じる
   *   4. 兄弟のドロップダウンは同時に開かない（アコーディオン）
   *   5. 開いている <details> の中では Tab が循環する（外へはEscで出る）
   *   6. メガのタブを hover でも切り替える（既定はラジオの :checked ＝ JS 不要）
   *   7. window の 'concept:menu-open' でモバイルドロワーを開く口を出す
   * JS が無くても <details> はクリックで開き、タブはラジオで切り替わるので、
   * 全リンク・全タブに到達できる。
   * ------------------------------------------------------------------------ */
  (function () {
    var HOVER_DELAY = 150;
    var FOCUSABLE =
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),' +
      'textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';

    function closeAll(header, except) {
      var open = header.querySelectorAll('details[open]');
      Array.prototype.forEach.call(open, function (d) {
        if (except && (d === except || d.contains(except) || except.contains(d))) return;
        d.open = false;
      });
    }

    function visibleFocusable(root) {
      return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
        // offsetParent は position:fixed で null になるが、ヘッダー内には無い。
        // visually-hidden のラジオは幅1pxで残るので、意図どおり Tab 対象に含める。
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
      });
    }

    function init(header) {
      if (header.dataset.chReady === 'true') return;
      header.dataset.chReady = 'true';

      var fine = window.matchMedia('(pointer: fine)');
      var wide = window.matchMedia('(min-width: 1024px)');

      Array.prototype.forEach.call(header.querySelectorAll('[data-ch-dropdown]'), function (d) {
        var item = d.parentElement;
        if (!item) return;
        var timer = null;

        function schedule(next) {
          if (!fine.matches || !wide.matches) return;
          window.clearTimeout(timer);
          timer = window.setTimeout(function () {
            d.open = next;
          }, HOVER_DELAY);
        }

        item.addEventListener('mouseenter', function () {
          schedule(true);
        });
        item.addEventListener('mouseleave', function () {
          schedule(false);
        });

        // メガのパネルは li のボックスの外（全幅・絶対配置）にあるので、
        // li の mouseleave だけだとパネルへ入った瞬間に閉じてしまう。
        // パネル自身にも開閉の口を付けて打ち消す。
        var panel = d.querySelector('[data-ch-mega], .concept-header__dropdown');
        if (panel) {
          panel.addEventListener('mouseenter', function () {
            schedule(true);
          });
          panel.addEventListener('mouseleave', function () {
            schedule(false);
          });
        }
      });

      // メガのタブ: hover でも切り替える（クリック／キーボードはラジオが担当）
      Array.prototype.forEach.call(header.querySelectorAll('[data-ch-tablabel]'), function (label) {
        label.addEventListener('mouseenter', function () {
          if (!fine.matches || !wide.matches) return;
          var input = document.getElementById(label.getAttribute('for'));
          if (input && !input.checked) input.checked = true;
        });
      });

      // toggle はバブルしないのでキャプチャで拾う
      header.addEventListener(
        'toggle',
        function (event) {
          var d = event.target;
          if (d.open) closeAll(header, d);
        },
        true
      );

      header.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          var open = header.querySelectorAll('details[open]');
          if (!open.length) return;
          var last = open[open.length - 1];
          var summary = last.querySelector('summary');
          closeAll(header);
          if (summary) summary.focus();
          return;
        }

        if (event.key !== 'Tab') return;

        // 開いているパネルの中にフォーカスがあるときだけ循環させる。
        // hover で開いただけ（フォーカスは別の場所）のときは何もしない＝
        // マウス利用者のタブ順を邪魔しない。出口は必ず Esc。
        var host = event.target.closest ? event.target.closest('details[open]') : null;
        if (!host || !header.contains(host)) return;

        var items = visibleFocusable(host);
        if (items.length < 2) return;
        var first = items[0];
        var last2 = items[items.length - 1];

        if (event.shiftKey && event.target === first) {
          event.preventDefault();
          last2.focus();
        } else if (!event.shiftKey && event.target === last2) {
          event.preventDefault();
          first.focus();
        }
      });

      header.addEventListener('focusout', function (event) {
        if (event.relatedTarget && header.contains(event.relatedTarget)) return;
        closeAll(header);
      });

      document.addEventListener('click', function (event) {
        if (header.contains(event.target)) return;
        closeAll(header);
      });

      // 並列班のドロワーからモバイルメニューを開くための口。
      // 検索/カートのドロワーと同じイベント名で揃えてある。
      window.addEventListener('concept:menu-open', function (event) {
        var drawer = header.querySelector('[data-ch-drawer]');
        if (!drawer || drawer.open) return;
        var opener = event && event.detail ? event.detail.opener : null;
        drawer.open = true;
        var summary = drawer.querySelector('summary');
        if (summary) summary.focus();
        if (!opener || typeof opener.focus !== 'function') return;
        // 閉じたら呼び出し元（モバイルドックのボタン）へフォーカスを返す
        drawer.addEventListener(
          'toggle',
          function back() {
            if (drawer.open) return;
            drawer.removeEventListener('toggle', back);
            opener.focus();
          },
          false
        );
      });
    }

    function boot() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ch-root]'), init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  /**
   * <clm-marquee data-speed="35"> … px/秒 を秒数に翻訳するだけの薄い要素。
   *  - 1セット分の実幅 ÷ 速度 = 1周の秒数 を --cs-marquee-dur に書く
   *  - ResizeObserver で幅の変化に追随（ロゴ高が段で変わるため）
   *  - Web フォント確定後に測り直す（テキストロゴの幅がずれるため）
   *  - 測れないときはプロパティを消して CSS 既定値(26s)に戻す
   * ここが動かなくても帯は既定速度で流れ続ける（内容は1つも欠けない）。
   */
  (() => {
    'use strict';

    class ClmMarquee extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.track = this.querySelector('[data-clm-track]');
        if (!this.track) return;

        this.dataset.ready = 'true';
        this.measure = this.measure.bind(this);

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.measure);
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', this.measure, { passive: true });
        }

        this.measure();

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.measure).catch(() => {});
        }
      }

      disconnectedCallback() {
        if (this.ro) {
          this.ro.disconnect();
          this.ro = null;
        }
        window.removeEventListener('resize', this.measure);
        this.dataset.ready = 'false';
      }

      measure() {
        // offsetWidth はレイアウト幅。親の rotate / translate の影響を受けない。
        const width = this.track ? this.track.offsetWidth : 0;
        const speed = parseFloat(this.dataset.speed);

        if (!(width > 0) || !(speed > 0)) {
          this.style.removeProperty('--cs-marquee-dur');
          return;
        }

        this.style.setProperty('--cs-marquee-dur', (width / speed).toFixed(3) + 's');
      }
    }

    if (!customElements.get('clm-marquee')) customElements.define('clm-marquee', ClmMarquee);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-lookbook-slider"] && !Shopify.designMode) return;
  try {
    
  /**
   * ホットスポット ⇄ 商品カード ⇄ ドットの同期。
   * これは「上乗せ」であって前提ではない:
   *   - ホットスポットは素の <a>（商品ページへのリンク）なので、JS が落ちても機能する。
   *   - 右パネルは最初のカードだけが `hidden` 無しで出ているので、JS 無しでも読める。
   *   - ドットは data-cls-ready が付くまで CSS で非表示（死んだ操作子を出さない）。
   */
  (function () {
    if (customElements.get('cls-lookbook')) return;

    class ClsLookbook extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.root = this.closest('.cls');
        this.hits = Array.prototype.slice.call(this.querySelectorAll('[data-cls-hit]'));
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-cls-card]'));
        this.figures = Array.prototype.slice.call(this.querySelectorAll('[data-cls-figure]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-cls-dot]'));

        if (!this.hits.length || !this.cards.length) return;

        this.index = 0;

        this.hits.forEach(
          function (hit, i) {
            hit.addEventListener(
              'click',
              function (event) {
                event.preventDefault();
                this.select(i, true);
              }.bind(this)
            );
            hit.addEventListener(
              'focus',
              function () {
                this.select(i, false);
              }.bind(this)
            );
          }.bind(this)
        );

        this.dots.forEach(
          function (dot, i) {
            dot.addEventListener(
              'click',
              function () {
                this.select(i, true);
              }.bind(this)
            );
          }.bind(this)
        );

        this.onKey = this.onKey.bind(this);
        this.addEventListener('keydown', this.onKey);

        if (this.root) this.root.setAttribute('data-cls-ready', '');
        this.select(0, false);
      }

      onKey(event) {
        if (event.key !== 'Escape') return;
        this.closeTips();
      }

      closeTips() {
        this.hits.forEach(function (hit) {
          const tip = hit.parentElement && hit.parentElement.querySelector('[data-cls-tip]');
          if (tip) tip.classList.remove('is-open');
        });
      }

      select(index, openTip) {
        if (index < 0 || index >= this.hits.length) return;
        this.index = index;

        // どのスライド（画像）に属する点かを見て、その1枚だけを出す。
        const figureIndex = this.hits[index].getAttribute('data-cls-figure-index');
        this.figures.forEach(function (fig) {
          const same = fig.getAttribute('data-cls-figure') === figureIndex;
          if (same) fig.removeAttribute('hidden');
          else fig.setAttribute('hidden', '');
        });

        this.cards.forEach(function (card, i) {
          if (i === index) card.removeAttribute('hidden');
          else card.setAttribute('hidden', '');
        });

        this.hits.forEach(function (hit, i) {
          if (i === index) hit.setAttribute('aria-current', 'true');
          else hit.removeAttribute('aria-current');
        });

        this.dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });

        this.closeTips();
        if (openTip) {
          const hit = this.hits[index];
          const tip = hit.parentElement && hit.parentElement.querySelector('[data-cls-tip]');
          if (tip) tip.classList.add('is-open');
        }
      }
    }

    customElements.define('cls-lookbook', ClsLookbook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-main-collection"]) return;
  try {
    
  /**
   * 絞り込みドロワーとソートの「あると気持ちいい」部分だけ。
   * ここが 1 行も動かなくても、<details> の素の開閉と GET フォームで操作は完結する。
   */
  (function () {
    'use strict';

    var lockCount = 0;

    function lock() {
      lockCount += 1;
      if (lockCount === 1) document.documentElement.style.overflow = 'hidden';
    }

    function unlock() {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) document.documentElement.style.overflow = '';
    }

    function wire(details) {
      if (details.dataset.cmcReady === 'true') return;
      details.dataset.cmcReady = 'true';

      var scrim = details.querySelector('.cmc__scrim');
      var summary = details.querySelector('.cmc__filter');

      if (scrim) {
        scrim.addEventListener('click', function () {
          details.open = false;
        });
      }

      details.addEventListener('toggle', function () {
        if (details.open) {
          lock();
          if (summary) summary.setAttribute('aria-label', '絞り込みを閉じる');
        } else {
          unlock();
          if (summary) summary.removeAttribute('aria-label');
        }
      });
    }

    function onKey(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.cmc__facets[open]').forEach(function (d) {
        d.open = false;
      });
    }

    function init() {
      document.querySelectorAll('.cmc__facets').forEach(wire);

      document.querySelectorAll('form[data-cmc-sort]').forEach(function (form) {
        if (form.dataset.cmcReady === 'true') return;
        form.dataset.cmcReady = 'true';
        var select = form.querySelector('select');
        if (!select) return;
        select.addEventListener('change', function () {
          form.submit();
        });
      });

      document.addEventListener('keydown', onKey);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-main-product"]) return;
  try {
    
  /**
   * ギャラリーとバリアントの「上乗せ」。どちらも無くても動線は完結する:
   *   サムネイル … #フラグメントのアンカー（ブラウザがスクロールする）
   *   もっと見る … 6枚目のサムネへのアンカー
   *   バリアント … 素のラジオ（name="id"）／2オプション以上は variant.url リンク
   * ここでやるのは「ページ縦位置を動かさない」「aria-current を合わせる」
   * 「選んだ値に応じて価格ラベルと主画像を差し替える」だけ。
   */
  (function () {
    if (!customElements.get('cmp-gallery')) {
      class CmpGallery extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.track = this.querySelector('[data-cmp-track]');
          if (!this.track) return;

          this.rail = this.querySelector('[data-cmp-rail]');
          this.more = this.querySelector('[data-cmp-more]');
          this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-cmp-thumb]'));

          this.sync = this.sync.bind(this);
          this.onScroll = this.onScroll.bind(this);

          this.thumbs.forEach(
            function (thumb, i) {
              thumb.addEventListener('click', this.goTo.bind(this, i));
            }.bind(this)
          );

          this.syncMore = this.syncMore.bind(this);
          if (this.more && this.rail) {
            this.more.addEventListener('click', this.pageRail.bind(this));
            this.rail.addEventListener('scroll', this.syncMore, { passive: true });
            this.syncMore();
          }

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          // 幅が変わるとレールが縦↔横に切り替わるので、送り先の残量も測り直す
          window.addEventListener(
            'resize',
            function () {
              this.sync();
              this.syncMore();
            }.bind(this),
            { passive: true }
          );
          this.sync();
        }

        get slides() {
          return Array.prototype.slice.call(this.track.children);
        }

        // 外から（バリアント選択などから）呼べるようにしておく。
        // connectedCallback が早期 return した個体でも落とさないよう track を先に見る。
        goTo(i, event) {
          if (!this.track) return;
          var slide = this.slides[i];
          if (!slide) return;
          if (event) event.preventDefault();
          // behavior は渡さない（= CSS の scroll-behavior に従う）。
          // reduced-motion のときは concept.css が .cs-slider を auto に落としている。
          this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft });
        }

        pageRail(event) {
          if (event) event.preventDefault();
          var vertical = this.rail.scrollHeight > this.rail.clientHeight + 1;
          if (vertical) this.rail.scrollBy({ top: this.rail.clientHeight });
          else this.rail.scrollBy({ left: this.rail.clientWidth });
        }

        // 末尾まで送ったらボタンを畳む（押しても何も起きないボタンを残さない）。
        // レールは 1024px 未満で横、以上で縦になるので両軸の残量を見る。
        syncMore() {
          if (!this.more || !this.rail) return;
          var roomY = this.rail.scrollHeight - this.rail.clientHeight - this.rail.scrollTop;
          var roomX = this.rail.scrollWidth - this.rail.clientWidth - this.rail.scrollLeft;
          this.more.hidden = Math.max(roomY, roomX) <= 2;
        }

        onScroll() {
          // 「保留中なら捨てて取り直す」。`if (this.frame) return;` にすると
          // rAF が発火しない状況（背面タブ等）で ID が残り、以後の同期が永久に止まる。
          if (this.frame) window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(this.sync);
        }

        sync() {
          if (!this.thumbs.length) return;
          var origin = this.track.offsetLeft;
          var mid = this.track.scrollLeft + this.track.clientWidth / 2;
          var active = 0;
          this.slides.forEach(function (slide, i) {
            if (slide.offsetLeft - origin <= mid) active = i;
          });
          this.thumbs.forEach(function (thumb, i) {
            if (i === active) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
        }
      }

      customElements.define('cmp-gallery', CmpGallery);
    }

    if (!customElements.get('cmp-variants')) {
      class CmpVariants extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          this.radios = Array.prototype.slice.call(
            this.querySelectorAll('input.cmp__swatch-input[type="radio"]')
          );
          if (!this.radios.length) return;

          this.priceEls = Array.prototype.slice.call(this.querySelectorAll('[data-cmp-price]'));
          this.atcPrice = this.querySelector('[data-cmp-atc-price]');
          this.optValue = this.querySelector('[data-cmp-optvalue]');

          var onChange = this.onChange.bind(this);
          this.radios.forEach(function (radio) {
            radio.addEventListener('change', onChange);
          });
        }

        onChange(event) {
          var radio = event.currentTarget;
          var price = radio.getAttribute('data-price');
          var name = radio.getAttribute('data-value');
          var media = parseInt(radio.getAttribute('data-media') || '0', 10);

          if (price) {
            if (this.atcPrice) this.atcPrice.textContent = price;
            this.priceEls.forEach(function (el) {
              el.textContent = price;
            });
          }
          if (name && this.optValue) this.optValue.textContent = name;

          // 主画像をそのバリアントの画像へ送る（position は 1 始まり）。
          // 同じセクションの中だけを探す（1ページに複数置かれても取り違えない）。
          var scope = this.closest('.cmp');
          var gallery = scope ? scope.querySelector('cmp-gallery') : null;
          if (media > 0 && gallery && typeof gallery.goTo === 'function') {
            gallery.goTo(media - 1);
          }

          // 共有・リロードで同じバリアントに戻れるよう URL だけ更新する（履歴は積まない）
          if (window.history && window.history.replaceState && radio.value) {
            try {
              var url = new URL(window.location.href);
              url.searchParams.set('variant', radio.value);
              window.history.replaceState({}, '', url.toString());
            } catch (e) {
              /* URL が作れない環境では何もしない（表示は既に更新済み） */
            }
          }
        }
      }

      customElements.define('cmp-variants', CmpVariants);
    }
  })();

  /* --- 最近見た商品の履歴（書き込み側） --------------------------------------
   * concept-recently-viewed.liquid（読み側）との契約:
   *   localStorage['concept:recently-viewed'] = '["handle-a","handle-b",...]'（新しい順・最大12）
   * localStorage は読めない環境があるので必ず try/catch（テーマ規約）。 */
  (function () {
    try {
      var el = document.querySelector('[data-cmp-handle]');
      var handle = el && el.getAttribute('data-cmp-handle');
      if (!handle) return;
      var KEY = 'concept:recently-viewed';
      var list = [];
      try { list = JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
      if (!Array.isArray(list)) list = [];
      list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) { /* 履歴は装飾。失敗しても購買動線に影響させない */ }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-main-search"]) return;
  try {
    
  /**
   * 検索ページの補助。1 行も動かなくても /search?q= の素の GET で結果は出る。
   */
  (function () {
    'use strict';

    var lockCount = 0;

    function lock() {
      lockCount += 1;
      if (lockCount === 1) document.documentElement.style.overflow = 'hidden';
    }

    function unlock() {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) document.documentElement.style.overflow = '';
    }

    function wire(details) {
      if (details.dataset.cmsReady === 'true') return;
      details.dataset.cmsReady = 'true';

      var scrim = details.querySelector('.cms__scrim');
      var summary = details.querySelector('.cms__filter');

      if (scrim) {
        scrim.addEventListener('click', function () {
          details.open = false;
        });
      }

      details.addEventListener('toggle', function () {
        if (details.open) {
          lock();
          if (summary) summary.setAttribute('aria-label', '絞り込みを閉じる');
        } else {
          unlock();
          if (summary) summary.removeAttribute('aria-label');
        }
      });
    }

    function onKey(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.cms__facets[open]').forEach(function (d) {
        d.open = false;
      });
    }

    function init() {
      document.querySelectorAll('.cms__facets').forEach(wire);

      document.querySelectorAll('form[data-cms-sort]').forEach(function (form) {
        if (form.dataset.cmsReady === 'true') return;
        form.dataset.cmsReady = 'true';
        var select = form.querySelector('select');
        if (!select) return;
        select.addEventListener('change', function () {
          form.submit();
        });
      });

      // 「クリア」は素のリンク（=/search へ移動）。JS があるときは入力欄をその場で空にする。
      document.querySelectorAll('[data-cms-clear]').forEach(function (link) {
        if (link.dataset.cmsReady === 'true') return;
        link.dataset.cmsReady = 'true';
        link.addEventListener('click', function (e) {
          var field = link.closest('.cms__field');
          var input = field && field.querySelector('input[type="search"]');
          if (!input) return;
          e.preventDefault();
          input.value = '';
          input.focus();
        });
      });

      document.addEventListener('keydown', onKey);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-mobile-dock"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * concept-mobile-dock
   *   ・カート/検索リンクはドロワー側の document 委譲がそのまま拾う（二重に書かない）
   *   ・メニューは concept:menu-open を投げるだけ。受け手が居なくても壊れない
   *   ・カート数は concept:cart-updated を購読して追随
   *   ・ページ最上部ではしまう（デモの挙動）。設定で無効化できる
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    class CsMobileDock extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.badge = this.querySelector('[data-dock-count]');
        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);

        var menu = this.querySelector('[data-dock-menu]');
        if (menu) {
          menu.addEventListener('click', function () {
            window.dispatchEvent(
              new CustomEvent('concept:menu-open', { detail: { opener: menu } })
            );
          });
        }

        var self = this;
        window.addEventListener('concept:cart-updated', function (event) {
          self.setCount(event.detail && event.detail.count);
        });

        if (this.dataset.hideAtTop === 'true') {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.sync();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }

      setCount(n) {
        if (!this.badge) return;
        var value = Number(n) || 0;
        this.badge.textContent = String(value);
        this.badge.hidden = value === 0;
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        var self = this;
        window.requestAnimationFrame(function () {
          self.sync();
          self.ticking = false;
        });
      }

      sync() {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        this.classList.toggle('is-tucked', y < 120);
      }
    }

    if (!window.customElements.get('cs-mobile-dock')) {
      window.customElements.define('cs-mobile-dock', CsMobileDock);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * concept-newsletter-popup
   *   ・初回訪問の N 秒後に開く。閉じたら localStorage に期限を書いて抑制する
   *   ・localStorage が例外を投げる環境（プライベートブラウズ等）でも落ちない。
   *     その場合はメモリ上のフラグに退避し「同一セッション内は出さない」に落ちる
   *   ・concept:newsletter-open で任意に開ける（ソーシャルレールの CTA から）
   *   ・テーマエディタ（Shopify.designMode）では抑制を無視して必ず出す
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    var FOCUSABLE =
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

    window.CsOverlayKit =
      window.CsOverlayKit ||
      (function () {
        var depth = 0;
        var prev = '';
        var gutter = !!(window.CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable'));

        function lock() {
          depth += 1;
          if (depth > 1) return;
          var root = document.documentElement;
          prev = root.style.overflow;
          if (!gutter) {
            var bar = window.innerWidth - root.clientWidth;
            if (bar > 0) document.body.style.paddingInlineEnd = bar + 'px';
          }
          root.style.overflow = 'hidden';
        }

        function unlock() {
          depth -= 1;
          if (depth > 0) return;
          depth = 0;
          document.documentElement.style.overflow = prev;
          document.body.style.paddingInlineEnd = '';
        }

        function visible(el) {
          return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        }

        function trap(root, event) {
          if (event.key !== 'Tab') return;
          var list = Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), visible);
          if (!list.length) return;
          var first = list[0];
          var last = list[list.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        return { lock: lock, unlock: unlock, trap: trap, visible: visible };
      })();

    var kit = window.CsOverlayKit;
    var memory = {};

    function readStamp(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
      }
    }

    function writeStamp(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {
        memory[key] = value;
      }
    }

    class CsNewsletterPopup extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.card = this.querySelector('[data-nl-card]');
        this.opener = null;
        this.onKeydown = this.onKeydown.bind(this);
        this.addEventListener('click', this.onClick.bind(this));

        var self = this;
        window.addEventListener('concept:newsletter-open', function (event) {
          self.open(event.detail && event.detail.opener);
        });
        window.addEventListener('concept:overlay-open', function (event) {
          if (!event.detail || event.detail.id === 'newsletter') return;
          self.close();
        });

        /* 送信が成功して戻ってきたときは、抑制済みでも結果を見せる */
        if (this.querySelector('[role="status"], [role="alert"]')) {
          this.open();
          return;
        }

        if (this.dataset.auto === 'false') return;
        if (!this.editing() && this.suppressed()) return;

        var delay = (parseFloat(this.dataset.delay) || 0) * 1000;
        window.setTimeout(function () {
          self.open();
        }, delay);
      }

      editing() {
        return !!(window.Shopify && window.Shopify.designMode);
      }

      suppressed() {
        var until = parseInt(readStamp(this.dataset.storageKey), 10);
        return !isNaN(until) && until > Date.now();
      }

      suppress() {
        var days = parseFloat(this.dataset.expiry);
        if (isNaN(days) || days <= 0) return;
        writeStamp(this.dataset.storageKey, String(Date.now() + days * 86400000));
      }

      onClick(event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (target.closest('[data-nl-close], [data-nl-scrim]')) {
          event.preventDefault();
          this.close(true);
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.stopPropagation();
          this.close(true);
          return;
        }
        kit.trap(this.card || this, event);
      }

      open(opener) {
        if (this.classList.contains('is-open')) return;
        this.opener = opener || null;
        this.classList.add('is-open');
        kit.lock();
        document.addEventListener('keydown', this.onKeydown);
        var self = this;
        window.requestAnimationFrame(function () {
          var target = self.querySelector('[data-nl-close]');
          if (target) target.focus();
        });
        window.dispatchEvent(
          new CustomEvent('concept:overlay-open', { detail: { id: 'newsletter' } })
        );
      }

      close(remember) {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        kit.unlock();
        document.removeEventListener('keydown', this.onKeydown);
        if (remember && !this.editing()) this.suppress();
        if (this.opener && document.contains(this.opener) && kit.visible(this.opener)) {
          this.opener.focus();
        }
        this.opener = null;
      }
    }

    if (!window.customElements.get('cs-newsletter-popup')) {
      window.customElements.define('cs-newsletter-popup', CsNewsletterPopup);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-portfolio"] && !Shopify.designMode) return;
  try {
    
  /**
   * <cs-profile> — カードの details/summary を <dialog> のモーダルに昇格させる。
   *
   * 昇格しない条件（＝ネイティブの details のまま残す）:
   *   - <dialog>.showModal() が無い環境
   *   - テンプレート／パネルが見つからない（マークアップ側の欠損）
   * どちらの場合も内容には到達できる。JS はあくまで上乗せ。
   */
  (function () {
    'use strict';

    if (!('customElements' in window)) return;

    var FOCUSABLE = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'summary',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');

    class CsProfile extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        var host = this.closest('.cportf');
        var tpl = host ? host.querySelector('.cportf__tpl') : null;
        var summary = this.querySelector('.cportf__toggle');
        var panel = this.querySelector('.cportf__panel');
        if (!host || !tpl || !tpl.content || !summary || !panel) return;

        var canModal =
          typeof window.HTMLDialogElement === 'function' &&
          typeof window.HTMLDialogElement.prototype.showModal === 'function';
        if (!canModal) return;

        this.dataset.ready = 'true';

        var dialog = tpl.content.cloneNode(true).querySelector('.cportf__modal');
        var sheet = dialog ? dialog.querySelector('.cportf__sheet') : null;
        var close = dialog ? dialog.querySelector('.cportf__close') : null;
        if (!dialog || !sheet || !close) return;

        // 複製ではなく「移動」。文言が二重に存在しないので食い違いようがない。
        sheet.appendChild(panel);
        host.appendChild(dialog);

        if (panel.dataset.title) dialog.setAttribute('aria-labelledby', panel.dataset.title);

        summary.setAttribute('aria-haspopup', 'dialog');
        summary.setAttribute('aria-expanded', 'false');
        if (panel.id) summary.setAttribute('aria-controls', panel.id);

        this.summary = summary;
        this.dialog = dialog;
        this.sheet = sheet;

        this.onToggle = this.onToggle.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onBackdrop = this.onBackdrop.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.afterClose = this.afterClose.bind(this);

        summary.addEventListener('click', this.onToggle);
        close.addEventListener('click', this.onClose);
        dialog.addEventListener('click', this.onBackdrop);
        dialog.addEventListener('keydown', this.onKeydown);
        // ブラウザが独自に閉じた経路（フォーム submit など）への保険。
        dialog.addEventListener('close', this.afterClose);
      }

      disconnectedCallback() {
        // 開いたままセクションが差し替わってもページのスクロールを取り戻す。
        this.unlock();
      }

      /** summary の既定動作（details の開閉）を止めて、モーダルに差し替える。 */
      onToggle(event) {
        event.preventDefault();
        if (this.dialog.open) return;
        this.lock();
        this.dialog.showModal();
        this.summary.setAttribute('aria-expanded', 'true');
        this.sheet.scrollTop = 0;
      }

      /**
       * 閉じる経路は必ずここを通す。
       * close イベントを待たずにその場で後始末するのは、**close イベントが届かない
       * 埋め込みブラウザが実在する**ため（検証中の Chromium 埋め込みで発火しなかった）。
       * afterClose() は冪等なので、後から close イベントが来ても二重には走らない。
       */
      onClose() {
        if (this.dialog.open) this.dialog.close();
        this.afterClose();
      }

      /** 幕（= dialog 要素自身）のクリックだけ拾う。中身のクリックは子要素が受ける。 */
      onBackdrop(event) {
        if (event.target === this.dialog) this.onClose();
      }

      /**
       * Esc は <dialog> のネイティブ動作でも閉じるが、上と同じ理由で自前でも受ける。
       * preventDefault が効いた場合も効かなかった場合も、onClose() が状態を揃える。
       * 残りは Tab のラップ（ネイティブのフォーカストラップに対する保険）。
       */
      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.onClose();
          return;
        }
        if (event.key !== 'Tab') return;
        var items = Array.prototype.filter.call(
          this.sheet.querySelectorAll(FOCUSABLE),
          function (el) {
            return el.getClientRects().length > 0;
          }
        );
        if (items.length < 2) return;

        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      /** aria-expanded を「開いているか」の唯一の記録にして冪等にする。 */
      afterClose() {
        if (this.summary.getAttribute('aria-expanded') !== 'true') return;
        this.unlock();
        this.summary.setAttribute('aria-expanded', 'false');
        this.summary.focus();
      }

      /** concept.css が html に scrollbar-gutter: stable を入れているので横ズレは出ない。 */
      lock() {
        this.prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }

      unlock() {
        if (this.prevOverflow === undefined) return;
        document.documentElement.style.overflow = this.prevOverflow;
        this.prevOverflow = undefined;
      }
    }

    if (!customElements.get('cs-profile')) customElements.define('cs-profile', CsProfile);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-product-bundle"] && !Shopify.designMode) return;
  try {
    
  /**
   * <cs-bundle> — バンドルの選択状態・小計・割引・合計をまとめる。
   *
   * 前提（重要）
   *  - この要素が無くても、商品グリッドは素の商品カードとして完全に読める。
   *    カード側のクイック追加が「1点ずつ追加する」導線として生きている。
   *  - 起動すると data-cbn-ready が付き、カード全面のトグルが有効になる。
   *    同時にカード側のクイック追加 <form> を畳んで、追加口をバンドルへ一本化する。
   *  - 送信は素の POST がベース。fetch が使えるときだけ /cart/add.js へ投げ、
   *    失敗したら form.submit() で素の POST に落ちる（二重送信は起きない）。
   */
  (function () {
    if (typeof window === 'undefined' || !('customElements' in window)) return;
    if (customElements.get('cs-bundle')) return;

    var DOCK_MQ = '(max-width: 1023px)';
    var REMOVE_ICON =
      '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">' +
      '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

    function stripTags(value) {
      return String(value == null ? '' : value).replace(/<[^>]*>/g, '');
    }

    /* Shopify の money_format をそのまま解釈する。ストア全体（商品カード等）と
       同じ書式になるので、パネル内だけ表記が割れることがない。 */
    function withDelimiters(cents, precision, thousands, decimal) {
      var t = thousands || ',';
      var d = decimal || '.';
      var n = Number(cents);
      if (!isFinite(n)) n = 0;
      var fixed = (n / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return parts[1] ? head + d + parts[1] : head;
    }

    function formatMoney(cents, format) {
      var fmt = stripTags(format);
      var token = /\{\{\s*(\w+)\s*\}\}/;
      var match = fmt.match(token);
      if (!match) return withDelimiters(cents, 0);
      var value;
      switch (match[1]) {
        case 'amount_no_decimals':
          value = withDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = withDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = withDelimiters(cents, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = withDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = withDelimiters(cents, 2, "'");
          break;
        default:
          value = withDelimiters(cents, 2);
      }
      return fmt.replace(token, value);
    }

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    class CsBundle extends HTMLElement {
      connectedCallback() {
        if (this.dataset.cbnReady === 'true') return;

        this.cells = toArray(this.querySelectorAll('[data-cbn-item]'));
        this.form = this.querySelector('[data-cbn-form]');
        this.itemsEl = this.querySelector('[data-cbn-items]');
        this.submitEl = this.querySelector('[data-cbn-submit]');
        if (!this.cells.length || !this.form || !this.itemsEl || !this.submitEl) return;

        this.min = parseInt(this.getAttribute('data-min'), 10) || 1;
        this.rate = parseInt(this.getAttribute('data-discount'), 10) || 0;
        this.moneyFormat = this.getAttribute('data-money-format') || '';
        this.addUrl = this.getAttribute('data-cart-add-url') || '/cart/add';
        this.cartUrl = this.getAttribute('data-cart-url') || '/cart';

        this.statusEl = this.querySelector('[data-cbn-status]');
        this.barEl = this.querySelector('[data-cbn-bar]');
        this.fillEl = this.querySelector('[data-cbn-fill]');
        this.emptyEl = this.querySelector('[data-cbn-empty]');
        this.skeletonEl = this.querySelector('[data-cbn-skeleton]');
        this.liveEl = this.querySelector('[data-cbn-live]');
        this.subtotalEl = this.querySelector('[data-cbn-subtotal]');
        this.discountRowEl = this.querySelector('[data-cbn-discount-row]');
        this.discountEl = this.querySelector('[data-cbn-discount]');
        this.totalEl = this.querySelector('[data-cbn-total]');
        this.ctaEl = this.querySelector('[data-cbn-cta]');
        this.errorEl = this.querySelector('[data-cbn-error]');
        // ★ セレクタは必ず要素種別つきで書く。ルート側の状態属性（data-cbn-layout）と
        //   ボタンの目印（data-cbn-dock）が同名だったとき、closest() がルートを拾って
        //   セクション内の全クリックを飲み込んだ（削除ボタンが無反応・
        //   モバイルでカードを触るとドックが開く、という形で表面化した）。
        this.dockBtn = this.querySelector('button[data-cbn-dock]');
        this.collapseEl = this.dockBtn
          ? document.getElementById(this.dockBtn.getAttribute('aria-controls'))
          : null;
        this.sideEl = this.querySelector('.cbn__side');

        // カード側のクイック追加はバンドルと二重になるので畳む（JS 無効時は生きている）。
        this.cells.forEach(function (cell) {
          toArray(cell.querySelectorAll('form')).forEach(function (f) {
            f.hidden = true;
          });
        });

        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.syncDock = this.syncDock.bind(this);

        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        this.form.addEventListener('submit', this.onSubmit);

        // 直前の選択。初回描画では読み上げない（ページを開いただけで喋らせない）。
        this.prevIds = null;

        this.dockOpen = false;
        this.mq = window.matchMedia(DOCK_MQ);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.syncDock);
        else if (this.mq.addListener) this.mq.addListener(this.syncDock);

        this.watchVisibility();

        this.dataset.cbnReady = 'true';
        this.syncDock();
        this.render();
      }

      /* --- 選択 ---------------------------------------------------------- */

      selected() {
        return this.cells.filter(function (cell) {
          var box = cell.querySelector('[data-cbn-check]');
          return box && box.checked;
        });
      }

      onChange(event) {
        if (!event.target || !event.target.hasAttribute('data-cbn-check')) return;
        this.render();
      }

      onClick(event) {
        var dock = event.target.closest ? event.target.closest('button[data-cbn-dock]') : null;
        if (dock) {
          this.dockOpen = dock.getAttribute('aria-expanded') !== 'true';
          this.syncDock();
          return;
        }

        var remove = event.target.closest ? event.target.closest('[data-cbn-remove]') : null;
        if (!remove) return;

        var id = remove.getAttribute('data-cbn-remove');
        var cell = this.cells.filter(function (c) {
          return c.getAttribute('data-cbn-id') === id;
        })[0];
        var box = cell ? cell.querySelector('[data-cbn-check]') : null;
        if (box) box.checked = false;

        // フォーカスがパネルの外へ飛ばないよう、次の削除ボタン → 送信ボタンの順で受け止める。
        var buttons = toArray(this.itemsEl.querySelectorAll('[data-cbn-remove]'));
        var index = buttons.indexOf(remove);
        this.render();
        var next = toArray(this.itemsEl.querySelectorAll('[data-cbn-remove]'));
        var target = next[Math.min(index, next.length - 1)] || this.submitEl;
        if (target && target.focus) target.focus();
      }

      /* --- 描画 ---------------------------------------------------------- */

      render() {
        var self = this;
        var picked = this.selected();
        var count = picked.length;

        var subtotal = picked.reduce(function (sum, cell) {
          return sum + (parseInt(cell.getAttribute('data-cbn-price'), 10) || 0);
        }, 0);

        var qualified = count >= this.min;
        var discount = qualified ? Math.floor((subtotal * this.rate) / 100) : 0;
        var total = subtotal - discount;

        this.renderRows(picked);

        if (this.emptyEl) this.emptyEl.hidden = count > 0;
        if (this.skeletonEl) this.skeletonEl.hidden = count > 0;

        var ratio = this.min > 0 ? Math.min(count / this.min, 1) : 1;
        if (this.fillEl) this.fillEl.style.setProperty('--cbn-progress', String(ratio));
        if (this.barEl) {
          this.barEl.setAttribute('aria-valuenow', String(Math.min(count, this.min)));
          this.barEl.setAttribute('aria-valuetext', this.min + '点中' + Math.min(count, this.min) + '点');
        }

        var short = Math.max(this.min - count, 0);

        if (this.statusEl) {
          if (qualified) {
            this.statusEl.textContent = this.rate + '%OFFが適用されています。';
          } else {
            this.statusEl.textContent =
              'あと' + short + '点で' + this.rate + '%OFFになります。';
          }
        }

        var money = function (cents) {
          return formatMoney(cents, self.moneyFormat);
        };

        if (this.subtotalEl) {
          this.subtotalEl.textContent = count ? money(subtotal) : '—';
          // 割引が乗ったときだけ小計に取り消し線（→ 下の「合計」が支払額）。
          this.subtotalEl.classList.toggle('cbn__num--was', qualified && count > 0);
        }
        if (this.discountRowEl) this.discountRowEl.hidden = !qualified || count === 0;
        if (this.discountEl) this.discountEl.textContent = '-' + money(discount);
        if (this.totalEl) this.totalEl.textContent = count ? money(total) : '—';

        if (this.ctaEl) {
          if (qualified) {
            this.ctaEl.textContent = count + '点をカートに追加';
          } else if (count === 0) {
            this.ctaEl.textContent = 'バンドルをカートに追加';
          } else {
            this.ctaEl.textContent = 'あと' + short + '点選んでください';
          }
        }

        // 必要点数に届くまではグレー。disabled ではなく aria-disabled なので
        // フォーカスは当たり、押せば理由（あと何点か）が error 行に出る。
        if (!qualified) this.submitEl.setAttribute('aria-disabled', 'true');
        else this.submitEl.removeAttribute('aria-disabled');

        var dockCount = this.querySelector('[data-cbn-dock-count]');
        var dockTotal = this.querySelector('[data-cbn-dock-total]');
        if (dockCount) dockCount.textContent = count + '点';
        if (dockTotal) dockTotal.textContent = count ? money(total) : '—';

        this.announce(picked, count, qualified, short, count ? money(total) : '');

        this.hideError();
        this.measureDock();
      }

      /**
       * 追加・削除を1か所の live region で読み上げる。
       * 直前の選択と突き合わせて「何が変わったか」を先に言い、そのあとに
       * 現在の点数・合計・あと何点かを続ける（操作の結果が1回で分かる）。
       */
      announce(picked, count, qualified, short, totalText) {
        if (!this.liveEl) return;

        var ids = picked.map(function (cell) {
          return cell.getAttribute('data-cbn-id') || '';
        });

        // 初回描画（ページを開いた直後）は喋らせない。
        if (this.prevIds === null) {
          this.prevIds = ids;
          return;
        }

        var prev = this.prevIds;
        var added = ids.filter(function (id) {
          return prev.indexOf(id) === -1;
        });
        var removed = prev.filter(function (id) {
          return ids.indexOf(id) === -1;
        });
        this.prevIds = ids;

        var self = this;
        var nameOf = function (id) {
          var cell = self.cells.filter(function (c) {
            return c.getAttribute('data-cbn-id') === id;
          })[0];
          return cell ? cell.getAttribute('data-cbn-title') || '' : '';
        };

        var head = '';
        if (added.length === 1 && removed.length === 0) {
          head = nameOf(added[0]) + 'を追加しました。';
        } else if (removed.length === 1 && added.length === 0) {
          head = nameOf(removed[0]) + 'をバンドルから外しました。';
        } else if (added.length === 0 && removed.length === 0) {
          return; // 選択が動いていない再描画では黙る
        }

        var body = count
          ? '選択' + count + '点、合計' + totalText + '。'
          : '選択している商品はありません。';
        var tail = qualified
          ? this.rate + '%OFFが適用されています。'
          : 'あと' + short + '点で' + this.rate + '%OFFになります。';

        this.liveEl.textContent = head + body + tail;
      }

      renderRows(picked) {
        var self = this;
        this.itemsEl.textContent = '';

        picked.forEach(function (cell) {
          var title = cell.getAttribute('data-cbn-title') || '';
          var variant = cell.getAttribute('data-cbn-variant') || '';
          var src = cell.getAttribute('data-cbn-image') || '';
          var price = parseInt(cell.getAttribute('data-cbn-price'), 10) || 0;

          var li = document.createElement('li');
          li.className = 'cbn__item';

          var thumb = document.createElement('span');
          thumb.className = 'cbn__thumb';
          if (src) {
            var img = document.createElement('img');
            img.src = src;
            img.alt = '';
            img.width = 56;
            img.height = 56;
            img.loading = 'lazy';
            thumb.appendChild(img);
          }
          li.appendChild(thumb);

          var body = document.createElement('span');
          body.className = 'cbn__item-body';

          var name = document.createElement('span');
          name.className = 'cbn__item-title';
          name.textContent = title;
          body.appendChild(name);

          if (variant) {
            var vr = document.createElement('span');
            vr.className = 'cbn__item-variant';
            vr.textContent = variant;
            body.appendChild(vr);
          }

          var pr = document.createElement('span');
          pr.className = 'cbn__item-price';
          pr.textContent = formatMoney(price, self.moneyFormat);
          body.appendChild(pr);

          li.appendChild(body);

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cbn__remove';
          btn.setAttribute('data-cbn-remove', cell.getAttribute('data-cbn-id') || '');
          btn.setAttribute('aria-label', title + 'をバンドルから外す');
          btn.innerHTML = REMOVE_ICON;
          li.appendChild(btn);

          self.itemsEl.appendChild(li);
        });
      }

      /* --- ドック -------------------------------------------------------- */

      syncDock() {
        var docked = this.mq.matches;
        this.dataset.cbnLayout = docked ? 'dock' : 'wide';

        var open = docked ? this.dockOpen : true;
        if (this.collapseEl) this.collapseEl.hidden = !open;
        if (this.dockBtn) this.dockBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.measureDock();
      }

      measureDock() {
        if (!this.sideEl) return;
        if (this.dataset.cbnLayout !== 'dock') {
          this.style.removeProperty('--cbn-dock-h');
          return;
        }
        this.style.setProperty('--cbn-dock-h', this.sideEl.offsetHeight + 'px');
      }

      watchVisibility() {
        if (!('IntersectionObserver' in window)) {
          this.dataset.cbnVisible = 'true';
          return;
        }
        var self = this;
        var main = this.querySelector('.cbn__main') || this;
        this.io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              self.dataset.cbnVisible = entry.isIntersecting ? 'true' : 'false';
            });
          },
          { rootMargin: '0px 0px -20% 0px', threshold: 0 }
        );
        this.io.observe(main);
      }

      /* --- 送信 ---------------------------------------------------------- */

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
      }

      onSubmit(event) {
        var picked = this.selected();
        if (!picked.length) {
          event.preventDefault();
          this.showError('商品を1点以上選んでください。');
          return;
        }

        // グレーのCTAを押したときは、無反応で終わらせず理由を返す。
        if (picked.length < this.min) {
          event.preventDefault();
          this.showError(
            'バンドルは' + this.min + '点からです。あと' +
              (this.min - picked.length) + '点選んでください。'
          );
          return;
        }

        if (typeof window.fetch !== 'function' || typeof window.FormData !== 'function') return;

        event.preventDefault();

        var data = new FormData();
        picked.forEach(function (cell, i) {
          data.append('items[' + i + '][id]', cell.getAttribute('data-cbn-id'));
          data.append('items[' + i + '][quantity]', '1');
        });

        var self = this;
        this.submitEl.disabled = true;
        this.submitEl.setAttribute('aria-busy', 'true');

        window
          .fetch(this.addUrl + '.js', {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return res.json();
          })
          .then(function () {
            window.location.href = self.cartUrl;
          })
          .catch(function () {
            // AJAX が使えない・弾かれた場合は素の POST に落ちる（submit() は再帰しない）。
            self.submitEl.removeAttribute('aria-busy');
            self.submitEl.disabled = false;
            self.form.submit();
          });
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.mq && this.mq.removeEventListener) {
          this.mq.removeEventListener('change', this.syncDock);
        } else if (this.mq && this.mq.removeListener) {
          this.mq.removeListener(this.syncDock);
        }
      }
    }

    customElements.define('cs-bundle', CsBundle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-recently-viewed"]) return;
  try {
    
  /**
   * 最近見た商品（読み側だけ）。
   *
   * ここが 1 行も動かなくても、サーバー側で描いた「こちらもおすすめ」がそのまま残る。
   * 動いたときだけ、localStorage の履歴でその中身を差し替える。
   *
   *   localStorage['concept:recently-viewed'] = '["handle-a","handle-b", ...]'（新しい順）
   *
   * 取り直しはセクション再レンダリング API。
   *   履歴あり : /search?section_id=<id>&type=product&q=handle:a OR handle:b
   *   履歴なし : /recommendations/products?product_id=<id>&section_id=<id>
   */
  (function () {
    'use strict';

    var KEY = 'concept:recently-viewed';
    var MAX_TERMS = 12;

    function readHistory() {
      try {
        var raw = window.localStorage.getItem(KEY);
        if (!raw) return [];
        var list = JSON.parse(raw);
        if (!Array.isArray(list)) return [];
        var out = [];
        for (var i = 0; i < list.length; i += 1) {
          var h = list[i];
          // 数値 ID を入れられていた場合も落とさず捨てるだけにする
          if (typeof h === 'string' && /^[a-z0-9-]+$/i.test(h) && out.indexOf(h) === -1) {
            out.push(h);
          }
          if (out.length >= MAX_TERMS) break;
        }
        return out;
      } catch (e) {
        return [];
      }
    }

    function fetchFragment(url) {
      return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('[data-crv-inner]');
        });
    }

    function reorder(inner, handles) {
      var list = inner.querySelector('[data-crv-list]');
      if (!list) return;
      var cells = Array.prototype.slice.call(list.querySelectorAll('[data-crv-handle]'));
      cells
        .slice()
        .sort(function (a, b) {
          var ia = handles.indexOf(a.getAttribute('data-crv-handle'));
          var ib = handles.indexOf(b.getAttribute('data-crv-handle'));
          return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
        })
        .forEach(function (cell) {
          list.appendChild(cell);
        });
    }

    function swap(host, inner) {
      if (!inner || !inner.querySelector('[data-crv-handle]')) return;
      var current = host.querySelector('[data-crv-inner]');
      if (!current) return;
      current.replaceWith(inner);
    }

    function boot(host) {
      if (host.dataset.crvReady === 'true') return;
      host.dataset.crvReady = 'true';

      if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;

      var limit = parseInt(host.getAttribute('data-crv-limit') || '8', 10);
      var handles = readHistory().slice(0, limit);

      if (handles.length > 0) {
        var terms = handles
          .map(function (h) {
            return 'handle:' + h;
          })
          .join(' OR ');
        fetchFragment(host.getAttribute('data-crv-url') + encodeURIComponent(terms))
          .then(function (inner) {
            if (!inner) return;
            reorder(inner, handles);
            swap(host, inner);
          })
          .catch(function () {
            /* 取り直せなければサーバー側の内容を残す */
          });
        return;
      }

      var recId = host.getAttribute('data-crv-recommend-id');
      if (recId) {
        fetchFragment(host.getAttribute('data-crv-recommend') + encodeURIComponent(recId))
          .then(function (inner) {
            swap(host, inner);
          })
          .catch(function () {
            /* 同上 */
          });
      }
    }

    function init() {
      document.querySelectorAll('cs-recently-viewed').forEach(boot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-scrolled-images"] && !Shopify.designMode) return;
  try {
    
  /**
   * <csi-wall> — 3本の行をスクロール量で横に流す（スクラブ）。
   *
   *  - concept.js と同じ「停止した WAAPI の currentTime を書く」方式。
   *    transition を一切かけないので、毎フレーム書く値と補間する値が衝突しない。
   *  - 振れ幅は行の自幅に対する % なので、画面幅やタイルサイズが変わっても比率が保たれる。
   *    手前（濃い）ほど速い ＝ 視差で奥行きが出る。
   *  - 画面外は計算しない（IntersectionObserver）。scroll は rAF で1フレーム1回に畳む。
   *  - reduced-motion のときはアニメーション自体を作らない（＝行は基準位置のまま）。
   */
  (() => {
    const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
    const SPEEDS = [7, 4.5, 2.5]; // 行の自幅に対する片振れ幅(%)
    const hosts = [];
    let raf = null;

    const motionOff = () =>
      REDUCE.matches || document.documentElement.dataset.motion === 'off';

    function tick() {
      raf = null;
      const vh = window.innerHeight || 1;

      for (const host of hosts) {
        if (!host.csiActive) continue;

        const rect = host.getBoundingClientRect();
        const total = rect.height + vh;
        if (total <= 0) continue;

        // 下から入って上へ抜けるまでを 0 → 1。中央通過(0.5)で基準位置に戻る。
        const p = Math.min(1, Math.max(0, (vh - rect.top) / total));
        for (const anim of host.csiAnims) anim.currentTime = p * 1000;
      }
    }

    const schedule = () => {
      if (raf === null) raf = requestAnimationFrame(tick);
    };

    class CsiWall extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const rows = this.querySelectorAll('[data-csi-row]');
        if (!rows.length || motionOff()) return;

        this.csiAnims = [];
        this.csiActive = false;

        rows.forEach((row, i) => {
          const s = SPEEDS[i % SPEEDS.length];
          const anim = row.animate(
            [
              { transform: 'translate3d(' + s + '%, 0, 0)' },
              { transform: 'translate3d(' + -s + '%, 0, 0)' },
            ],
            { duration: 1000, easing: 'linear', fill: 'both' }
          );
          anim.pause();
          this.csiAnims.push(anim);
        });

        hosts.push(this);

        this.csiObserver = new IntersectionObserver(
          (entries) => {
            this.csiActive = entries[0].isIntersecting;
            schedule();
          },
          { rootMargin: '15% 0px' }
        );
        this.csiObserver.observe(this);

        schedule();
      }

      disconnectedCallback() {
        if (this.csiObserver) {
          this.csiObserver.disconnect();
          this.csiObserver = null;
        }

        const i = hosts.indexOf(this);
        if (i > -1) hosts.splice(i, 1);

        if (this.csiAnims) {
          this.csiAnims.forEach((a) => a.cancel());
          this.csiAnims = null;
        }

        this.dataset.ready = 'false';
      }
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    if (!customElements.get('csi-wall')) customElements.define('csi-wall', CsiWall);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-search-drawer"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * concept-search-drawer
   *   ・a[href^=routes.search_url] のクリックを捕捉して開く（ヘッダーは無改造）
   *   ・入力 250ms デバウンス → /search/suggest?section_id= で断片HTMLを取得
   *   ・失敗したら候補を消すだけ。Enter の素の GET /search は常に生きている
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    var FOCUSABLE =
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

    window.CsOverlayKit =
      window.CsOverlayKit ||
      (function () {
        var depth = 0;
        var prev = '';
        var gutter = !!(window.CSS && CSS.supports && CSS.supports('scrollbar-gutter', 'stable'));

        function lock() {
          depth += 1;
          if (depth > 1) return;
          var root = document.documentElement;
          prev = root.style.overflow;
          if (!gutter) {
            var bar = window.innerWidth - root.clientWidth;
            if (bar > 0) document.body.style.paddingInlineEnd = bar + 'px';
          }
          root.style.overflow = 'hidden';
        }

        function unlock() {
          depth -= 1;
          if (depth > 0) return;
          depth = 0;
          document.documentElement.style.overflow = prev;
          document.body.style.paddingInlineEnd = '';
        }

        function visible(el) {
          return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        }

        function trap(root, event) {
          if (event.key !== 'Tab') return;
          var list = Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), visible);
          if (!list.length) return;
          var first = list[0];
          var last = list[list.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }

        return { lock: lock, unlock: unlock, trap: trap, visible: visible };
      })();

    var kit = window.CsOverlayKit;

    function near(target, selector) {
      return target && target.closest ? target.closest(selector) : null;
    }

    class CsSearchDrawer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.panel = this.querySelector('[data-sd-panel]');
        this.input = this.querySelector('[data-sd-input]');
        this.results = this.querySelector('[data-sd-slot]');
        this.fallback = this.querySelector('[data-sd-default]');
        this.clear = this.querySelector('[data-sd-clear]');
        this.timer = 0;
        this.controller = null;
        this.opener = null;
        this.onKeydown = this.onKeydown.bind(this);

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('input', this.onInput.bind(this));
        this.addEventListener('reset', this.onReset.bind(this));
        install(this);
      }

      onClick(event) {
        if (near(event.target, '[data-sd-close], [data-sd-scrim]')) {
          event.preventDefault();
          this.close();
        }
      }

      onReset() {
        var self = this;
        window.setTimeout(function () {
          self.render('');
          if (self.input) self.input.focus();
        }, 0);
      }

      onInput(event) {
        if (!near(event.target, '[data-sd-input]')) return;
        var self = this;
        var term = this.input.value.trim();
        if (this.clear) this.clear.hidden = term.length === 0;
        window.clearTimeout(this.timer);
        if (term.length < 2) {
          this.render('');
          return;
        }
        this.timer = window.setTimeout(function () {
          self.suggest(term);
        }, 250);
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.stopPropagation();
          this.close();
          return;
        }
        kit.trap(this.panel || this, event);
      }

      /* 断片HTMLを差し込む。空文字なら既定の導線（人気カテゴリ等）に戻す。 */
      render(html) {
        if (!this.results) return;
        this.results.innerHTML = html;
        this.results.hidden = html === '';
        if (this.fallback) this.fallback.hidden = html !== '';
      }

      suggest(term) {
        var self = this;
        if (this.controller) this.controller.abort();
        this.controller = window.AbortController ? new AbortController() : null;

        var url =
          this.dataset.suggestUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,collection,page,query' +
          '&resources[limit]=' +
          encodeURIComponent(this.dataset.limit || 4) +
          '&section_id=' +
          encodeURIComponent(this.dataset.sectionId);

        fetch(url, this.controller ? { signal: this.controller.signal } : undefined)
          .then(function (res) {
            if (!res.ok) throw new Error('suggest ' + res.status);
            return res.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var found = doc.querySelector('[data-sd-results]');
            self.render(found ? found.innerHTML : '');
          })
          .catch(function () {
            /* 予測検索は補助機能。失敗時は既定の導線に戻すだけで、
               Enter による素の GET /search は常に生きている。 */
            self.render('');
          });
      }

      open(opener) {
        if (this.classList.contains('is-open')) return;
        this.opener = opener || document.activeElement;
        this.classList.add('is-open');
        kit.lock();
        document.addEventListener('keydown', this.onKeydown);
        var self = this;
        window.requestAnimationFrame(function () {
          if (self.input) self.input.focus();
        });
        window.dispatchEvent(new CustomEvent('concept:overlay-open', { detail: { id: 'search' } }));
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        kit.unlock();
        document.removeEventListener('keydown', this.onKeydown);
        if (this.opener && document.contains(this.opener) && kit.visible(this.opener)) {
          this.opener.focus();
        }
        this.opener = null;
      }
    }

    var installed = false;

    function install(drawer) {
      if (installed) return;
      installed = true;

      document.addEventListener('click', function (event) {
        var link = near(event.target, 'a[href]');
        if (!link || event.defaultPrevented) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
        if (link.target && link.target !== '_self') return;
        if (drawer.contains(link)) return;

        var probe = document.createElement('a');
        probe.href = link.getAttribute('href');
        if (probe.host !== window.location.host) return;
        var route = String(drawer.dataset.searchUrl || '/search').replace(/\/$/, '');
        if (probe.pathname.replace(/\/$/, '') !== route) return;

        event.preventDefault();
        drawer.open(link);
      });

      window.addEventListener('concept:search-open', function (event) {
        drawer.open(event.detail && event.detail.opener);
      });

      window.addEventListener('concept:overlay-open', function (event) {
        if (!event.detail || event.detail.id === 'search') return;
        drawer.close();
      });
    }

    if (!window.customElements.get('cs-search-drawer')) {
      window.customElements.define('cs-search-drawer', CsSearchDrawer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-social-rail"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * concept-social-rail
   *   CTA は「登録ポップアップを開く」だけ。ポップアップが無い／JS が落ちた場合は
   *   href（既定は会員登録ページ）へ普通に遷移する。
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    class CsSocialRailCta extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        var link = this.querySelector('[data-rail-cta]');
        if (!link) return;

        link.addEventListener('click', function (event) {
          if (!document.querySelector('cs-newsletter-popup')) return;
          event.preventDefault();
          window.dispatchEvent(
            new CustomEvent('concept:newsletter-open', { detail: { opener: link } })
          );
        });
      }
    }

    if (!window.customElements.get('cs-social-rail-cta')) {
      window.customElements.define('cs-social-rail-cta', CsSocialRailCta);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-splitting-banner"] && !Shopify.designMode) return;
  try {
    
  /**
   * スプリットバナーのスクラブ。
   *
   * 方式:
   *   - 2 本の paused な Web Animation を作り、毎フレーム currentTime を書く。
   *     transition は一切かけない（書く値と補間する値は排他）。
   *   - 進捗は「トラッカー」2 枚の矩形からしか作らない。窓の位置・寸法は CSS が持ち、
   *     JS はそれを知らない。ブレークポイントで窓を変えても JS は無変更で追随する。
   *       p = clamp01((innerHeight − rect.top) / rect.height)
   *   - キーフレームの移動量とイージングは CSS カスタムプロパティから読む
   *     （--csb-open-* / --cs-ease-*）。JS に数値もベジェもハードコードしない。
   *
   * 制約:
   *   - 1 フレーム内で「全部読む → 全部書く」。読み書きを交互にすると layout thrashing。
   *   - 読む矩形はトラッカーだけ。トラッカーは transform を一切受けないので、
   *     書いた値が次フレームの入力に混ざらない ＝ 発振しない。
   *   - 画面外のセクションは計算しない。スクロールが止まれば rAF も止まる。
   *   - reduced-motion の間は data-csb-ready を付けない。フラグを先に立てると
   *     OS 設定を戻したときに二度と有効化されないため、ready も立てない。
   *   - フォーカスが文章に入ったら強制的に開き切る。閉じている間、文章は不透明な
   *     画像の下にあり、フォーカスリングが見えないため。
   */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var DURATION = 1000;

    var items = [];
    var scheduled = false;
    var bound = false;

    function clamp01(v) {
      return v < 0 ? 0 : v > 1 ? 1 : v;
    }

    function readVar(el, name, fallback) {
      var v = window.getComputedStyle(el).getPropertyValue(name).trim();
      return v === '' ? fallback : v;
    }

    /**
     * 開き量（px）を決める。
     *   下限 = CSS の --csb-open-{axis}（実測の 50%）を半分側の実寸に掛けたもの
     *   要求 = 本文の実寸の半分 + 余白    ← 隙間 = 開き量 × 2 なので、これで本文が収まる
     *   上限 = 半分側の実寸               ← 超えると半分が完全に外へ出る＝隙間 = ステージ全面
     * デスクトップでは本文が最大 46% に収まるので下限（＝実測の 50%）がそのまま勝つ。
     * モバイル（縦割り）だけ、本文が縦に長いぶん要求側が勝って余分に開く。
     * これで「本文が不透明な画像の下に潜る」状態が構造的に起きなくなる。
     */
    function openDistance(item, axis) {
      var half = item.start || item.end;
      if (!half) return 0;
      var pct = parseFloat(readVar(item.root, axis === 'x' ? '--csb-open-x' : '--csb-open-y', '50'));
      if (isNaN(pct)) pct = 50;
      var halfSize = axis === 'x' ? half.offsetWidth : half.offsetHeight;
      var inner = item.content ? item.content.firstElementChild : null;
      var copySize = inner ? (axis === 'x' ? inner.offsetWidth : inner.offsetHeight) : 0;
      var pad = parseFloat(readVar(item.root, '--cs-4', '16px'));
      if (isNaN(pad)) pad = 16;
      var need = copySize > 0 ? copySize / 2 + pad : 0;
      return Math.round(Math.min(Math.max((halfSize * pct) / 100, need), halfSize));
    }

    /* キーフレームを組み直す。ブレークポイントで軸が変わる／本文の折り返し行数が
       変わると開き量も変わるため、寸法込みの署名で「変わったときだけ」作り直す。 */
    function build(item) {
      var axis = readVar(item.root, '--csb-axis', 'x') === 'y' ? 'y' : 'x';
      var d = openDistance(item, axis);
      var x = axis === 'x' ? d + 'px' : '0px';
      var xn = axis === 'x' ? -d + 'px' : '0px';
      var y = axis === 'y' ? d + 'px' : '0px';
      var yn = axis === 'y' ? -d + 'px' : '0px';
      var signature = axis + '/' + d;
      if (item.signature === signature) return;
      item.signature = signature;

      var i;
      for (i = 0; i < item.anims.length; i++) item.anims[i].cancel();
      item.anims = [];
      item.doors = [];
      item.text = null;

      /* 開閉には対称イージング（--cs-ease-inout）、出現には --cs-ease-out。
         concept.css のトークン定義をそのまま使う。 */
      var easeDoor = readVar(item.root, '--cs-ease-inout', 'cubic-bezier(0.7, 0, 0.3, 1)');
      var easeText = readVar(item.root, '--cs-ease-out', 'cubic-bezier(0.3, 1, 0.3, 1)');

      if (item.start) {
        item.doors.push(
          item.start.animate(
            [
              { transform: 'translate3d(0, 0, 0)' },
              { transform: 'translate3d(' + xn + ', ' + yn + ', 0)' }
            ],
            { duration: DURATION, fill: 'both', easing: easeDoor }
          )
        );
      }

      if (item.end) {
        item.doors.push(
          item.end.animate(
            [
              { transform: 'translate3d(0, 0, 0)' },
              { transform: 'translate3d(' + x + ', ' + y + ', 0)' }
            ],
            { duration: DURATION, fill: 'both', easing: easeDoor }
          )
        );
      }

      if (item.content) {
        /* 0.8 で出し切る。貼り付きが解ける手前で読み終えられるようにするため。 */
        item.text = item.content.animate(
          [
            { opacity: 0, transform: 'scale(0.9)', offset: 0 },
            { opacity: 1, transform: 'scale(1)', offset: 0.8 },
            { opacity: 1, transform: 'scale(1)', offset: 1 }
          ],
          { duration: DURATION, fill: 'both', easing: easeText }
        );
      }

      item.anims = item.doors.slice();
      if (item.text) item.anims.push(item.text);
      for (i = 0; i < item.anims.length; i++) item.anims[i].pause();

      item.lastDoor = -1;
      item.lastText = -1;

      /* 直前の進捗をその場で復元する。作り直した瞬間だけ currentTime が 0（＝閉じた
         状態）に戻ると、貼り付いている最中のリサイズで扉が一瞬閉じて見えるため。 */
      for (i = 0; i < item.doors.length; i++) item.doors[i].currentTime = item.pDoor * DURATION;
      if (item.text) item.text.currentTime = item.pText * DURATION;
    }

    function progress(el, vh) {
      var rect = el.getBoundingClientRect();
      if (rect.height <= 0) return 1;
      return clamp01((vh - rect.top) / rect.height);
    }

    function update() {
      scheduled = false;
      var vh = window.innerHeight;
      var i, j, item;

      /* --- 読み取りフェーズ --- */
      for (i = 0; i < items.length; i++) {
        item = items[i];
        item.run = item.root.isConnected && (item.live || item.pending);
        if (!item.run) continue;
        item.pDoor = item.forced ? 1 : progress(item.trackSplit, vh);
        item.pText = item.forced ? 1 : progress(item.trackText, vh);
      }

      /* --- 書き込みフェーズ --- */
      for (i = 0; i < items.length; i++) {
        item = items[i];
        if (!item.run) continue;
        item.pending = false;

        if (item.pDoor !== item.lastDoor) {
          item.lastDoor = item.pDoor;
          for (j = 0; j < item.doors.length; j++) {
            item.doors[j].currentTime = item.pDoor * DURATION;
          }
        }

        if (item.text && item.pText !== item.lastText) {
          item.lastText = item.pText;
          item.text.currentTime = item.pText * DURATION;
        }
      }
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    /**
     * 組み直し。**2 回呼ぶ**（今と次フレーム）。
     * 幅が変わった直後は、メディアクエリの適用（＝--csb-axis の切り替わり）と
     * ResizeObserver / resize の発火順が環境によって前後する。古い軸のまま
     * 1 回だけ組むと、署名が新しい値に一致してしまい以後 build が no-op になる
     * （検証環境で実際に横割りのキーフレームが縦画面に残った）。
     * build は署名が同じなら何もしないので、2 回目はほぼ無コスト。
     */
    function refresh(item) {
      build(item);
      item.pending = true;
      window.requestAnimationFrame(function () {
        build(item);
        item.pending = true;
        schedule();
      });
    }

    function onResize() {
      for (var i = 0; i < items.length; i++) refresh(items[i]);
      schedule();
    }

    function bind() {
      if (bound) return;
      bound = true;
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
    }

    function setup(root) {
      if (root.hasAttribute('data-csb-ready')) return;
      if (reduce.matches) return;

      var trackSplit = root.querySelector('[data-csb-track-split]');
      var trackText = root.querySelector('[data-csb-track-text]');
      if (!trackSplit || !trackText) return;

      var start = root.querySelector('[data-csb-half-start]');
      var end = root.querySelector('[data-csb-half-end]');
      var content = root.querySelector('[data-csb-content]');
      var probe = start || end || content;
      if (!probe || typeof probe.animate !== 'function') return;

      /* ここで初めて「閉じた状態」が存在しうる状態になる。
         data-csb-ready と WAAPI の生成は同じタスクで行い、
         「貼り付いたが開いたまま」の 1 フレームを作らない。 */
      root.setAttribute('data-csb-ready', '');

      var item = {
        root: root,
        trackSplit: trackSplit,
        trackText: trackText,
        start: start,
        end: end,
        content: content,
        anims: [],
        doors: [],
        text: null,
        signature: '',
        live: false,
        pending: true,
        forced: false,
        run: false,
        pDoor: 0,
        pText: 0,
        lastDoor: -1,
        lastText: -1
      };
      items.push(item);
      build(item);

      /* 本文の折り返し行数が変われば必要な隙間も変わる（フォント読み込み・
         テーマエディタでの文言編集・端末回転）。本文の実寸を直接監視して組み直す。
         監視対象は本文、書き換えるのは扉の transform なので、
         書いた結果が次の観測に戻ってこない ＝ 無限ループしない。 */
      var innerEl = content ? content.firstElementChild : null;
      if (innerEl && 'ResizeObserver' in window) {
        new ResizeObserver(function () {
          refresh(item);
          schedule();
        }).observe(innerEl);
      }

      /* 画面外では一切計算しない。合成レイヤーも見えている間だけ確保する。 */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              item.live = entries[i].isIntersecting;
              if (item.live) {
                root.setAttribute('data-csb-live', '');
                item.pending = true;
              } else {
                root.removeAttribute('data-csb-live');
              }
            }
            schedule();
          },
          { rootMargin: '200px 0px' }
        ).observe(root);
      } else {
        item.live = true;
        root.setAttribute('data-csb-live', '');
      }

      /* 文章にフォーカスが入ったら開き切る（閉じている間はフォーカスリングが
         画像の下に隠れて見えないため）。抜けたらスクラブに戻す。 */
      if (content) {
        content.addEventListener('focusin', function () {
          item.forced = true;
          item.pending = true;
          schedule();
        });
        content.addEventListener('focusout', function (e) {
          if (content.contains(e.relatedTarget)) return;
          item.forced = false;
          item.pending = true;
          schedule();
        });
      }

      bind();
      schedule();
    }

    function init(scope) {
      var nodes = (scope || document).querySelectorAll('[data-csb]');
      for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });

    /* テーマエディタで選択されたら開いて見せる（編集中に文章が隠れないように） */
    document.addEventListener('shopify:section:select', function (e) {
      for (var i = 0; i < items.length; i++) {
        if (e.target.contains(items[i].root)) {
          items[i].forced = true;
          items[i].pending = true;
        }
      }
      schedule();
    });

    document.addEventListener('shopify:section:deselect', function (e) {
      for (var i = 0; i < items.length; i++) {
        if (e.target.contains(items[i].root)) {
          items[i].forced = false;
          items[i].pending = true;
        }
      }
      schedule();
    });

    if (reduce.addEventListener) {
      reduce.addEventListener('change', function () {
        if (!reduce.matches) init();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-timeline"] && !Shopify.designMode) return;
  try {
    
  /**
   * <cs-timeline>
   *  - ドットを押すとその項目へ scrollIntoView（scroll-padding は .cs-slider 側の指定が効く）
   *  - スクロール位置から現在項目を算出して aria-current / data-ctl-current を更新
   *  - 起動すると data-ctl-ready が付き、そこで初めて非選択項目に幕が掛かる
   *    （JS が届かない・落ちた場合は「幕なし＝全部読める」状態に構造的に着地する）
   */
  (function () {
    if (typeof window === 'undefined' || !('customElements' in window)) return;
    if (customElements.get('cs-timeline')) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    class CsTimeline extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ctlReady === 'true') return;

        this.track = this.querySelector('[data-ctl-track]');
        this.items = Array.prototype.slice.call(this.querySelectorAll('[data-ctl-item]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-ctl-dot]'));
        if (!this.track || this.items.length === 0) return;

        this.index = -1;
        this.frame = 0;
        this.lock = false;
        this.unlockTimer = 0;
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i));
          dot.addEventListener('keydown', (event) => this.onKeydown(event, i));
        });

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        window.addEventListener('load', this.onResize);

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.onResize);
          this.ro.observe(this.track);
        }

        this.dataset.ctlReady = 'true';
        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('load', this.onResize);
        if (this.ro) this.ro.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        if (this.unlockTimer) clearTimeout(this.unlockTimer);
      }

      get rtl() {
        return getComputedStyle(this).direction === 'rtl';
      }

      /**
       * 器の内側の開始辺に項目の開始辺を合わせる。
       *
       * scrollIntoView は使わない。理由は 2 つあり、どちらも実測で確認した:
       *   1. scroll-snap-type: x mandatory を持つこの器では Chrome が実際にスクロールしない
       *      （scrollLeft を直接入れると動くのに、scrollIntoView では 0 のまま動かない）。
       *   2. scrollIntoView は祖先のスクローラも巻き込むので、ドットを押しただけで
       *      ページ全体が縦に飛ぶ事故が起きうる。
       * 代わりに矩形から物理的な差分を出して器だけを動かす。scrollLeft は Chrome では
       * RTL で負値になる物理量なので、この差分の足し方は左右どちらの書字方向でも成立する。
       */
      goTo(i) {
        const item = this.items[i];
        if (!item) return;

        const rtl = this.rtl;
        const style = getComputedStyle(this.track);
        const pad = parseFloat(rtl ? style.paddingRight : style.paddingLeft) || 0;
        const box = this.track.getBoundingClientRect();
        const rect = item.getBoundingClientRect();
        const delta = rtl ? rect.right - (box.right - pad) : rect.left - (box.left + pad);

        // 走っている間は sync() を止める（途中の位置で選択が飛ぶのを防ぐ）
        this.lock = true;
        this.setCurrent(i);
        this.track.scrollTo({
          left: this.track.scrollLeft + delta,
          behavior: reduced.matches ? 'auto' : 'smooth',
        });
        this.unlockSoon();
      }

      /** scrollend が来たら解除。無い環境（Safari 等）はタイマーで必ず解除する。 */
      unlockSoon() {
        if (this.unlockTimer) clearTimeout(this.unlockTimer);
        if (!this.boundUnlock) {
          this.boundUnlock = () => {
            this.lock = false;
            if (this.unlockTimer) clearTimeout(this.unlockTimer);
          };
        }
        if ('onscrollend' in window) {
          this.track.addEventListener('scrollend', this.boundUnlock, { once: true });
        }
        this.unlockTimer = setTimeout(this.boundUnlock, 700);
      }

      /** 器の内側の開始辺に最も近い項目を「現在」とみなす（scroll-snap: start と同じ基準） */
      sync() {
        if (this.lock) return;
        const rtl = this.rtl;
        const style = getComputedStyle(this.track);
        const pad = parseFloat(rtl ? style.paddingRight : style.paddingLeft) || 0;
        const box = this.track.getBoundingClientRect();
        const anchor = rtl ? box.right - pad : box.left + pad;

        let best = 0;
        let bestDistance = Infinity;

        this.items.forEach((el, i) => {
          const rect = el.getBoundingClientRect();
          const edge = rtl ? rect.right : rect.left;
          const distance = Math.abs(edge - anchor);
          if (distance < bestDistance - 0.5) {
            bestDistance = distance;
            best = i;
          }
        });

        this.setCurrent(best);
      }

      setCurrent(i) {
        if (i === this.index) return;
        this.index = i;
        this.items.forEach((el, n) => {
          el.setAttribute('data-ctl-current', n === i ? 'true' : 'false');
        });
        this.dots.forEach((dot, n) => {
          dot.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.sync();
        });
      }

      onResize() {
        this.index = -1;
        this.sync();
      }

      /** 左右キーで隣のステップへ。上下キーは奪わない（ページスクロールを潰さないため）。 */
      onKeydown(event, i) {
        const rtl = this.rtl;
        let next = null;

        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.items.length - 1;
        else if (event.key === 'ArrowRight') next = i + (rtl ? -1 : 1);
        else if (event.key === 'ArrowLeft') next = i - (rtl ? -1 : 1);
        if (next === null) return;

        next = Math.max(0, Math.min(this.items.length - 1, next));
        event.preventDefault();
        this.dots[next].focus();
        this.goTo(next);
      }
    }

    customElements.define('cs-timeline', CsTimeline);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-topbar"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <cs-topbar> — 告知の切替のみ。スクロール監視は <cs-header>(concept.js) の担当。
   * 方針:
   *   - 前後/一時停止ボタンは hidden で出力されている。JS が動いたときだけ外す。
   *   - prefers-reduced-motion では自動切替しない（WCAG 2.3.3 / 2.2.2）。
   *   - 自動切替が動いている間は aria-live を off にし、停止中だけ polite に戻す
   *     （回転中に読み上げ続けるとスクリーンリーダーが使えなくなるため）。
   * ------------------------------------------------------------------------ */
  (function () {
    if (customElements.get('cs-topbar')) return;

    class CsTopbar extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.setupLocalization();

        this.slides = Array.from(this.querySelectorAll('[data-ct-slide]'));
        this.viewport = this.querySelector('[data-ct-viewport]');
        this.toggleBtn = this.querySelector('[data-ct-toggle]');
        if (this.slides.length < 2) return;

        this.index = Math.max(0, this.slides.findIndex(function (s) {
          return s.dataset.active === 'true';
        }));
        this.paused = false;
        this.held = false;

        var prev = this.querySelector('[data-ct-prev]');
        var next = this.querySelector('[data-ct-next]');
        if (prev) {
          prev.hidden = false;
          prev.addEventListener('click', this.go.bind(this, -1));
        }
        if (next) {
          next.hidden = false;
          next.addEventListener('click', this.go.bind(this, 1));
        }

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        var seconds = parseFloat(this.dataset.interval || '6');
        this.interval = (isNaN(seconds) ? 6 : seconds) * 1000;
        this.auto = this.dataset.autoplay === 'true' && !reduce.matches;

        if (this.auto && this.toggleBtn) {
          this.toggleBtn.hidden = false;
          this.toggleBtn.addEventListener('click', this.onToggle.bind(this));
          ['mouseenter', 'focusin'].forEach(function (t) {
            this.addEventListener(t, this.hold.bind(this, true));
          }, this);
          ['mouseleave', 'focusout'].forEach(function (t) {
            this.addEventListener(t, this.hold.bind(this, false));
          }, this);
          this.start();
        }
        this.syncLive();
      }

      disconnectedCallback() {
        this.stop();
      }

      setupLocalization() {
        var wrap = this.querySelector('[data-ct-loc]');
        if (!wrap) return;
        var form = wrap.querySelector('form');
        var submit = wrap.querySelector('[data-ct-loc-submit]');
        if (!form) return;
        if (submit) submit.hidden = true;
        Array.prototype.forEach.call(form.querySelectorAll('select'), function (select) {
          select.addEventListener('change', function () {
            form.submit();
          });
        });
      }

      start() {
        this.stop();
        var self = this;
        this.timer = window.setInterval(function () {
          if (self.paused || self.held || document.hidden) return;
          self.go(1);
        }, this.interval);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      hold(state) {
        this.held = state;
      }

      onToggle() {
        this.paused = !this.paused;
        this.toggleBtn.setAttribute('aria-pressed', String(this.paused));
        this.toggleBtn.setAttribute(
          'aria-label',
          this.paused ? 'お知らせの自動切替を再開' : 'お知らせの自動切替を一時停止'
        );
        this.syncLive();
      }

      syncLive() {
        if (!this.viewport) return;
        var rotating = this.auto && !this.paused;
        this.viewport.setAttribute('aria-live', rotating ? 'off' : 'polite');
      }

      go(dir) {
        var count = this.slides.length;
        this.slides[this.index].removeAttribute('data-active');
        this.index = (this.index + dir + count) % count;
        this.slides[this.index].setAttribute('data-active', 'true');
      }
    }

    customElements.define('cs-topbar', CsTopbar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["concept-video-banner"] && !Shopify.designMode) return;
  try {
    
  /**
   * <cvb-video data-provider="hosted|youtube|vimeo" data-embed-id data-autoplay data-player-id>
   *
   *  状態は data-state（idle / playing / paused）だけで表す。CSS はこれだけを見る。
   *  data-state はアップグレードできたときにしか付かないので、JS が届かない環境では
   *  再生ボタンが出ず「押しても何も起きないボタン」を作らない。
   *
   *  - hosted … <video preload="none"> をその場で play()。初回 play まで通信ゼロ。
   *  - youtube / vimeo … 押されたときに <iframe> を差し込むファサード方式。
   *                      停止は iframe を捨てて idle に戻す（＝ポスターが戻る）。
   *  - 自動再生 … muted + loop + playsinline。画面外・タブ非表示では止める。
   *               prefers-reduced-motion では自動再生しない（ボタンからは再生できる）。
   *  - 利用者が自分で止めたあとは、画面内に戻っても勝手に再生し直さない。
   */
  (function () {
    'use strict';

    if (window.customElements === undefined || customElements.get('cvb-video')) return;

    var YT = 'https://www.youtube-nocookie.com/embed/';
    var VIMEO = 'https://player.vimeo.com/video/';

    function embedUrl(provider, id) {
      var safe = encodeURIComponent(id);
      if (provider === 'youtube') {
        return (
          YT +
          safe +
          '?autoplay=1&mute=1&loop=1&playlist=' +
          safe +
          '&playsinline=1&rel=0&modestbranding=1&controls=0'
        );
      }
      return VIMEO + safe + '?autoplay=1&muted=1&loop=1&title=0&byline=0&portrait=0';
    }

    class CvbVideo extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.provider = this.getAttribute('data-provider') || '';
        if (!this.provider) return;

        this.dataset.ready = 'true';
        this.embedId = this.getAttribute('data-embed-id') || '';
        this.wantsAutoplay = this.getAttribute('data-autoplay') === 'true';
        this.button = this.querySelector('[data-cvb-toggle]');
        this.video = this.querySelector('video');
        // ★ `this.slot` は使えない。HTMLElement.prototype.slot（Shadow DOM の
        //   slot 属性を反映する **文字列** プロパティ）に食われ、代入した要素が
        //   "[object HTMLDivElement]" という文字列になって appendChild で落ちる。
        this.frameSlot = this.querySelector('.cvb__frame-slot');
        this.userPaused = false;
        this.resumeOnReturn = false;

        if (!this.button) return;
        if (this.provider === 'hosted' && !this.video) return;
        if (this.provider !== 'hosted' && (!this.frameSlot || !this.embedId)) return;

        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onClick = this.toggle.bind(this);
        this.onVisibility = this.onVisibility.bind(this);
        this.button.addEventListener('click', this.onClick);
        document.addEventListener('visibilitychange', this.onVisibility);

        if (this.video) {
          this.syncState = this.syncState.bind(this);
          this.video.addEventListener('play', this.syncState);
          this.video.addEventListener('pause', this.syncState);
        }

        this.setState('idle');

        // 自動再生は「画面に入っているあいだだけ」。電池とデータ量を無駄にしない。
        if (this.wantsAutoplay && !this.reduce.matches && 'IntersectionObserver' in window) {
          var self = this;
          this.io = new IntersectionObserver(
            function (entries) {
              var visible = entries[0].isIntersecting;
              self.inView = visible;
              if (visible && !self.userPaused) {
                self.play(true);
              } else if (!visible) {
                self.pause();
              }
            },
            { threshold: 0.25 }
          );
          this.io.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.video && this.syncState) {
          this.video.removeEventListener('play', this.syncState);
          this.video.removeEventListener('pause', this.syncState);
        }
      }

      setState(state) {
        this.setAttribute('data-state', state);
        if (!this.button) return;
        var next =
          state === 'playing'
            ? this.button.getAttribute('data-label-pause')
            : this.button.getAttribute('data-label-play');
        if (next) this.button.setAttribute('aria-label', next);
      }

      syncState() {
        if (!this.video) return;
        this.setState(this.video.paused ? 'paused' : 'playing');
      }

      toggle() {
        if (this.getAttribute('data-state') === 'playing') {
          this.userPaused = true;
          this.pause();
        } else {
          this.userPaused = false;
          this.play(false);
        }
      }

      play(auto) {
        if (this.provider === 'hosted') {
          var v = this.video;
          v.loop = true;
          v.playsInline = true;
          // 自動再生は必ず無音（ブラウザの方針であり WCAG 1.4.2 の要件でもある）。
          // 明示的なクリックのときだけ音を出す。
          v.muted = auto === true;
          var p = v.play();
          if (p && typeof p.catch === 'function') {
            var self = this;
            p.catch(function () {
              // 鳴らせなかった（自動再生ブロック等）ときは黙って idle に戻す。
              self.setState('idle');
            });
          }
          this.setState('playing');
          return;
        }

        if (!this.frameSlot.firstChild) {
          var frame = document.createElement('iframe');
          frame.className = 'cvb__frame';
          frame.src = embedUrl(this.provider, this.embedId);
          frame.setAttribute('title', this.getAttribute('data-frame-title') || '動画');
          frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          frame.setAttribute('allowfullscreen', '');
          frame.setAttribute('loading', 'lazy');
          frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
          this.frameSlot.appendChild(frame);
        }
        this.setState('playing');
      }

      pause() {
        if (this.provider === 'hosted') {
          if (this.video && !this.video.paused) this.video.pause();
          this.setState('paused');
          return;
        }
        // 埋め込みは API を積まずに済むよう iframe ごと捨てる（＝ポスターに戻る）。
        if (this.frameSlot) this.frameSlot.textContent = '';
        this.setState('idle');
      }

      /**
       * タブが隠れているあいだは止める。戻ってきたときは、
       * 「自動再生 ＆ 画面内 ＆ 利用者が自分で止めていない」ときだけ再開する。
       * （ここで再開しないと、自動再生バナーがタブ切替のあと二度と動かなくなる）
       */
      onVisibility() {
        if (document.hidden) {
          if (this.getAttribute('data-state') === 'playing') {
            this.resumeOnReturn = true;
            this.pause();
          }
          return;
        }
        if (
          this.resumeOnReturn &&
          this.wantsAutoplay &&
          !this.userPaused &&
          !this.reduce.matches &&
          this.inView !== false
        ) {
          this.resumeOnReturn = false;
          this.play(true);
        }
      }
    }

    customElements.define('cvb-video', CvbVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  /**
   * <cs-countdown data-deadline="ISO" data-expire="message|hide">
   *
   *  - 桁は <span data-unit="days|hours|minutes|seconds"> を個別に textContent 更新する
   *    （innerHTML の全書き換えをしない ＝ 毎秒のリフローを最小にする）
   *  - 表示していない単位の分は 1 つ上の単位に繰り上げて累積させる
   *    （「時」だけ表示なら 3300 時間のように出る）
   *  - タブが隠れているあいだは setInterval を止める
   *  - 読み上げは 1 分に 1 回だけ更新する隠しテキストが担当。桁側は aria-hidden。
   */
  (function () {
    'use strict';

    if (window.customElements === undefined || customElements.get('cs-countdown')) return;

    var ORDER = ['days', 'hours', 'minutes', 'seconds'];
    var SECONDS_IN = { days: 86400, hours: 3600, minutes: 60, seconds: 1 };

    function pad2(n) {
      var s = String(n);
      return s.length < 2 ? '0' + s : s;
    }

    class CsCountdown extends HTMLElement {
      connectedCallback() {
        var self = this;

        this.cells = {};
        Array.prototype.forEach.call(this.querySelectorAll('[data-unit]'), function (el) {
          self.cells[el.getAttribute('data-unit')] = el;
        });
        this.remaining = this.querySelector('[data-cd-remaining]');
        this.root = this.closest('[data-cdb-root]');
        this.designMode = !!(window.Shopify && window.Shopify.designMode);
        this.srKey = null;
        this.timer = null;

        var raw = (this.getAttribute('data-deadline') || '').trim();
        var parsed = raw ? Date.parse(raw) : NaN;

        // 解釈できない日時でセクションを黙って消さない。理由が見える状態に落とす。
        if (!raw || isNaN(parsed)) {
          this.deadline = null;
          this.setAttribute('data-state', 'invalid');
          return;
        }

        this.deadline = parsed;
        this.setAttribute('data-state', 'running');

        this.onVisibility = this.onVisibility.bind(this);
        this.onTick = this.tick.bind(this);
        document.addEventListener('visibilitychange', this.onVisibility);

        this.tick();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) {
          document.removeEventListener('visibilitychange', this.onVisibility);
        }
      }

      onVisibility() {
        if (document.hidden) {
          this.stop();
          return;
        }
        this.tick();
        this.start();
      }

      start() {
        if (this.timer || this.getAttribute('data-state') !== 'running') return;
        this.timer = setInterval(this.onTick, 1000);
      }

      stop() {
        if (!this.timer) return;
        clearInterval(this.timer);
        this.timer = null;
      }

      tick() {
        if (this.deadline === null || this.deadline === undefined) return;

        var diff = this.deadline - Date.now();
        if (diff <= 0) {
          this.expire();
          return;
        }

        var total = Math.floor(diff / 1000);
        var rest = total;
        var i, key, cell, value, text;

        for (i = 0; i < ORDER.length; i++) {
          key = ORDER[i];
          cell = this.cells[key];
          if (!cell) continue;
          value = Math.floor(rest / SECONDS_IN[key]);
          rest -= value * SECONDS_IN[key];
          text = pad2(value);
          if (cell.textContent !== text) cell.textContent = text;
        }

        // 読み上げ用は 1 分に 1 回だけ。毎秒書き換えても意味がなく、うるさいだけ。
        var minuteKey = Math.floor(total / 60);
        if (this.remaining && minuteKey !== this.srKey) {
          this.srKey = minuteKey;
          this.remaining.textContent =
            '（残り ' +
            Math.floor(total / 86400) +
            '日 ' +
            Math.floor((total % 86400) / 3600) +
            '時間 ' +
            Math.floor((total % 3600) / 60) +
            '分）';
        }
      }

      expire() {
        var self = this;
        this.stop();

        Object.keys(this.cells).forEach(function (key) {
          self.cells[key].textContent = '00';
        });
        if (this.remaining) this.remaining.textContent = '';

        this.setAttribute('data-state', 'ended');

        // エディタ内では隠さない（隠すとマーチャントが編集できなくなる）
        if (this.getAttribute('data-expire') === 'hide' && this.root && !this.designMode) {
          this.root.hidden = true;
        }
      }
    }

    customElements.define('cs-countdown', CsCountdown);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  /**
   * featured-blog
   * - 矢印による scrollBy（端で disabled + aria-disabled）
   * - 端フェードの ON/OFF
   * - 送る先が無い幅では data-fb-static を立てて矢印ごと隠す
   * JS が動かない場合はこのクラスが定義されず data-fb-ready も付かないため、
   * CSS 側は「矢印非表示・フェードなし」のまま＝記事はネイティブ横スクロールで全件読める。
   */
  if (!customElements.get('featured-blog')) {
    customElements.define(
      'featured-blog',
      class FeaturedBlog extends HTMLElement {
        connectedCallback() {
          if (this.dataset.fbReady !== undefined) return;

          this.track = this.querySelector('.fblog__track');
          if (!this.track) return;

          this.arrows = Array.prototype.slice.call(this.querySelectorAll('[data-fb-dir]'));
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.ticking = false;

          this.onArrowClick = this.onArrowClick.bind(this);
          this.onScroll = this.onScroll.bind(this);
          this.sync = this.sync.bind(this);

          this.arrows.forEach(
            function (btn) {
              btn.addEventListener('click', this.onArrowClick);
            }.bind(this)
          );
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.sync);
            this.ro.observe(this);
          } else {
            window.addEventListener('resize', this.sync);
          }

          this.dataset.fbReady = '';
          this.sync();
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
        }

        onArrowClick(event) {
          var btn = event.currentTarget;
          if (btn.disabled) return;

          var item = this.track.querySelector('.fblog__item');
          var styles = window.getComputedStyle(this.track);
          var gap = parseFloat(styles.columnGap || styles.gap) || 0;
          var unit = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
          // 1画面に収まる枚数だけまとめて送る（最低1枚）
          var count = Math.max(1, Math.floor(this.track.clientWidth / unit));
          var delta = unit * count * (btn.dataset.fbDir === 'prev' ? -1 : 1);

          this.track.scrollBy({ left: delta, behavior: this.reduced.matches ? 'auto' : 'smooth' });
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(
            function () {
              this.ticking = false;
              this.sync();
            }.bind(this)
          );
        }

        sync() {
          var max = this.track.scrollWidth - this.track.clientWidth;
          var x = this.track.scrollLeft;
          var canPrev = x > 1;
          var canNext = x < max - 1;

          this.track.toggleAttribute('data-fb-can-prev', canPrev);
          this.track.toggleAttribute('data-fb-can-next', canNext);
          this.toggleAttribute('data-fb-static', max <= 1);

          this.arrows.forEach(
            function (btn) {
              var enabled = btn.dataset.fbDir === 'prev' ? canPrev : canNext;
              // 無効化する矢印にフォーカスが乗っていたら反対側へ逃がす（フォーカス消失の防止）
              if (!enabled && document.activeElement === btn) {
                var other = this.arrows.find(function (b) {
                  return b !== btn;
                });
                if (other && !other.disabled) other.focus();
              }
              btn.disabled = !enabled;
              btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
            }.bind(this)
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  /**
   * featured-collection（layout = slider のときだけDOMに出る）
   * - 矢印による scrollBy（端で disabled + aria-disabled）
   * - 端フェードの ON/OFF
   * - スクロール不要な件数なら矢印ごと引っ込める
   * JSが動かない場合は data-fc-ready が付かないため、CSS側は「矢印非表示」のまま＝
   * トラックはネイティブ横スクロール（指・トラックパッド・tab+矢印キー）で全部読める。
   */
  if (!customElements.get('featured-collection')) {
    customElements.define(
      'featured-collection',
      class FeaturedCollection extends HTMLElement {
        connectedCallback() {
          if (this.dataset.fcReady !== undefined) return;

          this.rail = this.querySelector('.featured-collection__track');
          if (!this.rail) return;

          this.arrows = Array.prototype.slice.call(this.querySelectorAll('[data-fc-dir]'));
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.ticking = false;

          this.onArrowClick = this.onArrowClick.bind(this);
          this.onScroll = this.onScroll.bind(this);
          this.sync = this.sync.bind(this);

          this.arrows.forEach(
            function (btn) {
              btn.addEventListener('click', this.onArrowClick);
            }.bind(this)
          );
          this.rail.addEventListener('scroll', this.onScroll, { passive: true });

          // 遅延画像が入るとカード高さもトラック幅も変わる。都度取り直す。
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.sync);
            this.ro.observe(this.rail);
          } else {
            window.addEventListener('resize', this.sync);
          }

          this.dataset.fcReady = '';
          this.sync();
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
        }

        onArrowClick(event) {
          var btn = event.currentTarget;
          if (btn.disabled) return;

          var item = this.rail.querySelector('.featured-collection__item');
          var styles = window.getComputedStyle(this.rail);
          var gap = parseFloat(styles.columnGap || styles.gap) || 0;
          var unit = item ? item.getBoundingClientRect().width + gap : this.rail.clientWidth;
          // 1画面に収まる枚数だけまとめて送る（最低1枚）
          var count = Math.max(1, Math.floor(this.rail.clientWidth / unit));
          var delta = unit * count * (btn.dataset.fcDir === 'prev' ? -1 : 1);

          this.rail.scrollBy({ left: delta, behavior: this.reduced.matches ? 'auto' : 'smooth' });
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(
            function () {
              this.ticking = false;
              this.sync();
            }.bind(this)
          );
        }

        sync() {
          var max = this.rail.scrollWidth - this.rail.clientWidth;
          var x = this.rail.scrollLeft;
          var canPrev = x > 1;
          var canNext = x < max - 1;

          this.rail.toggleAttribute('data-fc-can-prev', canPrev);
          this.rail.toggleAttribute('data-fc-can-next', canNext);
          this.toggleAttribute('data-fc-static', max <= 1);

          this.arrows.forEach(
            function (btn) {
              var enabled = btn.dataset.fcDir === 'prev' ? canPrev : canNext;
              // 無効化する矢印にフォーカスが乗っていたら反対側へ逃がす（フォーカス消失の防止）
              if (!enabled && document.activeElement === btn) {
                var other = this.arrows.find(function (b) {
                  return b !== btn;
                });
                if (other && !other.disabled) other.focus();
              }
              btn.disabled = !enabled;
              btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
            }.bind(this)
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  // Shopify はセクションJSを1本に連結するので、必ず即時関数で閉じてから定義する。
  (function () {
    /**
     * 単品スポットライト（詳細モード）。
     *
     * ここが受け持つのは「選び直したら表示を追随させる」ことだけで、
     * 買う動線そのものは JS 抜きでも閉じている:
     *   - オプション1つ … ピルの radio が name="id" そのもの＝選ぶ＝送信値が決まる
     *   - オプション複数 … [data-fp-id] の select が name="id"＝既定値で送信できる
     *   - 数量 … input[type=number] のネイティブ矢印で増減できる
     *
     * DOM 側の前提:
     *   [data-fp-id]       … name="id" の select（オプション複数のときだけ）
     *   [data-fp-option]   … オプション別 select（同上）
     *   .fpd__pill-input   … name="id" の radio（オプション1つのときだけ）
     *   [data-fp-stepper]  … 数量ステッパーの器。中に [data-fp-step] と [data-fp-qty]
     * 状態を持つ要素はすべて data-price / data-compare / data-off / data-available /
     * data-title を持ち、表示側はそれを読むだけにしてある。
     */
    class FeaturedProductDetail extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;

        this.idSelect = this.querySelector('[data-fp-id]');
        this.optionSelects = Array.prototype.slice.call(this.querySelectorAll('[data-fp-option]'));
        this.pills = Array.prototype.slice.call(this.querySelectorAll('.fpd__pill-input'));
        this.priceEl = this.querySelector('[data-fp-price]');
        this.wasEl = this.querySelector('[data-fp-was]');
        this.compareEl = this.querySelector('[data-fp-compare]');
        this.badgeEl = this.querySelector('[data-fp-badge]');
        this.optValueEl = this.querySelector('[data-fp-optvalue]');
        this.atc = this.querySelector('[data-fp-atc]');
        this.atcLabel = this.querySelector('[data-fp-atc-label]');
        this.matched = true;

        // 初期表示は Liquid が正しく描いている。ここで sync() を呼ぶと
        // 意味のない書き換えでレイアウトを揺らすだけなので呼ばない。
        this.addEventListener('change', this.onChange.bind(this));
        this.setupStepper();
      }

      /* --- 数量ステッパー ------------------------------------------------ */

      setupStepper() {
        this.stepper = this.querySelector('[data-fp-stepper]');
        this.qty = this.querySelector('[data-fp-qty]');
        if (!this.stepper || !this.qty) return;

        this.steps = Array.prototype.slice.call(this.stepper.querySelectorAll('[data-fp-step]'));
        // ここまで来た＝JSが生きている。はじめて −/＋ を出し、
        // 同時にネイティブ矢印を畳む（is-ready がその合図）。
        this.steps.forEach(function (button) {
          button.hidden = false;
        });
        this.stepper.classList.add('is-ready');

        this.stepper.addEventListener('click', this.onStep.bind(this));
        this.qty.addEventListener('input', this.syncStepper.bind(this));
        this.syncStepper();
      }

      onStep(event) {
        const button = event.target.closest ? event.target.closest('[data-fp-step]') : null;
        if (!button || !this.stepper.contains(button)) return;
        const min = parseInt(this.qty.min, 10) || 1;
        const next = (parseInt(this.qty.value, 10) || min) + (parseInt(button.dataset.fpStep, 10) || 0);
        this.qty.value = String(Math.max(min, next));
        this.syncStepper();
      }

      /** 下限に張り付いたら「−」を無効化する（実測どおりの挙動） */
      syncStepper() {
        if (!this.steps) return;
        const min = parseInt(this.qty.min, 10) || 1;
        const value = parseInt(this.qty.value, 10) || min;
        this.steps.forEach(function (button) {
          if ((parseInt(button.dataset.fpStep, 10) || 0) < 0) button.disabled = value <= min;
        });
      }

      /* --- バリエーション ------------------------------------------------ */

      onChange(event) {
        const target = event.target;
        if (!target || !target.hasAttribute) return;
        if (target.hasAttribute('data-fp-option')) {
          this.resolve();
          this.sync();
        } else if (target.hasAttribute('data-fp-id') || target.classList.contains('fpd__pill-input')) {
          this.matched = true;
          this.sync();
        }
      }

      /** オプション select の値の組から該当バリエーションを探して name="id" に流す */
      resolve() {
        if (!this.idSelect || !this.optionSelects.length) return;
        const want = this.optionSelects.map(function (s) {
          return s.value;
        });
        const options = Array.prototype.slice.call(this.idSelect.options);
        const hit = options.find(function (option) {
          return want.every(function (value, i) {
            return (option.dataset['o' + (i + 1)] || '') === value;
          });
        });
        this.matched = !!hit;
        if (hit) this.idSelect.value = hit.value;
      }

      /** いま選ばれているバリエーションを表す要素（ピル or option）を返す */
      current() {
        if (this.pills.length) {
          return (
            this.pills.find(function (input) {
              return input.checked;
            }) || null
          );
        }
        if (!this.idSelect) return null;
        return this.idSelect.options[this.idSelect.selectedIndex] || null;
      }

      sync() {
        const source = this.current();
        const data = source ? source.dataset : {};
        const sellable = this.matched && !!source && data.available === 'true';

        if (this.priceEl && data.price) this.priceEl.textContent = data.price;
        if (this.optValueEl && data.title) this.optValueEl.textContent = data.title;

        const onSale = this.matched && !!data.compare;
        if (this.wasEl) this.wasEl.hidden = !onSale;
        if (this.compareEl && onSale) this.compareEl.textContent = data.compare;
        if (this.badgeEl) {
          this.badgeEl.hidden = !(onSale && data.off);
          if (onSale && data.off) this.badgeEl.textContent = 'SALE ' + data.off + '%';
        }

        if (this.atc) this.atc.disabled = !sellable;
        if (this.atcLabel) {
          if (!this.matched) {
            this.atcLabel.textContent = this.dataset.unavailableLabel || '';
          } else {
            this.atcLabel.textContent = sellable
              ? this.dataset.addLabel || ''
              : this.dataset.soldLabel || '';
          }
        }
      }
    }

    if (!customElements.get('featured-product-detail')) {
      customElements.define('featured-product-detail', FeaturedProductDetail);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * スクロールトップ FAB + 進捗リング。
   * show_scroll_top がオフのときは data-scroll-top が DOM に無いので完全な no-op。
   *
   *   dashoffset = 163.36 × (1 − scrollY / (scrollHeight − innerHeight))  … 完全線形
   *   scrollY > 150 で表示（実測）
   *
   * scroll は passive + rAF スロットル。スクロールは reduced-motion を尊重する。
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    var CIRCUMFERENCE = 163.36; /* r=26 の円周 */
    var SHOW_AT = 150;

    function prefersReduced() {
      return (
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    function setup(button) {
      if (button.dataset.totopReady === 'true') return;
      button.dataset.totopReady = 'true';

      var ring = button.querySelector('[data-scroll-progress]');
      var ticking = false;

      function sync() {
        var doc = document.documentElement;
        var y = window.pageYOffset || doc.scrollTop || 0;
        var max = doc.scrollHeight - window.innerHeight;
        var progress = max > 0 ? Math.min(y / max, 1) : 0;
        if (ring) {
          ring.style.strokeDashoffset = (CIRCUMFERENCE * (1 - progress)).toFixed(2);
        }
        button.classList.toggle('is-shown', y > SHOW_AT);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          sync();
        });
      }

      button.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: prefersReduced() ? 'auto' : 'smooth' });
      });

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      sync();
    }

    function init(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var found = root.querySelectorAll('[data-scroll-top]');
      for (var i = 0; i < found.length; i++) setup(found[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * reveal スティッキーヘッダー（sticky_mode = "reveal" のときだけ DOM に
   * data-header-reveal が出るので、既定の "always" では何も掴まず完全な no-op）。
   *
   *   scrollY <= 350 … パーク（sticky top:-100vh ＝ 実質フロー）
   *   scrollY >  350 … top:0 に貼り付け、translateY(-100%) → 0 を 1s ease-in-out
   *
   * scroll は passive + rAF スロットル。閾値をまたいだ瞬間だけクラスを触る。
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    var FALLBACK_THRESHOLD = 350;

    function prefersReduced() {
      return (
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    function setup(header) {
      if (header.dataset.revealReady === 'true') return;
      header.dataset.revealReady = 'true';
      header.classList.add('site-header--reveal');

      var threshold = parseFloat(header.dataset.headerReveal);
      if (!(threshold > 0)) threshold = FALLBACK_THRESHOLD;

      var ticking = false;
      var revealed = null;

      function apply() {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        var next = y > threshold;
        if (next === revealed) return;
        revealed = next;
        if (next) {
          header.classList.remove('is-hiding');
          header.classList.add('is-revealed');
          return;
        }
        header.classList.remove('is-revealed');
        if (prefersReduced()) {
          header.classList.remove('is-hiding');
        } else {
          header.classList.add('is-hiding');
        }
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          apply();
        });
      }

      header.addEventListener('animationend', function (event) {
        if (event.animationName === 'site-header-reveal-out') {
          header.classList.remove('is-hiding');
        }
      });

      window.addEventListener('scroll', onScroll, { passive: true });
      apply();
    }

    function init(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var found = root.querySelectorAll('[data-header-reveal]');
      for (var i = 0; i < found.length; i++) setup(found[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    /* テーマエディタでセクションを編集すると DOM が差し替わる */
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /**
   * cs-compare — before/after の境界コントロール
   *
   * 操作は3経路。どれも同じ apply() に集約する。
   *   1. ポインタドラッグ（pointerdown/move/up + setPointerCapture）
   *   2. キーボード（実体が <input type="range"> なので矢印キーはネイティブ）
   *   3. タッチ（pointer events が兼ねる）
   *
   * ネイティブ range のポインタ挙動（クリックでつまみが飛ぶ）は
   * pointerdown の preventDefault で止め、位置決めは自前の計算に一本化する。
   * preventDefault はフォーカス移動も止めるので focus() を明示的に呼ぶ。
   */
  (function () {
    'use strict';

    var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

    class CsCompare extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.range = this.querySelector('.image-comparison__range');
        if (!this.range) return;

        // CSS はこの属性を見てつまみを出し、仕切り線につまみぶんの切れ目を作る
        this.dataset.ready = 'true';
        this.range.hidden = false;

        this.vertical = this.getAttribute('data-layout') === 'vertical';
        this.labelBefore = this.range.getAttribute('data-label-before') || 'Before';
        this.labelAfter = this.range.getAttribute('data-label-after') || 'After';
        this.dragging = false;

        this.onInput = this.onInput.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        this.range.addEventListener('input', this.onInput);
        if (this.vertical) this.range.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('pointerdown', this.onDown);
        this.addEventListener('pointermove', this.onMove);
        this.addEventListener('pointerup', this.onUp);
        this.addEventListener('pointercancel', this.onUp);

        this.apply(Number(this.range.value));
        this.intro();
      }

      disconnectedCallback() {
        if (this.io) {
          this.io.disconnect();
          this.io = null;
        }
      }

      /** 初回の 10% → 50%。実測 0.7s cubic-bezier(.7,0,.3,1) */
      intro() {
        if (REDUCE.matches) return; // 動きを減らす設定では最初から 50%

        var rect = this.getBoundingClientRect();
        // 読み込み時点で既に見えているものは動かさない。
        // ここで 10% に落とすと 50%（CSS の初期値）からの巻き戻しが一度見えてしまう。
        if (rect.top < window.innerHeight && rect.bottom > 0) return;

        this.apply(10);

        var self = this;
        this.io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue;
              self.disconnectedCallback();
              self.classList.add('is-intro');
              self.getBoundingClientRect(); // 10% を確定させてから 50% へ（同フレーム結合の回避）
              self.apply(50);
              self.introTimer = window.setTimeout(function () {
                self.classList.remove('is-intro');
              }, 800);
              return;
            }
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
        );
        this.io.observe(this);
      }

      apply(value) {
        var p = Math.round(value);
        if (!isFinite(p)) p = 50;
        p = Math.max(0, Math.min(100, p));

        this.style.setProperty('--ic-percent', p + '%');
        if (Number(this.range.value) !== p) this.range.value = String(p);
        this.range.setAttribute(
          'aria-valuetext',
          this.labelBefore + ' ' + p + '% / ' + this.labelAfter + ' ' + (100 - p) + '%'
        );
      }

      onInput() {
        this.apply(Number(this.range.value));
      }

      /**
       * 縦レイアウトだけ上下キーを反転する。
       * --ic-percent は「上端からの距離」なので、ネイティブの ArrowUp（値を増やす）は
       * 境界を下へ動かしてしまう。見た目の方向と手の動きを合わせる。
       */
      onKeyDown(e) {
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        e.preventDefault();
        this.apply(Number(this.range.value) + (e.key === 'ArrowUp' ? -1 : 1));
      }

      onDown(e) {
        if (e.button > 0) return;
        e.preventDefault();

        if (this.introTimer) {
          window.clearTimeout(this.introTimer);
          this.introTimer = null;
        }
        this.classList.remove('is-intro'); // 掴んだ瞬間から指に張り付かせる

        this.dragging = true;
        this.classList.add('is-dragging');
        try {
          this.setPointerCapture(e.pointerId);
        } catch (err) {
          /* 捕捉できない環境ではバブリングのまま続行する */
        }
        try {
          this.range.focus({ preventScroll: true });
        } catch (err) {
          this.range.focus();
        }
        this.fromPointer(e);
      }

      onMove(e) {
        if (!this.dragging) return;
        e.preventDefault();
        this.fromPointer(e);
      }

      onUp(e) {
        if (!this.dragging) return;
        this.dragging = false;
        this.classList.remove('is-dragging');
        try {
          this.releasePointerCapture(e.pointerId);
        } catch (err) {
          /* 既に解放済み */
        }
      }

      fromPointer(e) {
        var r = this.getBoundingClientRect();
        if (this.vertical) {
          if (!r.height) return;
          this.apply(((e.clientY - r.top) / r.height) * 100);
          return;
        }
        if (!r.width) return;
        var rtl = window.getComputedStyle(this).direction === 'rtl';
        var x = rtl ? r.right - e.clientX : e.clientX - r.left;
        this.apply((x / r.width) * 100);
      }
    }

    if (!customElements.get('cs-compare')) customElements.define('cs-compare', CsCompare);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-announcement-bar"]) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <lc-announcement>
   *   1. 矢印を出す（JS が動いたときだけ＝死んだ UI を見せない）
   *   2. 1件ぶんスクロールさせ、端で disabled にする
   *   3. 言語 select を change で送信し、no-JS 用の「適用」ボタンを隠す
   * 送り自体はネイティブの scroll-snap に委譲する（local.js の lc-slider と同方針）。
   * ------------------------------------------------------------------------ */
  (function () {
    if (!window.customElements || customElements.get('lc-announcement')) return;

    class LcAnnouncement extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.setupLocalization();

        this.track = this.querySelector('[data-lc-anb-track]');
        if (!this.track) return;
        this.items = Array.prototype.slice.call(this.track.children);
        if (this.items.length < 2) return;

        this.prev = this.querySelector('[data-lc-anb-prev]');
        this.next = this.querySelector('[data-lc-anb-next]');
        if (!this.prev || !this.next) return;

        this.prev.hidden = false;
        this.next.hidden = false;
        this.prev.addEventListener('click', this.step.bind(this, -1));
        this.next.addEventListener('click', this.step.bind(this, 1));

        this.onScroll = this.sync.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.sync();
      }

      disconnectedCallback() {
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
      }

      setupLocalization() {
        var form = this.querySelector('.lc-anb__form');
        if (!form) return;
        var submit = form.querySelector('[data-lc-anb-loc-submit]');
        if (submit) submit.hidden = true;
        Array.prototype.forEach.call(form.querySelectorAll('select'), function (select) {
          select.addEventListener('change', function () {
            form.submit();
          });
        });
      }

      step(dir) {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: dir * this.track.clientWidth,
          behavior: reduced ? 'auto' : 'smooth',
        });
      }

      sync() {
        /* 端の判定は 1px 余裕を持たせる（小数のスクロール位置で端に届かない環境がある） */
        var max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft >= max - 1;
      }
    }

    customElements.define('lc-announcement', LcAnnouncement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * カートドロワー（Local）の上乗せ挙動
   *   1. 数量 ± / 削除 を /cart/change.js に差し替え、セクション再描画で反映
   *   2. data-lc-atc を持つフォーム（商品ページの「カートに入れる」）を横取りし、
   *      /cart/add.js → 再描画 → ドロワーを開く
   *   3. JS があるときだけ意味を持つ要素（閉じるボタン）を出す
   * 開閉そのもの・フォーカス管理・暗幕・Escape は local.js §4（<lc-drawer>）が持つ。
   * 失敗したら必ず素のリンク / 素の POST に落とす（規約9）。
   * ------------------------------------------------------------------------ */
  (function () {
    if (document.documentElement.dataset.design !== 'local') return;
    if (window.lcCartDrawerBound) return;
    window.lcCartDrawerBound = true;

    var ID = 'LcCartDrawer';

    function root() {
      return document.getElementById(ID);
    }

    /** JS 前提の要素を出す。再描画のたびに呼ぶ（innerHTML ごと入れ替わるため）。 */
    function reveal(el) {
      Array.prototype.forEach.call(el.querySelectorAll('[data-lc-cd-js]'), function (node) {
        node.hidden = false;
      });
    }

    /** ヘッダーのカートバッジ。要素が無い環境でも黙って何もしない。 */
    function syncCount(count) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (badge) {
        badge.textContent = count;
        badge.hidden = count === '0';
      });
    }

    function busy(el, on) {
      var body = el.querySelector('.lc-cd__body');
      if (body) body.classList.toggle('lc-is-disabled', on);
    }

    /**
     * {cart_url}?section_id={id} でこのセクションだけ描き直す。
     * live な <lc-drawer> は差し替えず innerHTML だけ入れ替える
     * （要素ごと替えると custom element の identity と .is-open が飛ぶ）。
     */
    function render() {
      var el = root();
      if (!el) return Promise.reject(new Error('drawer missing'));
      var base = el.dataset.cartUrl;
      var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + el.dataset.sectionId;
      var note = el.querySelector('textarea[name="note"]');
      var typed = note ? note.value : null;

      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error('section ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var next = new DOMParser().parseFromString(html, 'text/html').getElementById(ID);
          if (!next) throw new Error('section markup missing');
          el.innerHTML = next.innerHTML;
          el.dataset.count = next.dataset.count || '0';
          syncCount(el.dataset.count);
          reveal(el);
          /* 打ちかけのメモを消さない（サーバー側の cart.note はまだ空） */
          var again = el.querySelector('textarea[name="note"]');
          if (again && typed !== null) again.value = typed;
          /* 開いたまま描き直すとフォーカスが宙に浮くので、閉じるボタンへ戻す */
          if (el.classList.contains('is-open')) {
            var close = el.querySelector('[data-lc-drawer-close]');
            if (close) close.focus();
          }
        });
    }

    function openDrawer() {
      var el = root();
      if (el && typeof el.open === 'function') el.open();
    }

    document.addEventListener('click', function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      var link = e.target.closest('[data-lc-cd-change]');
      if (!link) return;
      var el = root();
      if (!el || !el.contains(link) || !window.fetch) return;
      e.preventDefault();
      busy(el, true);
      fetch(el.dataset.cartChangeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(link.dataset.lcCdLine),
          quantity: Number(link.dataset.lcCdQty),
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('change ' + res.status);
          return res.json();
        })
        .then(function () {
          /* ここから先の失敗でリンクを踏み直すと、削除（quantity=0）が
             「ずれた行番号」で二重に適用される。変更は通っているので
             同じ変更を再送せず、カートページに移して結果を見せる。 */
          return render().catch(function () {
            window.location.href = el.dataset.cartUrl;
          });
        })
        .catch(function () {
          /* 変更そのものが通らなかったときだけ、素のリンク（GET）に落とす */
          window.location.href = link.href;
        })
        .then(function () {
          busy(el, false);
        });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || typeof form.matches !== 'function' || !form.matches('[data-lc-atc]')) return;
      var el = root();
      if (!el || !window.fetch || !window.FormData) return;
      e.preventDefault();
      form.classList.add('lc-is-disabled');
      fetch(el.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add ' + res.status);
          return res.json();
        })
        .then(function () {
          /* 追加は通っている。ここで form.submit() に落とすと同じ商品が
             2回入るので、再描画に失敗したらカートページへ移すだけにする。 */
          return render()
            .then(openDrawer)
            .catch(function () {
              window.location.href = el.dataset.cartUrl;
            });
        })
        .catch(function () {
          /* 追加そのものが通らなかったときだけ素の POST に任せる
             （submit() はこのハンドラを再入させない） */
          form.classList.remove('lc-is-disabled');
          form.submit();
        })
        .then(function () {
          form.classList.remove('lc-is-disabled');
        });
    });

    function init() {
      var el = root();
      if (el) reveal(el);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    /* テーマエディタでこのセクションが描き直されたとき */
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-faq"] && !Shopify.designMode) return;
  try {
    
  /**
   * <lc-faq-list> — <details> の開閉に 200ms の高さ補間だけを足す層。
   *
   * 来る前（＝JS 無し / reduced-motion）の状態:
   *   ・素の <details>/<summary>。クリックでもキーボードでも開閉でき、
   *     aria-expanded は UA が管理する。内容は常に到達可能。
   * 来た後にやること:
   *   ・summary の既定動作を横取りし、パネルの height を 0 ↔ 実高さで補間する。
   *     実測（component-toggle.js）の 200ms / linear に合わせる。
   *
   * 失敗しても素の <details> に戻るだけ（open 属性は必ず正しい側に着地させる）。
   */
  (() => {
    'use strict';

    // 実測: transitionDuration = 200ms（jQuery slideUp/slideDown 相当の自作実装）
    const DURATION = 200;

    class LcFaqList extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.querySelectorAll('details.lc-faq__tab').forEach((tab) => {
          const summary = tab.querySelector('summary');
          const panel = tab.querySelector('[data-lcfaq-panel]');
          if (!summary || !panel) return;

          summary.addEventListener('click', (event) => {
            // 動きを止める設定のときは何もしない（UA の即時開閉に任せる）
            if (this.motion.matches) return;
            event.preventDefault();
            if (tab.dataset.lcBusy === 'true') return;

            if (tab.open) {
              this.slide(tab, panel, panel.scrollHeight, 0, () => {
                tab.open = false;
              });
            } else {
              // 高さを測るには先に開いている必要がある
              tab.open = true;
              this.slide(tab, panel, 0, panel.scrollHeight, null);
            }
          });
        });
      }

      disconnectedCallback() {
        this.dataset.lcReady = 'false';
      }

      slide(tab, panel, from, to, done) {
        tab.dataset.lcBusy = 'true';
        panel.style.overflow = 'hidden';
        panel.style.height = from + 'px';

        // 強制リフロー。挟まないと from が初期値として採用されず補間が始まらない。
        void panel.offsetHeight;

        panel.style.transition = 'height ' + DURATION + 'ms linear';
        panel.style.height = to + 'px';

        const finish = () => {
          window.clearTimeout(timer);
          panel.removeEventListener('transitionend', onEnd);
          panel.style.transition = '';
          panel.style.height = '';
          panel.style.overflow = '';
          tab.dataset.lcBusy = 'false';
          if (done) done();
        };

        const onEnd = (event) => {
          if (event.target !== panel || event.propertyName !== 'height') return;
          finish();
        };

        // transitionend が来ない環境（タブ非表示中など）でも必ず着地させる保険
        const timer = window.setTimeout(finish, DURATION + 80);
        panel.addEventListener('transitionend', onEnd);
      }
    }

    if (!window.customElements.get('lc-faq-list')) {
      window.customElements.define('lc-faq-list', LcFaqList);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-featured-collection"] && !Shopify.designMode) return;
  try {
    
  /**
   * <lc-fcoll-tabs> — 「リンク列」を「タブ」に格上げするだけの薄い要素。
   *
   * 来る前（＝JS 無し）の状態:
   *   ・タブは素の <a href="コレクションURL">。押せばそのコレクションへ移動する。
   *   ・1枚目のパネルだけが見え、2枚目以降は hidden 属性で閉じている。
   * 来た後にやること:
   *   1. role="tablist" / "tab" / "tabpanel" と aria-* を後付けする
   *      （no-JS 環境に「タブだと名乗るのに切り替わらない」嘘を残さないため、
   *        マークアップ側には一切書かない）
   *   2. クリックを横取りしてパネルの hidden を付け替える（ページ遷移しない）
   *   3. ← → Home End のローピングタブ移動（tabindex は選択中だけ 0）
   *
   * どこで失敗しても「リンク列 ＋ 1枚目のパネル」に落ちるだけで、内容は失われない。
   */
  (() => {
    'use strict';

    class LcFcollTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;

        this.tablist = this.querySelector('[data-lcfc-tablist]');
        this.tabs = Array.from(this.querySelectorAll('[data-lcfc-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-lcfc-panel]'));

        // 対応が崩れているときは何もしない（リンク列のまま。壊れるより黙って退く）
        if (!this.tablist || this.tabs.length < 2 || this.tabs.length !== this.panels.length) {
          return;
        }

        this.dataset.lcReady = 'true';
        this.index = 0;
        this.onKey = this.onKey.bind(this);

        this.tablist.setAttribute('role', 'tablist');

        this.tabs.forEach((tab, i) => {
          const panel = this.panels[i];
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.setAttribute('tabindex', '0');

          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.select(i, true);
          });
          tab.addEventListener('keydown', this.onKey);
        });

        this.select(0, false);
      }

      disconnectedCallback() {
        this.dataset.lcReady = 'false';
      }

      select(next, focus) {
        const max = this.tabs.length - 1;
        const i = Math.min(Math.max(next, 0), max);
        this.index = i;

        this.tabs.forEach((tab, n) => {
          const on = n === i;
          tab.classList.toggle('lc-btn--solid', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          // ローピング移動のため、タブ列全体で Tab キーの止まり先はひとつだけにする
          tab.setAttribute('tabindex', on ? '0' : '-1');
          this.panels[n].toggleAttribute('hidden', !on);
        });

        if (focus) this.tabs[i].focus();
      }

      onKey(event) {
        const last = this.tabs.length - 1;
        let next = null;

        if (event.key === 'ArrowRight') next = this.index >= last ? 0 : this.index + 1;
        else if (event.key === 'ArrowLeft') next = this.index <= 0 ? last : this.index - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = last;

        if (next === null) return;
        event.preventDefault();
        this.select(next, true);
      }
    }

    if (window.customElements && !customElements.get('lc-fcoll-tabs')) {
      customElements.define('lc-fcoll-tabs', LcFcollTabs);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-featured-product"] && !Shopify.designMode) return;
  try {
    
  /**
   * local-main-product.liquid の同名クラスと**同一の実装**（意図的な複製）。
   * ホームにはセクション「商品ページ本体」が無いので、こちら側にも定義が要る。
   * customElements.get() ガードがあるため、両方が同じページにあっても二重定義にならない。
   *
   * JS 無しの状態: ギャラリーは横スクロール＋サムネは #アンカー、ズームは原寸画像リンク、
   * バリアントはラジオ or variant.url リンク、数量は素の input、カート追加は素の POST。
   */
  (() => {
    'use strict';

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const define = (name, ctor) => {
      if (window.customElements && !customElements.get(name)) customElements.define(name, ctor);
    };
    const scrollBehavior = () => (reduced.matches ? 'auto' : 'smooth');

    /* --- 数量の ± ------------------------------------------------------- */
    class LcQty extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.input = this.querySelector('input[type="number"]');
        if (!this.input) return;
        this.dataset.lcReady = 'true';
        this.prepend(this.step(-1));
        this.append(this.step(1));
      }

      step(delta) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'lc-mpb__step';
        b.setAttribute('aria-label', delta < 0 ? '数量を1減らす' : '数量を1増やす');
        b.innerHTML =
          '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
          (delta < 0
            ? '<path d="M5 12h14" stroke="currentColor" stroke-width="1.6"/>'
            : '<path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.6"/>') +
          '</svg>';
        b.addEventListener('click', () => {
          const min = parseInt(this.input.min, 10) || 1;
          const now = parseInt(this.input.value, 10) || min;
          this.input.value = String(Math.max(min, now + delta));
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return b;
      }
    }
    define('lc-qty', LcQty);

    /* --- ギャラリー（サムネ送り + ライトボックス） ------------------------ */
    class LcProductGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.track = this.querySelector('.lc-mpg__track');
        this.slides = Array.from(this.querySelectorAll('[data-lc-media]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-lc-thumb]'));
        this.dialog = this.querySelector('[data-lc-zoom-dialog]');

        this.addEventListener('click', (event) => {
          const thumb = event.target.closest && event.target.closest('[data-lc-thumb]');
          if (thumb && this.contains(thumb)) {
            event.preventDefault();
            this.show(parseInt(thumb.dataset.lcThumb, 10));
            return;
          }
          const zoom = event.target.closest && event.target.closest('[data-lc-zoom]');
          if (zoom && this.contains(zoom)) this.openZoom(event, zoom);
        });

        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog || event.target.closest('[data-lc-zoom-close]')) {
              this.dialog.close();
            }
          });
        }

        if (this.track && 'IntersectionObserver' in window && this.slides.length > 1) {
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio < 0.5) return;
                this.mark(parseInt(entry.target.dataset.lcMedia, 10));
              });
            },
            { root: this.track, threshold: [0.5] }
          );
          this.slides.forEach((s) => this.io.observe(s));
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      show(position) {
        if (!this.track) return;
        const slide = this.slides.find((s) => parseInt(s.dataset.lcMedia, 10) === position);
        if (!slide) return;
        const left =
          this.track.scrollLeft +
          (slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left);
        this.track.scrollTo({ left: left, behavior: scrollBehavior() });
        this.mark(position);
      }

      mark(position) {
        this.thumbs.forEach((t) => {
          if (parseInt(t.dataset.lcThumb, 10) === position) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }

      openZoom(event, link) {
        // <dialog> を開けない環境（古い Safari 等）は素のリンク＝原寸画像に任せる
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        const source = link.closest('[data-lc-media]');
        const base = source && source.querySelector('.lc-mpg__img');
        let img = this.dialog.querySelector('[data-lc-zoom-img]');
        if (!img) {
          img = document.createElement('img');
          img.className = 'lc-mpg__dialog-img';
          img.decoding = 'async';
          img.setAttribute('data-lc-zoom-img', '');
          const slot = this.dialog.querySelector('[data-lc-zoom-slot]') || this.dialog;
          slot.prepend(img);
        }
        img.src = link.href;
        img.alt = base ? base.alt : '';
        this.dialog.showModal();
      }
    }
    define('lc-product-gallery', LcProductGallery);

    /* --- バリアント選択 --------------------------------------------------- */
    class LcVariants extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.root = this.closest('[data-lc-product]') || document;
        this.hiddenId = this.querySelector('[data-lc-variant-id]');
        this.matrix = null;
        const json = this.querySelector('[data-lc-variants-json]');
        if (json) {
          try {
            this.matrix = JSON.parse(json.textContent);
          } catch (error) {
            this.matrix = null;
          }
        }

        this.addEventListener('change', (event) => {
          const radio = event.target.closest && event.target.closest('input[name="id"]');
          if (!radio) return;
          const label = this.querySelector('[data-lc-opt-value="1"]');
          if (label) label.textContent = radio.dataset.lcValue || '';
          this.apply({
            id: radio.value,
            price: radio.dataset.price,
            compare: radio.dataset.compare,
            saving: radio.dataset.saving,
            media: parseInt(radio.dataset.media, 10) || 0,
            url: radio.dataset.url,
            available: radio.dataset.available !== 'false',
          });
        });

        this.addEventListener('click', (event) => {
          const link = event.target.closest && event.target.closest('a[data-lc-opt]');
          if (!link || !this.matrix) return;
          event.preventDefault();
          this.select(link);
        });
      }

      select(link) {
        const group = link.closest('.lc-mpv__values');
        if (group) {
          group.querySelectorAll('[data-lc-opt]').forEach((el) => el.removeAttribute('aria-current'));
        }
        link.setAttribute('aria-current', 'true');
        const label = this.querySelector('[data-lc-opt-value="' + link.dataset.lcOpt + '"]');
        if (label) label.textContent = link.dataset.lcValue || '';

        const chosen = Array.from(this.querySelectorAll('.lc-mpv__opt')).map((opt) => {
          const current = opt.querySelector('[data-lc-opt][aria-current="true"]');
          return current ? current.dataset.lcValue : null;
        });

        const variant = this.matrix.find(
          (v) => v.o.length === chosen.length && v.o.every((value, i) => value === chosen[i])
        );

        if (!variant) {
          this.apply({ id: '', price: null, compare: null, saving: null, media: 0, url: null, available: false });
        } else {
          this.apply({
            id: variant.id,
            price: variant.p,
            compare: variant.c,
            saving: variant.s,
            media: variant.m,
            url: variant.u,
            available: variant.a,
          });
        }
        this.refresh(chosen);
      }

      refresh(chosen) {
        Array.from(this.querySelectorAll('.lc-mpv__opt')).forEach((opt, index) => {
          opt.querySelectorAll('[data-lc-opt]').forEach((el) => {
            const trial = chosen.slice();
            trial[index] = el.dataset.lcValue;
            const hit = this.matrix.find(
              (v) => v.o.length === trial.length && v.o.every((value, i) => value === trial[i])
            );
            const ok = !!hit && hit.a;
            el.classList.toggle('lc-mpv__face--out', !ok);
            el.dataset.available = ok ? 'true' : 'false';
          });
        });
      }

      apply(variant) {
        if (this.hiddenId) this.hiddenId.value = variant.id || '';

        if (variant.price) {
          this.root.querySelectorAll('[data-lc-price-now]').forEach((el) => {
            el.textContent = variant.price;
          });
        }
        this.root.querySelectorAll('[data-lc-price-was]').forEach((el) => {
          const value = el.querySelector('[data-lc-price-was-value]');
          if (value) value.textContent = variant.compare || '';
          el.hidden = !variant.compare;
        });
        this.root.querySelectorAll('[data-lc-price-save]').forEach((el) => {
          const value = el.querySelector('[data-lc-price-save-value]');
          if (value) value.textContent = variant.saving || '';
          el.hidden = !variant.saving;
        });

        this.root.querySelectorAll('[data-lc-atc-button]').forEach((button) => {
          button.disabled = !variant.available;
          const label = button.querySelector('[data-lc-atc-label]');
          if (label) {
            label.textContent = variant.available ? button.dataset.lcLabel || label.textContent : '売り切れ';
          }
        });

        if (variant.media) {
          const gallery = this.root.querySelector('lc-product-gallery');
          if (gallery && typeof gallery.show === 'function') gallery.show(variant.media);
        }

        if (variant.url && this.root.hasAttribute('data-lc-url-sync') && window.history.replaceState) {
          window.history.replaceState({}, '', variant.url);
        }
      }
    }
    define('lc-variants', LcVariants);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-header"]) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <lc-header>
   *   1. JS でしか意味を持たないボタン（バーガー・ドロワーの閉じる）を出す
   *   2. 固定バーを共有エンジン window.LcStickyHeader に預ける
   *      （基準要素は下段バー。≤1023 では display:none で rect が全ゼロになり
   *        しきい値 -100px を満たさない＝モバイルでは出ない）
   *   3. メガメニューの Escape 閉じ。開閉自体は CSS（hover / :focus-within）が持つ。
   * 開閉を JS に持たせないので、JS が落ちてもキーボードとポインタで全リンクに届く。
   * ------------------------------------------------------------------------ */
  (function () {
    if (!window.customElements || customElements.get('lc-header')) return;

    class LcHeader extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        var root = this.closest('.shopify-section') || this.parentNode || document;
        Array.prototype.forEach.call(root.querySelectorAll('[data-lc-hdr-js]'), function (el) {
          el.hidden = false;
        });

        this.initSticky = this.initSticky.bind(this);
        if (!this.initSticky()) window.addEventListener('load', this.initSticky);

        this.hasClosed = false;
        this.onKeydown = this.onKeydown.bind(this);
        this.clearClosed = this.clearClosed.bind(this);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusin', this.clearClosed);
        /* pointerover は移動のたびに飛ぶが、hasClosed の早期 return で
           Escape 直後の1回しか走らない（pointerenter だとヘッダーに入り直すまで
           解除されず、同じ項目にポインタを戻しても開かなくなる）。 */
        this.addEventListener('pointerover', this.clearClosed);
      }

      /** local.js は defer 読込なので、まだ来ていなければ load で再試行する。 */
      initSticky() {
        if (!window.LcStickyHeader) return false;
        var bar = this.querySelector('[data-lc-hdr-sticky]');
        var ref = this.querySelector('.lc-hdr__bottom');
        if (bar && ref) window.LcStickyHeader.init(ref, bar);
        return true;
      }

      onKeydown(e) {
        if (e.key !== 'Escape') return;
        if (!e.target || typeof e.target.closest !== 'function') return;
        var item = e.target.closest('.lc-hdr__item--panel');
        if (!item) return;
        /* 先に一次リンクへ戻してから閉じる。順序を逆にすると focus() が起こす
           focusin で is-closed が即座に外れて閉じられない。 */
        var link = item.querySelector('.lc-hdr__link');
        if (link) link.focus();
        item.classList.add('is-closed');
        this.hasClosed = true;
      }

      clearClosed() {
        if (!this.hasClosed) return;
        this.hasClosed = false;
        var closed = this.querySelectorAll('.lc-hdr__item--panel.is-closed');
        Array.prototype.forEach.call(closed, function (el) {
          el.classList.remove('is-closed');
        });
      }
    }

    customElements.define('lc-header', LcHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-main-article"]) return;
  try {
    
  /**
   * 記事のシェア。Web Share API →（無ければ）クリップボード。
   * この JS が無くても記事は全て読めるので、ボタンは hidden で出して
   * ここで外す（押しても何も起きないボタンを残さないため）。
   * ボタンは1ページに1つだが、テーマエディタの再描画に備えて委譲で拾う。
   */
  (() => {
    'use strict';

    const SELECTOR = '[data-lcma-share]';
    const NOTE_MS = 2400;

    function note(btn, text) {
      const box = btn.parentElement && btn.parentElement.querySelector('.lcma__share-note');
      if (!box) return;
      box.textContent = text;
      window.clearTimeout(Number(box.dataset.lcmaTimer));
      box.dataset.lcmaTimer = String(
        window.setTimeout(() => {
          box.textContent = '';
        }, NOTE_MS)
      );
    }

    /** clipboard API が使えない文脈（http・古い WebView）の最後の手段。 */
    function legacyCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.insetBlockStart = '-1000px';
      document.body.appendChild(ta);
      ta.select();
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (err) {
        ok = false;
      }
      document.body.removeChild(ta);
      return ok;
    }

    async function share(btn) {
      const url = btn.dataset.shareUrl;
      if (!url) return;
      const title = btn.dataset.shareTitle || document.title;

      if (typeof navigator.share === 'function') {
        try {
          await navigator.share({ title: title, url: url });
          return;
        } catch (err) {
          // 共有シートを閉じただけのときは何も知らせない
          if (err && err.name === 'AbortError') return;
        }
      }

      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        try {
          await navigator.clipboard.writeText(url);
          note(btn, 'リンクをコピーしました');
          return;
        } catch (err) {
          // 権限拒否・非セキュアコンテキスト → 下の手動コピーへ
        }
      }

      note(btn, legacyCopy(url) ? 'リンクをコピーしました' : url);
    }

    function reveal(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll(SELECTOR).forEach((btn) => {
        btn.hidden = false;
      });
    }

    document.addEventListener('click', (event) => {
      const target = event.target;
      const btn = target && target.closest ? target.closest(SELECTOR) : null;
      if (btn) share(btn);
    });

    document.addEventListener('shopify:section:load', (event) => reveal(event.target));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => reveal(document));
    } else {
      reveal(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-main-collection"] && !Shopify.designMode) return;
  try {
    
  /**
   * <lc-facets> — 素の GET フォームに「開閉の排他」と「並べ替えの即時送信」を足すだけ。
   *
   * 来る前（＝JS 無し）の状態:
   *   ・<details> は普通に開閉する（複数同時に開くだけ）
   *   ・各パネルの「適用」で条件が送られる
   *   ・並べ替えは select の隣の「並べ替える」ボタンで送られる
   * 来た後にやること:
   *   1. ひとつ開いたら他を閉じる（toggle は bubble しないので capture で拾う）
   *   2. 外側クリック / Escape で閉じる（Escape はフォーカスを summary に戻す）
   *   3. 「並べ替える」ボタンを hidden にし、select の change で form を送る
   *
   * どこで失敗しても素のフォームに落ちるだけで、絞り込みも並べ替えも失われない。
   */
  (() => {
    'use strict';

    class LcFacets extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.form = this.querySelector('form');
        this.groups = Array.from(this.querySelectorAll('details'));

        this.onToggle = this.onToggle.bind(this);
        this.onDocClick = this.onDocClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        // toggle は bubble しないが、capture 中は祖先にも届く
        this.addEventListener('toggle', this.onToggle, true);
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKeydown);

        const select = this.querySelector('[data-lc-sort]');
        const go = this.querySelector('[data-lc-sort-go]');
        if (select && this.form) {
          if (go) go.hidden = true;
          select.addEventListener('change', () => {
            if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
            else this.form.submit();
          });
        }
      }

      disconnectedCallback() {
        this.dataset.lcReady = 'false';
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      onToggle(event) {
        const opened = event.target;
        if (!opened || !opened.open || this.groups.indexOf(opened) === -1) return;
        this.groups.forEach((group) => {
          if (group !== opened && group.open) group.open = false;
        });
      }

      onDocClick(event) {
        this.groups.forEach((group) => {
          if (group.open && !group.contains(event.target)) group.open = false;
        });
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;
        this.groups.forEach((group) => {
          if (!group.open) return;
          const inside = group.contains(document.activeElement);
          group.open = false;
          if (!inside) return;
          const summary = group.querySelector('summary');
          if (summary) summary.focus();
        });
      }
    }

    if (window.customElements && !customElements.get('lc-facets')) {
      customElements.define('lc-facets', LcFacets);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-main-product"]) return;
  try {
    
  /**
   * Local 商品ページのランタイム。
   * ここで定義するカスタム要素は local-featured-product.liquid と**同一の実装**
   * （どちらか一方だけがページにある場合でも動くよう、両方に同じ定義を置く。
   *   customElements.get() ガードがあるので二重定義にはならない）。
   *
   * 来る前（JS 無し）の状態:
   *   ・ギャラリーは横スクロール、サムネは #フラグメントのアンカー
   *   ・ズームは原寸画像へのリンク
   *   ・バリアントは radio（1オプション）か variant.url へのリンク（2オプション以上）
   *   ・数量は素の input[type=number]、カート追加は素の POST
   * 来た後にやること:
   *   1. サムネ・ズームをページ内で完結させる（スクロール＋<dialog>）
   *   2. バリアント選択でフォームの id・価格・画像・URL を同期（リロードしない）
   *   3. 数量の ± ボタン、割引コードのコピーボタンを差し込む
   *   4. 本体 ATC が画面外に出たら下部バーを出す
   * どれが落ちても素の HTML の動線が残る。
   */
  (() => {
    'use strict';

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const define = (name, ctor) => {
      if (window.customElements && !customElements.get(name)) customElements.define(name, ctor);
    };
    const scrollBehavior = () => (reduced.matches ? 'auto' : 'smooth');

    /* --- 数量の ± ------------------------------------------------------- */
    class LcQty extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.input = this.querySelector('input[type="number"]');
        if (!this.input) return;
        this.dataset.lcReady = 'true';
        this.prepend(this.step(-1));
        this.append(this.step(1));
      }

      step(delta) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'lc-mpb__step';
        b.setAttribute('aria-label', delta < 0 ? '数量を1減らす' : '数量を1増やす');
        b.innerHTML =
          '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
          (delta < 0
            ? '<path d="M5 12h14" stroke="currentColor" stroke-width="1.6"/>'
            : '<path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.6"/>') +
          '</svg>';
        b.addEventListener('click', () => {
          const min = parseInt(this.input.min, 10) || 1;
          const now = parseInt(this.input.value, 10) || min;
          this.input.value = String(Math.max(min, now + delta));
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return b;
      }
    }
    define('lc-qty', LcQty);

    /* --- ギャラリー（サムネ送り + ライトボックス） ------------------------ */
    class LcProductGallery extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.track = this.querySelector('.lc-mpg__track');
        this.slides = Array.from(this.querySelectorAll('[data-lc-media]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-lc-thumb]'));
        this.dialog = this.querySelector('[data-lc-zoom-dialog]');

        this.addEventListener('click', (event) => {
          const thumb = event.target.closest && event.target.closest('[data-lc-thumb]');
          if (thumb && this.contains(thumb)) {
            event.preventDefault();
            this.show(parseInt(thumb.dataset.lcThumb, 10));
            return;
          }
          const zoom = event.target.closest && event.target.closest('[data-lc-zoom]');
          if (zoom && this.contains(zoom)) this.openZoom(event, zoom);
        });

        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            // 画像の外（＝dialog そのもの）を押したら閉じる
            if (event.target === this.dialog || event.target.closest('[data-lc-zoom-close]')) {
              this.dialog.close();
            }
          });
        }

        if (this.track && 'IntersectionObserver' in window && this.slides.length > 1) {
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio < 0.5) return;
                this.mark(parseInt(entry.target.dataset.lcMedia, 10));
              });
            },
            { root: this.track, threshold: [0.5] }
          );
          this.slides.forEach((s) => this.io.observe(s));
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      /** position（1始まり・product.images の position と同じ）のスライドへ送る */
      show(position) {
        if (!this.track) return;
        const slide = this.slides.find((s) => parseInt(s.dataset.lcMedia, 10) === position);
        if (!slide) return;
        const left =
          this.track.scrollLeft +
          (slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left);
        this.track.scrollTo({ left: left, behavior: scrollBehavior() });
        this.mark(position);
      }

      mark(position) {
        this.thumbs.forEach((t) => {
          if (parseInt(t.dataset.lcThumb, 10) === position) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }

      openZoom(event, link) {
        // <dialog> を開けない環境（古い Safari 等）は素のリンク＝原寸画像に任せる
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        const source = link.closest('[data-lc-media]');
        const base = source && source.querySelector('.lc-mpg__img');
        let img = this.dialog.querySelector('[data-lc-zoom-img]');
        if (!img) {
          img = document.createElement('img');
          img.className = 'lc-mpg__dialog-img';
          img.decoding = 'async';
          img.setAttribute('data-lc-zoom-img', '');
          const slot = this.dialog.querySelector('[data-lc-zoom-slot]') || this.dialog;
          slot.prepend(img);
        }
        img.src = link.href;
        img.alt = base ? base.alt : '';
        this.dialog.showModal();
      }
    }
    define('lc-product-gallery', LcProductGallery);

    /* --- バリアント選択 --------------------------------------------------- */
    class LcVariants extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.root = this.closest('[data-lc-product]') || document;
        this.hiddenId = this.querySelector('[data-lc-variant-id]');
        this.matrix = null;
        const json = this.querySelector('[data-lc-variants-json]');
        if (json) {
          try {
            this.matrix = JSON.parse(json.textContent);
          } catch (error) {
            this.matrix = null;
          }
        }

        this.addEventListener('change', (event) => {
          const radio = event.target.closest && event.target.closest('input[name="id"]');
          if (!radio) return;
          const label = this.querySelector('[data-lc-opt-value="1"]');
          if (label) label.textContent = radio.dataset.lcValue || '';
          this.apply({
            id: radio.value,
            price: radio.dataset.price,
            compare: radio.dataset.compare,
            saving: radio.dataset.saving,
            media: parseInt(radio.dataset.media, 10) || 0,
            url: radio.dataset.url,
            available: radio.dataset.available !== 'false',
          });
        });

        this.addEventListener('click', (event) => {
          const link = event.target.closest && event.target.closest('a[data-lc-opt]');
          if (!link || !this.matrix) return; // 表が無ければリロードで選ぶ（素のリンク）
          event.preventDefault();
          this.select(link);
        });
      }

      select(link) {
        const group = link.closest('.lc-mpv__values');
        if (group) {
          group.querySelectorAll('[data-lc-opt]').forEach((el) => el.removeAttribute('aria-current'));
        }
        link.setAttribute('aria-current', 'true');
        const label = this.querySelector('[data-lc-opt-value="' + link.dataset.lcOpt + '"]');
        if (label) label.textContent = link.dataset.lcValue || '';

        const chosen = Array.from(this.querySelectorAll('.lc-mpv__opt')).map((opt) => {
          const current = opt.querySelector('[data-lc-opt][aria-current="true"]');
          return current ? current.dataset.lcValue : null;
        });

        const variant = this.matrix.find(
          (v) => v.o.length === chosen.length && v.o.every((value, i) => value === chosen[i])
        );

        if (!variant) {
          // 存在しない組み合わせ。カート追加は止める（無い商品を送らない）
          this.apply({ id: '', price: null, compare: null, saving: null, media: 0, url: null, available: false });
        } else {
          this.apply({
            id: variant.id,
            price: variant.p,
            compare: variant.c,
            saving: variant.s,
            media: variant.m,
            url: variant.u,
            available: variant.a,
          });
        }
        this.refresh(chosen);
      }

      /** 他オプションの現在値と組み合わせられない値に「売り切れ」表示を付ける */
      refresh(chosen) {
        Array.from(this.querySelectorAll('.lc-mpv__opt')).forEach((opt, index) => {
          opt.querySelectorAll('[data-lc-opt]').forEach((el) => {
            const trial = chosen.slice();
            trial[index] = el.dataset.lcValue;
            const hit = this.matrix.find(
              (v) => v.o.length === trial.length && v.o.every((value, i) => value === trial[i])
            );
            const ok = !!hit && hit.a;
            el.classList.toggle('lc-mpv__face--out', !ok);
            el.dataset.available = ok ? 'true' : 'false';
          });
        });
      }

      apply(variant) {
        if (this.hiddenId) this.hiddenId.value = variant.id || '';

        if (variant.price) {
          this.root.querySelectorAll('[data-lc-price-now]').forEach((el) => {
            el.textContent = variant.price;
          });
        }
        this.root.querySelectorAll('[data-lc-price-was]').forEach((el) => {
          const value = el.querySelector('[data-lc-price-was-value]');
          if (value) value.textContent = variant.compare || '';
          el.hidden = !variant.compare;
        });
        this.root.querySelectorAll('[data-lc-price-save]').forEach((el) => {
          const value = el.querySelector('[data-lc-price-save-value]');
          if (value) value.textContent = variant.saving || '';
          el.hidden = !variant.saving;
        });

        this.root.querySelectorAll('[data-lc-atc-button]').forEach((button) => {
          button.disabled = !variant.available;
          const label = button.querySelector('[data-lc-atc-label]');
          if (label) {
            label.textContent = variant.available ? button.dataset.lcLabel || label.textContent : '売り切れ';
          }
        });

        if (variant.media) {
          const gallery = this.root.querySelector('lc-product-gallery');
          if (gallery && typeof gallery.show === 'function') gallery.show(variant.media);
        }

        // 商品ページのときだけ URL を書き換える（ホーム埋込で /products/… にしない）
        if (variant.url && this.root.hasAttribute('data-lc-url-sync') && window.history.replaceState) {
          window.history.replaceState({}, '', variant.url);
        }
      }
    }
    define('lc-variants', LcVariants);

    /* --- 割引コードのコピー ---------------------------------------------- */
    class LcCopy extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        const text = this.dataset.lcCopy;
        if (!text || !navigator.clipboard) return; // コードは文字として読める＝退いてよい
        this.dataset.lcReady = 'true';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lc-mpd__copy lc-tap';
        button.setAttribute('aria-label', 'クーポンコードをコピーする');
        button.innerHTML =
          '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" aria-hidden="true" focusable="false">' +
          '<rect x="9" y="9" width="11" height="11" rx="2.5" stroke="currentColor" stroke-width="1.5"/>' +
          '<path d="M15 6.5A2.5 2.5 0 0 0 12.5 4h-6A2.5 2.5 0 0 0 4 6.5v6A2.5 2.5 0 0 0 6.5 15" ' +
          'stroke="currentColor" stroke-width="1.5"/></svg>';

        const status = document.createElement('span');
        status.className = 'lc-mpd__copied';
        status.setAttribute('role', 'status');

        button.addEventListener('click', () => {
          navigator.clipboard.writeText(text).then(
            () => {
              status.textContent = 'コピーしました';
              clearTimeout(this.timer);
              this.timer = setTimeout(() => {
                status.textContent = '';
              }, 2000);
            },
            () => {
              status.textContent = 'コピーできませんでした';
            }
          );
        });

        this.append(button, status);
      }
    }
    define('lc-copy', LcCopy);

    /* --- 下部固定 ATC バー ------------------------------------------------ */
    class LcStickyAtc extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        const target = this.dataset.lcWatch && document.querySelector(this.dataset.lcWatch);
        if (!target || !('IntersectionObserver' in window)) return;
        this.dataset.lcReady = 'true';

        this.io = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            // 本体 ATC が「画面の上へ抜けた」ときだけ出す（下にあるうちは出さない）
            const scrolledPast = entry.boundingClientRect.top < 0;
            this.classList.toggle('visible', !entry.isIntersecting && scrolledPast);
          },
          { threshold: 0 }
        );
        this.io.observe(target);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }
    }
    define('lc-sticky-atc', LcStickyAtc);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-marquee"] && !Shopify.designMode) return;
  try {
    
  /**
   * <lc-marquee data-lc-pause-hover="true"> の hover / focus 停止。
   * 走行そのものは assets/local.js の <lc-marquee>（start() / stop() を公開）。
   * ここは「いつ止めるか」だけを足す薄い層で、これが動かなくても帯は流れ続ける。
   *
   *  - hover 停止は参照テーマにもある機能（既定は無効だった）
   *  - focus 停止は当方追加。動く帯の中のリンクにキーボードで入ったとき、
   *    読めないまま流れていくのを防ぐ（WCAG 2.2.2 の一時停止手段も兼ねる）
   */
  (() => {
    'use strict';

    const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

    function bind(el) {
      if (el.dataset.lcPauseBound === 'true') return;
      el.dataset.lcPauseBound = 'true';

      // カスタム要素の upgrade 前に呼ばれても落ちないよう、毎回 typeof で確かめる。
      const stop = () => {
        if (typeof el.stop === 'function') el.stop();
      };
      const start = () => {
        if (typeof el.start === 'function') el.start();
      };

      if (FINE_POINTER.matches) {
        el.addEventListener('pointerenter', stop);
        el.addEventListener('pointerleave', start);
      }

      el.addEventListener('focusin', stop);
      el.addEventListener('focusout', (event) => {
        // 帯の中のリンク同士を移動しただけなら止めたままにする（再生→停止の点滅防止）
        if (!el.contains(event.relatedTarget)) start();
      });
    }

    function init(root) {
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('lc-marquee[data-lc-pause-hover="true"]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * local-newsletter-popup
   *   ・settings の秒数だけ遅らせて表示。閉じたら localStorage に期限を書いて抑制。
   *   ・localStorage が例外を投げる環境ではメモリへ退避（＝同一セッション内は出さない）。
   *   ・テーマエディタでは自動表示も抑制もせず、section select のときだけ即表示。
   *   ・閉状態を作る共有クラス .lc-popup は JS が付ける（PE: 規約9・local.css §7）。
   *     no-JS 時は hidden 属性のまま＝何も出さない（ポップアップは enhancement）。
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    /* .lc-popup の transition（.3s + 50ms delay）が終わってから hidden に戻す */
    var CLOSE_MS = 400;
    var memory = {};

    function readStamp(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (e) {
        return Object.prototype.hasOwnProperty.call(memory, key) ? memory[key] : null;
      }
    }

    function writeStamp(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {
        memory[key] = value;
      }
    }

    class LcNewsletterPopup extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.openTimer = 0;
        this.hideTimer = 0;
        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));

        var self = this;

        if (this.editing()) {
          document.addEventListener('shopify:section:select', function (event) {
            if (!document.contains(self)) return;
            if (event.detail && event.detail.sectionId === self.dataset.sectionId) self.show();
          });
          document.addEventListener('shopify:section:deselect', function (event) {
            if (!document.contains(self)) return;
            if (event.detail && event.detail.sectionId === self.dataset.sectionId) self.close(false);
          });
          return;
        }

        /* 購読の結果を持って戻ってきたときは、抑制中でも結果を見せる */
        if (this.querySelector('[role="alert"], [role="status"]')) {
          this.show();
          return;
        }

        if (this.suppressed()) return;

        var delay = (parseFloat(this.dataset.delay) || 0) * 1000;
        this.openTimer = window.setTimeout(function () {
          self.show();
        }, delay);
      }

      disconnectedCallback() {
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.hideTimer);
      }

      editing() {
        return !!(window.Shopify && window.Shopify.designMode);
      }

      suppressed() {
        var until = parseInt(readStamp(this.dataset.key), 10);
        return !isNaN(until) && until > Date.now();
      }

      suppress() {
        var days = parseFloat(this.dataset.expiry);
        if (isNaN(days) || days <= 0) return;
        writeStamp(this.dataset.key, String(Date.now() + days * 86400000));
      }

      show() {
        if (this.classList.contains('is-open')) return;
        window.clearTimeout(this.hideTimer);
        this.hidden = false;
        /* 閉状態（visibility:hidden）を作るクラスはここで初めて付く＝no-JS では付かない */
        this.classList.add('lc-popup');

        var self = this;
        /* 2フレーム待たないと初期状態が確定せず transition が走らない */
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            self.classList.add('is-open');
          });
        });
      }

      close(remember) {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        if (remember && !this.editing()) this.suppress();

        /* 非モーダルなのでフォーカスは元へ戻さず、閉じた要素から外すだけ */
        if (this.contains(document.activeElement) && document.activeElement.blur) {
          document.activeElement.blur();
        }

        var self = this;
        this.hideTimer = window.setTimeout(function () {
          if (self.classList.contains('is-open')) return;
          self.classList.remove('lc-popup');
          self.hidden = true;
        }, CLOSE_MS);
      }

      handleClick(event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest('[data-lc-close]')) return;
        event.preventDefault();
        this.close(true);
      }

      handleKeydown(event) {
        if (event.key !== 'Escape') return;
        this.close(true);
      }
    }

    if (window.customElements && !window.customElements.get('lc-newsletter-popup')) {
      window.customElements.define('lc-newsletter-popup', LcNewsletterPopup);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-product-recommendations"]) return;
  try {
    
  /**
   * <lc-recs> — Shopify のレコメンドを後から取りに行き、グリッドを差し替える。
   *
   * 来る前（JS 無し）: 同じコレクションの他の商品が既に並んでいる。
   * 来た後: 画面に近づいたら Section Rendering API を1回だけ叩き、
   *         返ってきた HTML の .lc-prec__grid で今のグリッドを置き換える。
   * 失敗・0件・fetch 非対応のときは**何もしない**（フォールバックがそのまま残る）。
   */
  (() => {
    'use strict';

    class LcRecs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        const url = this.dataset.url;
        if (!url || !window.fetch) return;
        this.dataset.lcReady = 'true';

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.io.disconnect();
              this.io = null;
              this.load(url);
            },
            { rootMargin: '200px' }
          );
          this.io.observe(this);
        } else {
          this.load(url);
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
      }

      load(url) {
        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.querySelector('.lc-prec__grid');
            if (!next?.querySelector('.st-compact-product')) return; // レコメンド0件。フォールバックを残す
            const current = this.querySelector('.lc-prec__grid');
            if (current) current.replaceWith(next);
            else this.appendChild(next);
            if (window.yotpoWidgetsContainer?.initWidgets) window.yotpoWidgetsContainer.initWidgets();
          })
          .catch(() => {
            /* 取得できなければフォールバックのまま。段は消さない */
          });
      }
    }

    if (window.customElements && !customElements.get('lc-recs')) {
      customElements.define('lc-recs', LcRecs);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-shoppable-video"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * <lcsv-videos>
   *   1. 画面外の動画を止める（IntersectionObserver）
   *   2. reduced-motion では自動再生せず poster ＋ ネイティブ controls に落とす
   *   3. 各動画に一時停止トグルを足す（WCAG 2.2.2。参照テーマには存在しない）
   *   4. スライダーが1画面に収まるときは data-fits を立ててナビを隠す
   *   この JS が落ちても、markup の autoplay/muted/loop/playsinline だけで成立する。
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    var ICON_PAUSE = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="M9 5v14M15 5v14" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
    var ICON_PLAY = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="M8 5l11 7-11 7z" fill="currentColor"/></svg>';

    function noop() {}

    class LcsvVideos extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.videos = Array.prototype.slice.call(this.querySelectorAll('video'));

        if (this.videos.length) {
          if (this.reduced.matches) {
            this.videos.forEach(this.freeze, this);
          } else {
            this.videos.forEach(this.enhance, this);
            this.watch();
          }
        }

        this.measure = this.measure.bind(this);
        this.measure();
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.measure);
          this.ro.observe(this);
        } else {
          window.addEventListener('resize', this.measure);
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('resize', this.measure);
      }

      /* reduced-motion: 再生を巻き戻して poster を出し直し、再生権を利用者に渡す。 */
      freeze(video) {
        video.autoplay = false;
        video.removeAttribute('autoplay');
        video.pause();
        video.controls = true;
        try {
          video.load();
        } catch (e) {
          noop();
        }
      }

      enhance(video) {
        var host = video.parentNode;
        if (!host) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'lcsv__toggle lc-tap';
        button.innerHTML = ICON_PAUSE;
        button.setAttribute('aria-label', '動画を一時停止');
        button.addEventListener('click', function () {
          if (video.paused) {
            video.dataset.lcsvPaused = 'false';
            var p = video.play();
            if (p && p.catch) p.catch(noop);
            button.innerHTML = ICON_PAUSE;
            button.setAttribute('aria-label', '動画を一時停止');
          } else {
            video.dataset.lcsvPaused = 'true';
            video.pause();
            button.innerHTML = ICON_PLAY;
            button.setAttribute('aria-label', '動画を再生');
          }
        });
        host.appendChild(button);
      }

      /* 画面外は pause。利用者が自分で止めた動画（data-lcsv-paused）は勝手に再開しない。 */
      watch() {
        if (!('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (!entry.isIntersecting) {
                video.pause();
              } else if (video.dataset.lcsvPaused !== 'true') {
                var p = video.play();
                if (p && p.catch) p.catch(noop);
              }
            });
          },
          { rootMargin: '100px', threshold: 0 }
        );
        this.videos.forEach(function (video) {
          this.io.observe(video);
        }, this);
      }

      measure() {
        var slider = this.querySelector('lc-slider');
        var track = this.querySelector('.lc-slider__track');
        if (!slider || !track) return;
        slider.dataset.fits = track.scrollWidth <= track.clientWidth + 1 ? 'true' : 'false';
      }
    }

    if (window.customElements && !window.customElements.get('lcsv-videos')) {
      window.customElements.define('lcsv-videos', LcsvVideos);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-store-selector"] && !Shopify.designMode) return;
  try {
    
  /* ---------------------------------------------------------------------------
   * local-store-selector
   *   ・モーダル化（.lc-modal / .lc-modal__content の付与）は JS の仕事。
   *     マークアップに直書きすると JS が落ちた環境で中身に到達できなくなる。
   *   ・選択は radio の change で確定し、localStorage 保存 ＋ 'lc:store-change'
   *     （bubbles）で通知する。表示側は document で購読するだけでよい。
   *   ・フォーカストラップは Tab の巡回だけを自前で持つ（inert 方式は本要素が
   *     body 直下とは限らないため使えない＝親を inert にすると自分も死ぬ）。
   * ------------------------------------------------------------------------ */
  (function () {
    'use strict';

    var STORE_KEY = 'lc-selected-store';
    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
      ' select:not([disabled]), textarea:not([disabled]), summary,' +
      ' iframe, [tabindex]:not([tabindex="-1"])';

    var memory = {};
    var openInstance = null;
    var scrollPad = '';

    function slice(list) {
      return Array.prototype.slice.call(list);
    }

    function readStore() {
      try {
        return window.localStorage.getItem(STORE_KEY);
      } catch (e) {
        return Object.prototype.hasOwnProperty.call(memory, STORE_KEY) ? memory[STORE_KEY] : null;
      }
    }

    function writeStore(value) {
      try {
        window.localStorage.setItem(STORE_KEY, value);
      } catch (e) {
        memory[STORE_KEY] = value;
      }
    }

    /* スクロールバーが消える分を padding で補い、開閉時の横ズレ（CLS）を防ぐ */
    function lockScroll(on) {
      var body = document.body;
      if (on) {
        var gap = window.innerWidth - document.documentElement.clientWidth;
        scrollPad = body.style.paddingInlineEnd;
        if (gap > 0) body.style.paddingInlineEnd = gap + 'px';
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = '';
        body.style.paddingInlineEnd = scrollPad;
      }
    }

    class LcStoreSelector extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lcReady === 'true') return;
        this.dataset.lcReady = 'true';

        this.isModal = this.dataset.mode === 'modal';
        this.dialog = this.querySelector('.lc-ss__dialog');
        this.bar = this.querySelector('.lc-ss__bar');
        this.statusEl = this.querySelector('[data-lc-ss-status]');
        this.confirmBtn = this.querySelector('[data-lc-ss-confirm]');
        this.radios = slice(this.querySelectorAll('.lc-ss__radio'));

        /* JS 前提の操作子をここで初めて出す（no-JS では死んだボタンを置かない） */
        if (this.bar) this.bar.hidden = false;
        var closeBtn = this.querySelector('[data-lc-ss-close]');
        if (closeBtn) closeBtn.hidden = false;

        if (this.isModal && this.dialog) {
          this.classList.add('lc-modal');
          this.dialog.classList.add('lc-modal__content');
          this.dialog.setAttribute('role', 'dialog');
          this.dialog.setAttribute('aria-modal', 'true');
          var title = this.querySelector('.lc-ss__title');
          if (title && title.id) this.dialog.setAttribute('aria-labelledby', title.id);
          if (!this.dialog.hasAttribute('tabindex')) this.dialog.setAttribute('tabindex', '-1');
        }

        this.onChange = this.handleChange.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);

        /* 同じページにモーダルとページ内の2つが載ることがある（店舗一覧ページ）。
           片方で選んだらもう片方も追従させる。追従側は再通知も再保存もしない。 */
        var self = this;
        this.onExternal = function (event) {
          if (event.target === self || !event.detail) return;
          self.syncFrom(event.detail.id);
        };
        document.addEventListener('lc:store-change', this.onExternal);

        if (this.isModal && window.Shopify && window.Shopify.designMode) this.bindEditor();

        this.restore();
      }

      disconnectedCallback() {
        document.removeEventListener('lc:store-change', this.onExternal);
        if (openInstance === this) {
          lockScroll(false);
          openInstance = null;
        }
      }

      /* --- テーマエディタ: セクション/ブロックを選んだら開いて見せる ----------- */
      bindEditor() {
        var self = this;
        document.addEventListener('shopify:section:select', function (event) {
          if (!document.contains(self)) return;
          if (event.detail && event.detail.sectionId === self.dataset.sectionId) self.open(null);
        });
        document.addEventListener('shopify:section:deselect', function (event) {
          if (!document.contains(self)) return;
          if (event.detail && event.detail.sectionId === self.dataset.sectionId) self.close();
        });
        document.addEventListener('shopify:block:select', function (event) {
          if (!document.contains(self)) return;
          if (!event.detail || !self.contains(event.target)) return;
          self.open(null);
          var disc = event.target.querySelector('.lc-ss__disc');
          if (disc) disc.open = true;
        });
      }

      /* --- 開閉 ---------------------------------------------------------------- */
      open(trigger) {
        if (!this.isModal || this.classList.contains('is-open')) return;
        this.returnFocus = trigger || document.activeElement;
        this.classList.add('is-open');
        lockScroll(true);
        openInstance = this;

        var target =
          this.querySelector('.lc-ss__radio:checked') ||
          this.querySelector('[data-lc-ss-close]') ||
          this.dialog;
        if (target && target.focus) {
          /* .lc-modal は visibility で閉じているのでフレームを1つ待たないと focus が乗らない */
          window.requestAnimationFrame(function () {
            target.focus();
          });
        }
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        lockScroll(false);
        if (openInstance === this) openInstance = null;
        var back = this.returnFocus;
        this.returnFocus = null;
        if (back && document.contains(back) && back.focus) back.focus();
      }

      /* --- 選択 ---------------------------------------------------------------- */
      handleChange(event) {
        var radio = event.target;
        if (!radio || !radio.classList || !radio.classList.contains('lc-ss__radio')) return;
        this.apply(radio, true, false);
      }

      handleClick(event) {
        var target = event.target;

        /* 暗幕（要素そのもの）のクリックで閉じる */
        if (this.isModal && target === this) {
          this.close();
          return;
        }
        if (!target || typeof target.closest !== 'function') return;

        if (target.closest('[data-lc-ss-close]')) {
          event.preventDefault();
          this.close();
          return;
        }

        if (target.closest('[data-lc-ss-confirm]')) {
          event.preventDefault();
          this.confirm();
          return;
        }

        var pin = target.closest('[data-lc-ss-pin]');
        if (pin) {
          var id = pin.getAttribute('data-lc-ss-pin');
          var radio = this.querySelector('.lc-ss__radio[value="' + id + '"]');
          if (!radio) return;
          event.preventDefault();
          radio.checked = true;
          this.apply(radio, true, false);
          var store = this.querySelector('[data-lc-ss-store="' + id + '"]');
          var disc = store && store.querySelector('.lc-ss__disc');
          if (disc) disc.open = true;
          if (store && store.scrollIntoView) {
            store.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }
        }
      }

      handleKeydown(event) {
        if (!this.isModal || !this.classList.contains('is-open')) return;
        if (event.key === 'Escape') {
          event.stopPropagation();
          this.close();
          return;
        }
        if (event.key === 'Tab') this.trap(event);
      }

      /* Tab の巡回だけを自前で持つ最小トラップ。inert 方式は本要素が body 直下とは
         限らない（ページ内配置もある）ため使えない。 */
      trap(event) {
        if (!this.dialog) return;
        var nodes = slice(this.dialog.querySelectorAll(FOCUSABLE)).filter(function (el) {
          return el.getClientRects().length > 0;
        });
        if (!nodes.length) return;
        var first = nodes[0];
        var last = nodes[nodes.length - 1];
        var active = document.activeElement;

        if (event.shiftKey && (active === first || active === this.dialog)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && active === last) {
          event.preventDefault();
          first.focus();
        }
      }

      confirm() {
        var radio = this.querySelector('.lc-ss__radio:checked');
        if (!radio) return;
        if (this.isModal) {
          this.close();
        } else if (this.statusEl) {
          /* ページ内モードは閉じる先が無いので、確定した事実だけを読み上げに返す */
          this.statusEl.textContent = radio.getAttribute('data-name') + 'を受け取り店舗にしました';
        }
      }

      /** 見た目（行の選択色・ピンの active・確定バー）だけを合わせる。 */
      paint(radio) {
        var id = radio.value;

        this.radios.forEach(function (r) {
          var store = r.closest('.lc-ss__store');
          if (store) store.classList.toggle('is-selected', r === radio);
        });

        slice(this.querySelectorAll('.lc-ss__pin-item')).forEach(function (item) {
          var pin = item.querySelector('[data-lc-ss-pin]');
          item.classList.toggle('is-active', !!pin && pin.getAttribute('data-lc-ss-pin') === id);
        });

        if (this.statusEl) {
          this.statusEl.textContent = '選択中: ' + (radio.getAttribute('data-name') || '');
          this.statusEl.classList.add('is-set');
        }
        if (this.confirmBtn) this.confirmBtn.disabled = false;
      }

      /** 他インスタンスの選択に追従する（保存も通知もしない）。 */
      syncFrom(id) {
        if (!id) return;
        var radio = this.querySelector('.lc-ss__radio[value="' + id + '"]');
        if (!radio || radio.checked) return;
        radio.checked = true;
        this.paint(radio);
      }

      /**
       * 選択状態を DOM・保存・通知へ反映する。
       * persist=false は復元時（保存済みの値を書き戻さない）。
       */
      apply(radio, persist, restored) {
        var id = radio.value;
        var name = radio.getAttribute('data-name') || '';
        this.paint(radio);

        if (persist) {
          writeStore(JSON.stringify({ id: id, name: name, at: Date.now() }));
        }

        this.dispatchEvent(
          new CustomEvent('lc:store-change', {
            bubbles: true,
            detail: {
              id: id,
              name: name,
              fee: radio.getAttribute('data-fee') || '',
              pickup: radio.getAttribute('data-pickup') || '',
              address: radio.getAttribute('data-address') || '',
              restored: !!restored,
            },
          })
        );
      }

      /* 保存済みの選択を書き戻す。ブロックを作り直すと ID が変わるので店名でも照合する。
         見つからなければ何もしない（保存は消さない。同一ページの別インスタンスが
         一部の店舗しか持たない場合に、そちらの都合で選択を壊さないため）。 */
      restore() {
        var raw = readStore();
        if (!raw || !this.radios.length) return;

        var data;
        try {
          data = JSON.parse(raw);
        } catch (e) {
          data = { id: raw, name: '' };
        }
        if (!data || typeof data !== 'object') return;

        var found = null;
        this.radios.forEach(function (r) {
          if (found) return;
          if (data.id && r.value === data.id) found = r;
        });
        if (!found && data.name) {
          this.radios.forEach(function (r) {
            if (found) return;
            if (r.getAttribute('data-name') === data.name) found = r;
          });
        }

        if (!found) return;
        found.checked = true;
        this.apply(found, false, true);
      }
    }

    if (window.customElements && !window.customElements.get('lc-store-selector')) {
      window.customElements.define('lc-store-selector', LcStoreSelector);
    }

    /* --- グローバルの開くトリガ（後から差し込まれた DOM にも効く委譲） --------- */
    if (!window.lcStoreSelectorBound) {
      window.lcStoreSelectorBound = true;

      document.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        var opener = target.closest('[data-lc-store-open]');
        if (!opener) return;
        var sel = opener.getAttribute('data-lc-store-open') || '#LcStoreSelector';
        var el = document.querySelector(sel);
        if (!el || typeof el.open !== 'function') return;
        event.preventDefault();
        el.open(opener);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && openInstance) openInstance.close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  /**
   * <cs-lookbook>
   *  - ホットスポット ⇄ 商品カードの相互ハイライト
   *  - 開いている吹き出しは常に 1 つ。Esc / 外側クリック / 別スポットで閉じる
   *  - 起動すると data-lb-ready が付き、CSS 側の :hover / :focus-within
   *    フォールバックが切れる（Esc で閉じたのに開きっぱなし、を防ぐ）
   */
  (function () {
    if (typeof window === 'undefined' || !('customElements' in window)) return;
    if (customElements.get('cs-lookbook')) return;

    var finePointer = window.matchMedia('(pointer: fine)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    class CsLookbook extends HTMLElement {
      connectedCallback() {
        if (this.dataset.lbReady === 'true') return;

        this.spots = Array.prototype.slice.call(this.querySelectorAll('[data-lb-spot]'));
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-lb-card]'));
        if (this.spots.length === 0) return;

        this.current = null;
        this.onKeydown = this.onKeydown.bind(this);
        this.onOutside = this.onOutside.bind(this);

        this.spots.forEach((spot) => {
          const dot = spot.querySelector('[data-lb-dot]');
          if (!dot) return;

          // クリック / Enter / Space（button の既定動作で click になる）
          dot.addEventListener('click', () => {
            if (this.current === spot && spot.dataset.lbPinned === 'true') {
              this.close(spot);
              return;
            }
            this.open(spot);
            spot.dataset.lbPinned = 'true';
            this.revealCard(spot);
          });

          dot.addEventListener('focus', () => this.open(spot));

          spot.addEventListener('pointerenter', () => {
            if (finePointer.matches) this.open(spot);
          });

          spot.addEventListener('pointerleave', () => {
            if (!finePointer.matches) return;
            if (spot.dataset.lbPinned === 'true') return;
            // 中にフォーカスが残っているときに閉じるとフォーカスが消える
            if (spot.contains(document.activeElement)) return;
            this.close(spot);
          });
        });

        this.cards.forEach((card) => {
          const spot = this.spotFor(card.getAttribute('data-lb-card'));
          if (!spot) return;
          const dot = spot.querySelector('[data-lb-dot]');
          if (!dot) return;
          const on = () => dot.classList.add('is-active');
          const off = () => dot.classList.remove('is-active');
          card.addEventListener('pointerenter', on);
          card.addEventListener('pointerleave', off);
          card.addEventListener('focusin', on);
          card.addEventListener('focusout', off);
        });

        document.addEventListener('keydown', this.onKeydown);
        document.addEventListener('pointerdown', this.onOutside);

        this.dataset.lbReady = 'true';
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('pointerdown', this.onOutside);
      }

      spotFor(key) {
        for (var i = 0; i < this.spots.length; i++) {
          if (this.spots[i].getAttribute('data-lb-spot') === key) return this.spots[i];
        }
        return null;
      }

      cardFor(spot) {
        const key = spot.getAttribute('data-lb-spot');
        for (var i = 0; i < this.cards.length; i++) {
          if (this.cards[i].getAttribute('data-lb-card') === key) return this.cards[i];
        }
        return null;
      }

      open(spot) {
        if (this.current && this.current !== spot) this.close(this.current);
        this.current = spot;
        spot.classList.add('is-open');
        const dot = spot.querySelector('[data-lb-dot]');
        if (dot) dot.setAttribute('aria-expanded', 'true');
        const card = this.cardFor(spot);
        if (card) card.classList.add('is-active');
      }

      close(spot) {
        const target = spot || this.current;
        if (!target) return;
        target.classList.remove('is-open');
        delete target.dataset.lbPinned;
        const dot = target.querySelector('[data-lb-dot]');
        if (dot) dot.setAttribute('aria-expanded', 'false');
        const card = this.cardFor(target);
        if (card) card.classList.remove('is-active');
        if (this.current === target) this.current = null;
      }

      revealCard(spot) {
        const card = this.cardFor(spot);
        if (!card || typeof card.scrollIntoView !== 'function') return;
        card.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: reduced.matches ? 'auto' : 'smooth',
        });
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.current) return;
        const spot = this.current;
        const dot = spot.querySelector('[data-lb-dot]');
        const hadFocus = spot.contains(document.activeElement);
        this.close(spot);
        if (dot && hadFocus) dot.focus();
      }

      onOutside(event) {
        if (!this.current) return;
        if (this.current.contains(event.target)) return;
        this.close();
      }
    }

    customElements.define('cs-lookbook', CsLookbook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-announcement"] && !Shopify.designMode) return;
  try {
    
/* 🔷C 自動送りの一時停止ボタン。autoplay のタイマー自体は pipeline.js の <pl-slider> が
   持っているので、ここは stopAutoplay() / setupAutoplay() を叩くだけにする
   （同じ機構を二重に実装しない）。reduced-motion では pipeline.js が回さないので隠す。
   hidden 属性を JS が外す＝ JS が無い環境ではボタンが出ない（押しても何も起きない
   ボタンを見せない）。 */
(function () {
  var REDUCED = '(prefers-reduced-motion: reduce)';

  function bind(root) {
    var btns = root.querySelectorAll('[data-pl-announcement-pause]');
    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.dataset.plBound === 'true') return;
      btn.dataset.plBound = 'true';
      var slider = document.getElementById(btn.getAttribute('aria-controls'));
      if (!slider || (window.matchMedia && window.matchMedia(REDUCED).matches)) return;
      var glyph = btn.querySelector('[data-pl-pause-glyph]');
      var label = btn.querySelector('.pl-sr');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var paused = btn.getAttribute('aria-pressed') === 'true';
        if (paused) {
          if (typeof slider.setupAutoplay === 'function') slider.setupAutoplay();
          btn.setAttribute('aria-pressed', 'false');
          if (glyph) glyph.textContent = '▌▌';
          if (label) label.textContent = 'お知らせの自動切替を止める';
        } else {
          if (typeof slider.stopAutoplay === 'function') slider.stopAutoplay();
          btn.setAttribute('aria-pressed', 'true');
          if (glyph) glyph.textContent = '▶';
          if (label) label.textContent = 'お知らせの自動切替を再開する';
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    bind(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      bind(document);
    });
  }
  document.addEventListener('shopify:section:load', function (e) {
    bind(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-footer"] && !Shopify.designMode) return;
  try {
    
/* 🔷1 <details> の初期状態だけを決める。JS が無ければ open のまま＝全リンクが読める。
   768px 以上では見出しの pointer-events を CSS で殺しているので、開いたまま固定される。 */
(function () {
  var MQ = '(min-width: 768px)';

  function sync(root) {
    var mq = window.matchMedia(MQ);
    var items = root.querySelectorAll('[data-pl-footer-acc]');
    Array.prototype.forEach.call(items, function (el) {
      /* 先頭 1 つだけ開いた状態にするのではなく、参照どおり全部閉じる（SP のみ）。 */
      if (!mq.matches && el.dataset.plUserToggled !== 'true') el.open = false;
      if (mq.matches) el.open = true;
      if (el.dataset.plBound === 'true') return;
      el.dataset.plBound = 'true';
      el.addEventListener('toggle', function () {
        if (!window.matchMedia(MQ).matches) el.dataset.plUserToggled = 'true';
      });
    });
  }

  function boot() {
    sync(document);
    var mq = window.matchMedia(MQ);
    var handler = function () {
      sync(document);
    };
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else if (mq.addListener) mq.addListener(handler);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    sync(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-logos"] && !Shopify.designMode) return;
  try {
    
  /* 一時停止ボタン（🔷A・WCAG 2.2.2）。共有 <pl-ticker> は .is-paused を見て止まるので、
     ここではクラスの付け外しと押下状態の同期だけを行う（共有層には手を入れない）。
     reduced-motion では共有 CSS が最初から paused なので、ボタン自体を隠す（CSS 側）。 */
  document.addEventListener('click', function (event) {
    var node = event.target;
    if (!node || !node.closest) return;
    var btn = node.closest('[data-pl-ticker-pause]');
    if (!btn) return;
    var bar = btn.closest('.pl-logos__bar');
    if (!bar) return;
    var ticker = bar.querySelector('.pl-ticker');
    if (!ticker) return;
    var paused = ticker.classList.toggle('is-paused');
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    var label = btn.querySelector('.pl-logos__pause-label');
    if (label) label.textContent = paused ? '再生' : '一時停止';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-popdown"] && !Shopify.designMode) return;
  try {
    
  /* カート追加通知に「何を入れたか」を載せる。
     共通層 <pl-popdown> は開閉だけを担当するので、中身はここで埋める。
     ・fetch が無い / 失敗した環境では汎用文言のまま（通知自体は出る）
     ・商品名は textContent で入れる（HTML を組み立てない＝差し込みの穴を作らない） */
  (function () {
    var host = document.querySelector('[data-pl-popdown-host]');
    if (!host || !window.fetch) return;
    var title = host.querySelector('[data-pl-popdown-title]');
    var media = host.querySelector('[data-pl-popdown-media]');
    if (!title && !media) return;

    document.addEventListener('pl:cart:update', function (e) {
      if (e.detail && e.detail.source !== 'product-form') return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var item = cart.items && cart.items.length ? cart.items[cart.items.length - 1] : null;
          if (!item) return;
          if (title) title.textContent = item.product_title || '';
          if (media) {
            media.textContent = '';
            if (item.image) {
              var img = document.createElement('img');
              img.src = item.image;
              img.width = 48;
              img.height = 54;
              img.alt = '';
              img.loading = 'lazy';
              media.appendChild(img);
            }
          }
        })
        .catch(function () {
          /* 汎用文言のままにする（通知を出さない方が悪い） */
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-recently-viewed"] && !Shopify.designMode) return;
  try {
    
/* 最近見た商品。localStorage に ID を積み、検索の ?section_id= で描画を取りに行く。
   履歴が空のときはセクションごと隠したままにする（空の帯を残さない）。 */
(function () {
  if (customElements.get('pl-recently-viewed')) return;

  var KEY = 'pl:recently-viewed';
  var MAX = 20;

  function readIds() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  }

  function writeIds(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (err) {
      /* プライベートモード等では黙って諦める */
    }
  }

  class PlRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.dataset.plReady === 'true') return;
      this.dataset.plReady = 'true';

      var current = this.dataset.current || '';
      var ids = readIds();
      if (current) {
        ids = ids.filter(function (id) {
          return String(id) !== String(current);
        });
        ids.unshift(current);
        writeIds(ids);
      }

      var limit = parseInt(this.dataset.limit || '8', 10) || 8;
      var wanted = ids
        .filter(function (id) {
          return !current || String(id) !== String(current);
        })
        .slice(0, limit);
      if (!wanted.length || !window.fetch) return;

      /* すでにサーバ側で描画済み（= 差し替え結果そのもの）なら何もしない */
      if (this.children.length) return;

      var query = wanted
        .map(function (id) {
          return 'id:' + id;
        })
        .join(' OR ');
      var url =
        (this.dataset.url || '/search') +
        '?section_id=' +
        encodeURIComponent(this.dataset.sectionId || '') +
        '&type=product&q=' +
        encodeURIComponent(query);

      var self = this;
      fetch(url)
        .then(function (res) {
          return res.ok ? res.text() : Promise.reject(res.status);
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('pl-recently-viewed');
          if (!fresh || !fresh.children.length) return;
          self.innerHTML = fresh.innerHTML;
          self.hidden = false;
        })
        .catch(function () {
          /* 取得できなければ隠したまま */
        });
    }
  }

  customElements.define('pl-recently-viewed', PlRecentlyViewed);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-related"] && !Shopify.designMode) return;
  try {
    
/* 関連商品を Recommendations API で差し替える（実測: 参照は同じ ?section_id= 方式）。
   画面に近づいてから読む（rootMargin 200px）。失敗したらサーバ描画のまま残す。 */
(function () {
  if (customElements.get('pl-recommendations')) return;

  class PlRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.plReady === 'true') return;
      this.dataset.plReady = 'true';
      var url = this.dataset.url;
      if (!url || !window.fetch) return;
      var self = this;
      if (!('IntersectionObserver' in window)) {
        this.load(url);
        return;
      }
      this.io = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          self.io.disconnect();
          self.load(url);
        },
        { rootMargin: '200px 0px' }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }

    load(url) {
      var self = this;
      fetch(url)
        .then(function (res) {
          return res.ok ? res.text() : Promise.reject(res.status);
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('pl-recommendations');
          if (!fresh || !fresh.children.length) return;
          self.innerHTML = fresh.innerHTML;
        })
        .catch(function () {
          /* サーバ描画の代替リストをそのまま見せる */
        });
    }
  }

  customElements.define('pl-recommendations', PlRecommendations);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-finder"] && !Shopify.designMode) return;
  try {
    
  /**
   * routine-finder
   * - ラジオの選択を集めて CTA の href を /collections/<handle>/tag1+tag2 に組み替える
   * - 未選択のあいだは aria-disabled="true"（属性を足すのはここだけ。
   *   JSが動かない環境では CTA は素のリンクのまま対象コレクションへ飛ぶ）
   * - summary に選択中のラベルを表示する
   * - ポインタ操作で選んだときだけ <details> を閉じる。キーボードの ↑↓ で
   *   選択を移している最中に閉じるとフォーカスが消えるため、キー操作では閉じない。
   */
  if (!customElements.get('routine-finder')) {
    customElements.define(
      'routine-finder',
      class RoutineFinder extends HTMLElement {
        connectedCallback() {
          if (this.dataset.rfindReady !== undefined) return;

          this.cta = this.querySelector('[data-rfind-cta]');
          this.filters = Array.prototype.slice.call(this.querySelectorAll('.rfind__filter'));
          if (!this.cta || !this.filters.length) return;

          this.base = String(this.dataset.rfindBase || '').replace(/\/+$/, '');
          this.pointer = false;

          this.onChange = this.onChange.bind(this);
          this.onClick = this.onClick.bind(this);
          this.onPointer = this.onPointer.bind(this);
          this.onKey = this.onKey.bind(this);

          this.addEventListener('change', this.onChange);
          this.addEventListener('pointerdown', this.onPointer, true);
          this.addEventListener('keydown', this.onKey, true);
          this.cta.addEventListener('click', this.onClick);

          this.dataset.rfindReady = '';
          this.update();
        }

        onPointer() {
          this.pointer = true;
        }

        onKey() {
          this.pointer = false;
        }

        /* 選択中のタグを filter の並び順で集める。ついでに summary の表示も更新する。 */
        collect() {
          var tags = [];
          this.filters.forEach(function (filter) {
            var input = filter.querySelector('.rfind__radio:checked');
            var slot = filter.querySelector('[data-rfind-value]');
            if (input) {
              tags.push(input.value);
              if (slot) slot.textContent = '／' + (input.getAttribute('data-rfind-label') || '');
            } else if (slot) {
              slot.textContent = '';
            }
          });
          return tags;
        }

        update() {
          var tags = this.collect();
          var href = this.base;
          if (tags.length) {
            href =
              this.base +
              '/' +
              tags
                .map(function (tag) {
                  return encodeURIComponent(tag);
                })
                .join('+');
          }
          this.cta.setAttribute('href', href);
          this.cta.setAttribute('aria-disabled', tags.length ? 'false' : 'true');
        }

        onChange(event) {
          var input = event.target;
          if (!input || input.type !== 'radio') return;
          this.update();
          if (!this.pointer) return;

          var details = input.closest('details');
          if (!details) return;
          details.open = false;
          // 閉じた瞬間にフォーカス先（ラジオ）が消えるので summary へ移す。
          var summary = details.querySelector('summary');
          if (summary) summary.focus({ preventScroll: true });
        }

        onClick(event) {
          if (this.cta.getAttribute('aria-disabled') === 'true') event.preventDefault();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-cards"] && !Shopify.designMode) return;
  try {
    
  /**
   * sticky stack の傾き（スクラブ駆動）。
   *
   * 駆動式（参照テーマの実測値から復元。カード2枚ぶんのサンプルで一致を確認済み）:
   *   step_i  = カード i の高さ + スタックの gap
   *   offset_i = スタック上端から カード i の上端までの距離（= Σ step_k, k<i）
   *   進捗 p_i = clamp01((innerHeight * ENTER - stackTop - offset_i) / (step_i * SPAN))
   *   角度  = maxDeg * p_i * (i が偶数 ? +1 : -1)
   * つまり「スタック上端が画面の下 20% に入った時点」から傾き始め、
   * カード1枚ぶんの送りの 1.9 倍だけスクロールすると最大角に達してクランプする。
   * 左右交互に振ることで、積み上がったカードが扇状にずれて見える。
   *
   * 設計上の制約:
   *   - 触るのは CSS カスタムプロパティ 1 個（--scard-angle）だけ。DOM も表示内容も変えない。
   *   - scale は掛けない。参照テーマは常に 1.0 で、縮小は元から存在しない。
   *   - 1フレーム内で「全部読む → 全部書く」。読み書きを交互にすると layout thrashing になる。
   *   - 入力に使う矩形はスタック（親）のもの1個だけ。子の rotate も sticky のずれも
   *     親のレイアウト矩形には影響しないので、書いた値が次フレームの入力に混ざらない
   *     ＝発振しない。カード自身の getBoundingClientRect は回転後の外接矩形なので使わない。
   *   - 高さは offsetHeight（レイアウト値）で取る。同じ理由。
   *   - 画面外のセクションは計算しない。スクロールが止まれば rAF も止まる（アイドル 0%）。
   */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* スタック上端が viewport 高さの何割の位置に来たら傾き始めるか（実測: 下から 20%） */
    var ENTER = 0.8;
    /* 最大角に達するまでのスクロール量を step の何倍にするか（実測: 1.9） */
    var SPAN = 1.9;
    /* schema の range と同じ上限。設定値が壊れていても物理的にありえない角度にしない */
    var MAX_DEG = 10;

    var stacks = [];
    var scheduled = false;
    var bound = false;

    function clamp(v, min, max) {
      return v < min ? min : v > max ? max : v;
    }

    function num(v, fallback) {
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    function measure(stack) {
      var gap = num(window.getComputedStyle(stack.list).rowGap, 0);
      var offset = 0;
      for (var i = 0; i < stack.cards.length; i++) {
        var card = stack.cards[i];
        /* 実際の高さを足し上げる。カードの高さは aspect-ratio 固定なので全枚数同じだが、
           将来ばらついても式が成立するように i * step ではなく累積で持つ。 */
        card.step = Math.max(card.el.offsetHeight + gap, 1);
        card.offset = offset;
        offset += card.step;
      }
      stack.measuredAt = window.innerHeight;
    }

    function update() {
      scheduled = false;
      var i, j, s;

      /* --- 読み取りフェーズ --- */
      for (i = 0; i < stacks.length; i++) {
        s = stacks[i];
        if (!s.live || !s.root.isConnected) continue;
        if (s.measuredAt !== window.innerHeight) measure(s);
        /* スタック（親）の矩形だけ読む。子の rotate も sticky も親の箱を動かさない */
        s.top = s.list.getBoundingClientRect().top;
      }

      /* --- 書き込みフェーズ --- */
      for (i = 0; i < stacks.length; i++) {
        s = stacks[i];
        if (!s.live || !s.root.isConnected) continue;

        /* スタック上端が「傾き開始ライン」をどれだけ通り過ぎたか（px） */
        var lead = window.innerHeight * ENTER - s.top;

        for (j = 0; j < s.cards.length; j++) {
          var card = s.cards[j];
          var p = clamp((lead - card.offset) / (card.step * SPAN), 0, 1);
          /* 符号はカードの並び順の偶奇で交互（0番目 +、1番目 −、2番目 +…）。
             同じ向きに揃えると「全体が傾いた」だけに見えて、扇状にならない。 */
          var out = (s.maxDeg * p * (j % 2 === 0 ? 1 : -1)).toFixed(3) + 'deg';
          if (card.last !== out) {
            card.last = out;
            card.el.style.setProperty('--scard-angle', out);
          }
        }
      }
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }

    function bind() {
      if (bound) return;
      bound = true;
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', function () {
        for (var i = 0; i < stacks.length; i++) stacks[i].measuredAt = -1;
        schedule();
      });
    }

    function setup(root) {
      if (root.hasAttribute('data-scard-ready')) return;
      /* reduced-motion の間は ready フラグを立てない。
         OS 設定を切り替えたときに init() をもう一度通せるようにするため
         （フラグを先に立てると、設定を戻しても二度と有効化されない）。 */
      if (reduce.matches) return;
      root.setAttribute('data-scard-ready', '');

      var list = root.querySelector('.scard__stack');
      if (!list) return;
      var els = Array.prototype.slice.call(list.querySelectorAll('.scard__card'));
      if (els.length < 2) return;

      var stack = {
        root: root,
        list: list,
        maxDeg: clamp(num(root.getAttribute('data-scard-tilt'), 4), 0, MAX_DEG),
        top: 0,
        measuredAt: -1,
        live: false,
        cards: els.map(function (el) {
          return { el: el, step: 1, offset: 0, last: '' };
        }),
      };
      stacks.push(stack);

      /* 画面外では一切計算しない。will-change の合成レイヤーも見えている間だけ確保する */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              stack.live = entries[i].isIntersecting;
              if (stack.live) {
                root.setAttribute('data-scard-live', '');
                stack.measuredAt = -1;
                schedule();
              } else {
                root.removeAttribute('data-scard-live');
              }
            }
          },
          { rootMargin: '200px 0px' }
        ).observe(root);
      } else {
        stack.live = true;
        root.setAttribute('data-scard-live', '');
      }

      bind();
      schedule();
    }

    function init(scope) {
      var nodes = (scope || document).querySelectorAll('[data-scard]');
      for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
    if (reduce.addEventListener) {
      reduce.addEventListener('change', function () {
        if (!reduce.matches) init();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-ribbons"] && !Shopify.designMode) return;
  try {
    
  /**
   * <cs-ribbon data-speed="94"> … px/秒 を秒数に翻訳するだけの薄い要素。
   *  - 1セット分の実幅 ÷ 速度 = 1周の秒数 を --cs-marquee-dur に書く
   *  - ResizeObserver で幅の変化に追随（vw 連動の文字サイズが変わるため）
   *  - Web フォント確定後に測り直す（フォールバック字形のままだと幅がずれる）
   *  - 測れないときはプロパティを消して CSS 既定値(26s)に戻す
   */
  (() => {
    class CsRibbon extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.track = this.querySelector('[data-ribbon-track]');
        if (!this.track) return;

        this.measure = this.measure.bind(this);

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.measure);
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', this.measure, { passive: true });
        }

        this.measure();

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.measure).catch(() => {});
        }
      }

      disconnectedCallback() {
        if (this.ro) {
          this.ro.disconnect();
          this.ro = null;
        }
        if (this.measure) window.removeEventListener('resize', this.measure);
        this.dataset.ready = 'false';
      }

      measure() {
        // offsetWidth はレイアウト幅。translate/rotate の影響を受けない。
        const width = this.track ? this.track.offsetWidth : 0;
        const speed = parseFloat(this.dataset.speed);

        if (!(width > 0) || !(speed > 0)) {
          this.style.removeProperty('--cs-marquee-dur');
          return;
        }

        this.style.setProperty('--cs-marquee-dur', (width / speed).toFixed(3) + 's');
      }
    }

    if (!customElements.get('cs-ribbon')) customElements.define('cs-ribbon', CsRibbon);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  // Shopify はテーマ内のセクションJSを1本のファイルに連結する。トップレベルに
  // class を置くとレキシカル束縛が衝突しうるので、必ず即時関数で閉じる。
  (function () {
    class ShopTheLook extends HTMLElement {
      constructor() {
        super();
        // connected/disconnected を往復しても同じ参照で着脱できるようここで束縛する
        this.onDocPointer = this.onDocPointer.bind(this);
      }

      connectedCallback() {
        document.addEventListener('pointerdown', this.onDocPointer);
        if (this.ready) return;
        this.ready = true;

        this.spots = Array.from(this.querySelectorAll('[data-stl-spot]'));
        this.markers = Array.from(this.querySelectorAll('[data-stl-marker]'));
        this.items = Array.from(this.querySelectorAll('[data-stl-item]'));
        this.totalEl = this.querySelector('[data-stl-total]');
        this.wasEl = this.querySelector('[data-stl-total-was]');
        this.countEl = this.querySelector('[data-stl-count]');
        // 割引率は data-discount（Liquid が 0% のときは属性そのものを出さない）
        this.discount = parseInt(this.dataset.discount, 10) || 0;
        this.openSpot = null;

        // .stl--js が付いて初めてチェックボックス／閉じるボタンが現れる。
        // これより前は「JSなしでも正しい」状態＝全商品がカートに入る帯として振る舞う。
        this.classList.add('stl--js');

        this.readMoneyShape();

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('focusout', this.onFocusout.bind(this));

        this.sync();
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onDocPointer);
      }

      spotFor(key) {
        return this.spots.find(function (s) {
          return s.dataset.stlSpot === key;
        });
      }

      itemFor(key) {
        return this.items.find(function (i) {
          return i.dataset.stlItem === key;
        });
      }

      onClick(event) {
        const marker = event.target.closest('[data-stl-marker]');
        if (marker) {
          const spot = marker.closest('[data-stl-spot]');
          this.toggle(spot, !spot.classList.contains('is-open'));
          return;
        }

        const close = event.target.closest('[data-stl-close]');
        if (close) {
          const spot = close.closest('[data-stl-spot]');
          this.toggle(spot, false);
          const btn = spot.querySelector('[data-stl-marker]');
          if (btn) btn.focus();
          return;
        }

        const toggle = event.target.closest('[data-stl-toggle]');
        if (toggle) {
          const item = this.itemFor(toggle.dataset.stlToggle);
          const check = item && item.querySelector('[data-stl-check]');
          if (check) {
            check.checked = !check.checked;
            this.sync();
          }
        }
      }

      onChange(event) {
        if (event.target.closest('[data-stl-check]')) this.sync();
      }

      onFocusout(event) {
        if (!this.openSpot) return;
        const next = event.relatedTarget;
        if (next && this.openSpot.contains(next)) return;
        if (next && this.contains(next) && !next.closest('[data-stl-spot]')) return;
        if (next) this.toggle(this.openSpot, false);
      }

      onDocPointer(event) {
        if (!this.openSpot) return;
        if (this.openSpot.contains(event.target)) return;
        this.toggle(this.openSpot, false);
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.openSpot) {
          const spot = this.openSpot;
          this.toggle(spot, false);
          const btn = spot.querySelector('[data-stl-marker]');
          if (btn) btn.focus();
          event.stopPropagation();
          return;
        }

        const marker = event.target.closest('[data-stl-marker]');
        if (!marker) return;

        const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
        if (keys.indexOf(event.key) === -1) return;

        const i = this.markers.indexOf(marker);
        const last = this.markers.length - 1;
        let next = i;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i === last ? 0 : i + 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i === 0 ? last : i - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;

        event.preventDefault();
        this.markers[next].focus();
      }

      toggle(spot, open) {
        if (!spot) return;
        if (open && this.openSpot && this.openSpot !== spot) this.toggle(this.openSpot, false);
        spot.classList.toggle('is-open', open);
        const btn = spot.querySelector('[data-stl-marker]');
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.openSpot = open ? spot : null;
      }

      sync() {
        let total = 0;
        let count = 0;
        let dropped = 0;
        let line = 0;

        this.items.forEach((item) => {
          const check = item.querySelector('[data-stl-check]');
          const on = !!check && check.checked;
          const price = parseInt(item.dataset.stlPrice, 10) || 0;
          const idInput = item.querySelector('[data-stl-id]');
          const qtyInput = item.querySelector('[data-stl-qty]');

          // disabled のフォーム要素は送信されない＝チェックを外した商品はカートに入らない
          [idInput, qtyInput].forEach((input) => {
            if (input) input.disabled = !on;
          });
          // 生き残った行を 0 から振り直す。items[0],items[2] のような歯抜けを
          // サーバーに渡さないための保険。
          if (on && idInput && qtyInput) {
            idInput.name = 'items[' + line + '][id]';
            qtyInput.name = 'items[' + line + '][quantity]';
            line += 1;
          }
          item.classList.toggle('is-dropped', !!check && !on);

          if (check && !on) dropped += 1;
          if (on) {
            total += price;
            count += 1;
          }

          const spot = this.spotFor(item.dataset.stlItem);
          if (spot) {
            spot.classList.toggle('is-picked', on);
            const toggle = spot.querySelector('[data-stl-toggle]');
            if (toggle) toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
          }
        });

        // 「発光」は取捨選択を始めてから出す。初期状態で全部光ると画面が騒がしいため。
        this.classList.toggle('stl--curating', dropped > 0);

        if (this.countEl) this.countEl.textContent = String(count);
        if (this.totalEl) this.totalEl.textContent = this.money(this.net(total));
        if (this.wasEl) this.wasEl.textContent = this.money(total);

        const buy = this.querySelector('.stl__buy');
        if (buy) buy.disabled = count === 0;
      }

      // 割引後の金額。Liquid 側は `total | times: keep | divided_by: 100` の整数除算
      // （＝切り捨て）なので、JS も Math.floor に揃える。丸めが違うと初期表示と
      // クリック後で1円ずれて見える。
      net(cents) {
        if (!this.discount) return cents;
        return Math.floor((cents * (100 - this.discount)) / 100);
      }

      // 通貨表記はサーバー（Liquid の money フィルタ）が出した合計文字列から
      // 記号の位置と小数桁を読み取って再利用する。Intl の通貨表記だと
      // 「￥」と「¥」のようにストアの表記と食い違うため。
      readMoneyShape() {
        const raw = this.totalEl ? this.totalEl.textContent.trim() : '';
        const parts = raw.match(/^(\D*?)([\d.,\s]+)(\D*)$/);
        this.moneyPrefix = parts ? parts[1] : '';
        this.moneySuffix = parts ? parts[3] : '';
        this.moneyDecimals = parts && /[.,]\d{2}$/.test(parts[2].trim()) ? 2 : 0;
      }

      money(cents) {
        const value = cents / 100;
        const options = {
          minimumFractionDigits: this.moneyDecimals,
          maximumFractionDigits: this.moneyDecimals,
        };
        let body;
        try {
          body = value.toLocaleString(this.dataset.locale || document.documentElement.lang, options);
        } catch (error) {
          // ロケール文字列が不正でも桁区切りは落とさない
          body = value.toLocaleString(undefined, options);
        }
        return this.moneyPrefix + body + this.moneySuffix;
      }
    }

    if (!customElements.get('shop-the-look')) {
      customElements.define('shop-the-look', ShopTheLook);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  /**
   * cs-slideshow — ヒーロースライドショー専用のカスタム要素
   *
   * concept.js の <cs-slider> は汎用でオートプレイを持たないため、ここで別に定義する。
   * やることは3つだけ。
   *   1. トラックの scrollLeft からアクティブ index を求める
   *   2. ドットの aria-current / 矢印の disabled / 非アクティブスライドの aria-hidden + inert を更新
   *   3. オートプレイ（reduced-motion・タブ非表示・hover・フォーカス・画面外では止める）
   *
   * スライド送りは scroll-snap + scrollTo({behavior:'smooth'}) のみ。
   * このクラスが定義されない環境では [data-cshero-ready] が付かず、
   * コントロールは非表示のまま＝ネイティブの横スクロールで全スライドを読める。
   */
  if (!customElements.get('cs-slideshow')) {
    customElements.define(
      'cs-slideshow',
      class CsSlideshow extends HTMLElement {
        connectedCallback() {
          if (!this.built) this.build();
          if (!this.track) return;
          this.attach();
          this.sync();
          this.refresh();
        }

        disconnectedCallback() {
          if (!this.built || !this.track) return;
          this.detach();
          this.stop();
        }

        build() {
          this.built = true;

          this.track = this.querySelector('[data-cs-track]');
          if (!this.track) return;

          this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-cshero-slide]'));
          if (!this.slides.length) {
            this.track = null;
            return;
          }

          this.prevBtn = this.querySelector('[data-cs-prev]');
          this.nextBtn = this.querySelector('[data-cs-next]');
          this.playBtn = this.querySelector('[data-cs-play]');
          this.pauseIcon = this.querySelector('[data-cs-icon-pause]');
          this.playIcon = this.querySelector('[data-cs-icon-play]');
          this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-cs-dot]'));

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.wantsAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
          this.interval = Math.max(3000, parseInt(this.dataset.interval, 10) || 5000);

          this.index = 0;
          this.timer = null;
          this.ticking = false;
          this.userPaused = false;
          this.hovered = false;
          this.focused = false;
          this.editing = false;
          this.onScreen = true;

          this.onScroll = this.onScroll.bind(this);
          this.onResize = this.onResize.bind(this);
          this.refresh = this.refresh.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);
          this.onBlockDeselect = this.onBlockDeselect.bind(this);

          var self = this;

          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.addEventListener('pointerdown', function () {
            self.bump();
          });
          this.track.addEventListener('keydown', function () {
            self.bump();
          });

          this.addEventListener('pointerenter', function () {
            self.hovered = true;
            self.refresh();
          });
          this.addEventListener('pointerleave', function () {
            self.hovered = false;
            self.refresh();
          });
          this.addEventListener('focusin', function () {
            self.focused = true;
            self.refresh();
          });
          this.addEventListener('focusout', function () {
            self.focused = false;
            self.refresh();
          });

          if (this.prevBtn) {
            this.prevBtn.addEventListener('click', function () {
              self.goTo(self.index - 1);
              self.bump();
            });
          }
          if (this.nextBtn) {
            this.nextBtn.addEventListener('click', function () {
              self.goTo(self.index + 1);
              self.bump();
            });
          }
          this.dots.forEach(function (dot, i) {
            dot.addEventListener('click', function () {
              self.goTo(i);
              self.bump();
            });
          });
          if (this.playBtn) {
            this.playBtn.addEventListener('click', function () {
              self.userPaused = !self.userPaused;
              self.refresh();
            });
          }

          // 画面外では回さない（無駄なスクロールアニメを走らせない）
          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              function (entries) {
                self.onScreen = entries[0].isIntersecting;
                self.refresh();
              },
              { threshold: 0.2 }
            );
            this.io.observe(this);
          }

          if (this.reduced.addEventListener) this.reduced.addEventListener('change', this.refresh);
          else if (this.reduced.addListener) this.reduced.addListener(this.refresh);

          this.dataset.csheroReady = '';
        }

        attach() {
          // 同一の (type, listener) を足し直しても二重登録にはならない
          window.addEventListener('resize', this.onResize, { passive: true });
          document.addEventListener('visibilitychange', this.refresh);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        detach() {
          window.removeEventListener('resize', this.onResize);
          document.removeEventListener('visibilitychange', this.refresh);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        /* --- テーマエディタ ---------------------------------------------------
         * スライドを選択したらそこへ送り、編集中は自動送りを止める。
         * userPaused とは別フラグにして、再生/停止ボタンの表示状態を汚さない。 */
        onBlockSelect(event) {
          var i = this.slides.indexOf(event.target);
          if (i < 0) return;
          this.editing = true;
          this.refresh();
          this.goTo(i);
        }

        onBlockDeselect(event) {
          if (this.slides.indexOf(event.target) < 0) return;
          this.editing = false;
          this.refresh();
        }

        /* --- 位置 ------------------------------------------------------------
         * 1枚目が scrollLeft:0 に収まる（scroll-padding-inline と padding-inline が同値）ため、
         * i 番目のスクロール位置は「offsetLeft の差」でそのまま出る。
         * RTL では offsetLeft の差が負になり、負の scrollLeft と符号が一致する。 */
        offsetOf(i) {
          return this.slides[i].offsetLeft - this.slides[0].offsetLeft;
        }

        goTo(i) {
          var last = this.slides.length - 1;
          var target = Math.min(last, Math.max(0, i));
          var left = this.offsetOf(target);
          var behavior = this.reduced.matches ? 'auto' : 'smooth';

          if (typeof this.track.scrollTo === 'function') {
            this.track.scrollTo({ left: left, behavior: behavior });
          } else {
            this.track.scrollLeft = left;
          }
        }

        onScroll() {
          if (this.ticking) return;
          this.ticking = true;
          var self = this;
          window.requestAnimationFrame(function () {
            self.ticking = false;
            self.sync();
          });
        }

        onResize() {
          this.sync();
        }

        sync() {
          var pos = this.track.scrollLeft;
          var best = 0;
          var bestDist = Infinity;

          for (var i = 0; i < this.slides.length; i++) {
            var dist = Math.abs(this.offsetOf(i) - pos);
            if (dist < bestDist) {
              bestDist = dist;
              best = i;
            }
          }
          this.index = best;

          this.dots.forEach(function (dot, i) {
            dot.setAttribute('aria-current', i === best ? 'true' : 'false');
          });

          this.slides.forEach(function (slide, i) {
            if (i === best) {
              slide.removeAttribute('aria-hidden');
              slide.removeAttribute('inert');
              slide.inert = false;
            } else {
              slide.setAttribute('aria-hidden', 'true');
              slide.setAttribute('inert', '');
              slide.inert = true;
            }
          });

          var last = this.slides.length - 1;
          if (this.prevBtn) this.prevBtn.disabled = best <= 0;
          if (this.nextBtn) this.nextBtn.disabled = best >= last;

          // 端で disabled になった矢印にフォーカスが残るとキーボード操作が途切れるので逃がす
          if (this.prevBtn && this.nextBtn) {
            if (this.prevBtn.disabled && document.activeElement === this.prevBtn) this.nextBtn.focus();
            else if (this.nextBtn.disabled && document.activeElement === this.nextBtn) this.prevBtn.focus();
          }
        }

        /* --- オートプレイ ---------------------------------------------------- */
        start() {
          if (this.timer) return;
          var self = this;
          this.timer = window.setInterval(function () {
            self.goTo((self.index + 1) % self.slides.length);
          }, this.interval);
        }

        stop() {
          if (!this.timer) return;
          window.clearInterval(this.timer);
          this.timer = null;
        }

        /** 手動操作の直後は次の自動送りまでを測り直す */
        bump() {
          if (!this.timer) return;
          this.stop();
          this.start();
        }

        refresh() {
          var allowed = this.wantsAutoplay && !this.reduced.matches;
          var run =
            allowed &&
            !this.userPaused &&
            !this.editing &&
            !this.hovered &&
            !this.focused &&
            this.onScreen &&
            document.visibilityState === 'visible';

          if (run) this.start();
          else this.stop();

          if (this.playBtn) {
            this.playBtn.hidden = !allowed;
            this.playBtn.setAttribute('aria-label', this.userPaused ? '自動再生を開始' : '自動再生を停止');
            if (this.pauseIcon) this.pauseIcon.hidden = this.userPaused;
            if (this.playIcon) this.playIcon.hidden = !this.userPaused;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stripes-showcase"] && !Shopify.designMode) return;
  try {
    
  /**
   * ストライプの停止/再生（WCAG 2.2.2）。
   * JS が動く時だけボタンを出す＝JS 無しでも壊れない。
   * 動きを止める OS 設定が入っている場合は、そもそも流れていないのでボタンを出さない。
   */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(root) {
      if (root.dataset.stripesReady) return;
      root.dataset.stripesReady = '1';

      var btn = root.querySelector('.stripes__toggle');
      if (!btn) return;

      var label = btn.querySelector('.stripes__toggle-text');

      function sync() {
        var paused = root.hasAttribute('data-stripes-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (label) {
          label.textContent = paused
            ? btn.getAttribute('data-label-play')
            : btn.getAttribute('data-label-pause');
        }
      }

      function apply() {
        if (reduce.matches) {
          btn.hidden = true;
          return;
        }
        btn.hidden = false;
        sync();
      }

      btn.addEventListener('click', function () {
        if (root.hasAttribute('data-stripes-paused')) {
          root.removeAttribute('data-stripes-paused');
        } else {
          root.setAttribute('data-stripes-paused', '');
        }
        sync();
      });

      if (reduce.addEventListener) reduce.addEventListener('change', apply);
      apply();
    }

    function init(scope) {
      var nodes = (scope || document).querySelectorAll('.stripes');
      for (var i = 0; i < nodes.length; i++) setup(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-orbit"] && !Shopify.designMode) return;
  try {
    
  /* testimonials-orbit — 増設レイヤーのみ。
     切替の真実源はネイティブ radio なので、ここが動かなくても機能は落ちない。 */
  (function () {
    var READY = 'orbitReady';

    function initOrbit(root) {
      if (!root || root.dataset[READY] === '1') return;
      var stage = root.querySelector('.orbit__stage');
      if (!stage) return;
      var radios = Array.prototype.slice.call(stage.querySelectorAll('.orbit__radio'));
      if (radios.length < 2) return;
      root.dataset[READY] = '1';

      var panel = stage.querySelector('.orbit__panel');
      var nav = root.querySelector('.orbit__nav');
      var prev = root.querySelector('[data-orbit-prev]');
      var next = root.querySelector('[data-orbit-next]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var wide = window.matchMedia('(min-width: 750px)');
      var autoplay = root.dataset.orbitAutoplay === 'true';
      var wait = Math.max(3, parseFloat(root.dataset.orbitInterval) || 6) * 1000;
      var timer = null;
      var onScreen = false;
      var held = false;

      function current() {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].checked) return i;
        }
        return 0;
      }

      // silent=true は自動再生による切替。
      // WAIのカルーセルパターン通り、自動回転中はライブリージョンを黙らせる
      // （数秒おきに引用文を読み上げられるとスクリーンリーダーでは操作不能になる）。
      function go(i, silent) {
        var n = radios.length;
        var t = ((i % n) + n) % n;
        if (radios[t].checked) return;
        if (panel) panel.setAttribute('aria-live', silent ? 'off' : 'polite');
        radios[t].checked = true;
        radios[t].dispatchEvent(new Event('change', { bubbles: true }));
      }

      function running() {
        return autoplay && onScreen && !held && !reduce.matches && wide.matches && !document.hidden;
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (!running()) return;
        timer = setInterval(function () {
          if (!running()) {
            stop();
            return;
          }
          go(current() + 1, true);
        }, wait);
      }

      function step(delta) {
        go(current() + delta, false);
        start();
      }

      if (nav) {
        nav.hidden = false;
        // 矢印キーはラジオ上ではブラウザ標準で効く。ナビボタン上でも同じ操作を許す。
        nav.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            step(-1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            step(1);
          }
        });
      }
      if (prev) {
        prev.addEventListener('click', function () {
          step(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          step(1);
        });
      }

      radios.forEach(function (r) {
        r.addEventListener('change', start);
      });

      // アバター直クリック/矢印キーはブラウザ標準で radio が切り替わるため go() を通らない。
      // 自動再生が黙らせたライブリージョンを、変更が起きる前（キャプチャ段階）に戻す。
      function livePolite() {
        if (panel) panel.setAttribute('aria-live', 'polite');
      }
      stage.addEventListener('pointerdown', livePolite, true);
      stage.addEventListener('keydown', livePolite, true);

      // hover / focus / 画面外 / 別タブ では自動再生を止める
      ['mouseenter', 'focusin'].forEach(function (ev) {
        root.addEventListener(ev, function () {
          held = true;
          stop();
        });
      });
      ['mouseleave', 'focusout'].forEach(function (ev) {
        root.addEventListener(ev, function () {
          held = false;
          start();
        });
      });
      document.addEventListener('visibilitychange', start);
      if (reduce.addEventListener) reduce.addEventListener('change', start);
      if (wide.addEventListener) wide.addEventListener('change', start);

      // 監視は1個。自動再生の可視判定と、登場アニメのワンショット発火を兼ねる。
      // orbit--in は一度付けたら外さない（参照実測も戻らない）。
      // 付けなくてもホイールは正位置なので、ここが動かなくても壊れない。
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            onScreen = entries[0].isIntersecting;
            if (onScreen) root.classList.add('orbit--in');
            start();
          },
          { rootMargin: '0px 0px -10% 0px' }
        ).observe(root);
      } else {
        onScreen = true;
        root.classList.add('orbit--in');
        start();
      }
    }

    function initAll() {
      document.querySelectorAll('.orbit').forEach(initOrbit);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('.orbit') : null;
      if (el) initOrbit(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  /**
   * video-slider
   * - 4,000ms 間隔の自動送り（1 枚ぶん translate3d）
   * - pointerdown / move / up のドラッグ送り（離したら最寄りのカードへスナップ）
   * - transform の書き込みは requestAnimationFrame に集約（読み取りと書き込みを分ける）
   * - hover / フォーカス / 画面外 / タブ非表示 / 明示停止 で自動送りを止める
   * - prefers-reduced-motion: 自動送り停止・移動アニメ無し・動画は poster に戻す
   *
   * この class が定義されなければ data-vs-mode も付かないので、CSS は
   * 「素の横スクロール」のまま＝カードは全部見られる。
   */
  if (!customElements.get('video-slider')) {
    customElements.define(
      'video-slider',
      class VideoSlider extends HTMLElement {
        connectedCallback() {
          if (this.dataset.vsMode) return;

          this.viewport = this.querySelector('[data-vs-viewport]');
          this.track = this.querySelector('[data-vs-track]');
          this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-vs-slide]'));
          if (!this.viewport || !this.track || !this.slides.length) return;

          this.videos = Array.prototype.slice.call(this.querySelectorAll('[data-vs-video]'));
          this.toggle = this.querySelector('[data-vs-toggle]');
          this.toggleLabel = this.querySelector('[data-vs-toggle-label]');

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.autoplay = this.dataset.autoplay === 'true';
          this.pauseHover = this.dataset.pauseHover === 'true';
          this.speed = parseInt(this.dataset.speed, 10) || 4000;

          this.position = 0;
          this.frame = 0;
          this.dragging = false;
          this.moved = false;
          this.startX = 0;
          this.startPosition = 0;
          this.timer = null;
          this.inView = true;
          this.userPaused = false;
          this.hoverPaused = false;
          this.focusPaused = false;

          this.onPointerDown = this.onPointerDown.bind(this);
          this.onPointerMove = this.onPointerMove.bind(this);
          this.onPointerUp = this.onPointerUp.bind(this);
          this.onClickCapture = this.onClickCapture.bind(this);
          this.onFocusIn = this.onFocusIn.bind(this);
          this.onFocusOut = this.onFocusOut.bind(this);
          this.onMouseEnter = this.onMouseEnter.bind(this);
          this.onMouseLeave = this.onMouseLeave.bind(this);
          this.onToggle = this.onToggle.bind(this);
          this.onResize = this.onResize.bind(this);
          this.onVisibility = this.onVisibility.bind(this);
          this.onMotionChange = this.onMotionChange.bind(this);

          this.viewport.addEventListener('pointerdown', this.onPointerDown);
          this.viewport.addEventListener('pointermove', this.onPointerMove);
          this.viewport.addEventListener('pointerup', this.onPointerUp);
          this.viewport.addEventListener('pointercancel', this.onPointerUp);
          this.viewport.addEventListener('lostpointercapture', this.onPointerUp);
          this.viewport.addEventListener('click', this.onClickCapture, true);

          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('focusout', this.onFocusOut);

          if (this.pauseHover) {
            this.viewport.addEventListener('mouseenter', this.onMouseEnter);
            this.viewport.addEventListener('mouseleave', this.onMouseLeave);
          }

          if (this.toggle) this.toggle.addEventListener('click', this.onToggle);

          document.addEventListener('visibilitychange', this.onVisibility);

          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.onResize);
            this.resizeObserver.observe(this.viewport);
          } else {
            window.addEventListener('resize', this.onResize);
          }

          // 画面外では自動送りも動画再生も止める（電池とデコード負荷の節約）
          if ('IntersectionObserver' in window) {
            this.sectionObserver = new IntersectionObserver(
              function (entries) {
                this.inView = entries[0].isIntersecting;
                this.sync();
              }.bind(this),
              { rootMargin: '96px 0px' }
            );
            this.sectionObserver.observe(this);

            this.slideObserver = new IntersectionObserver(
              function (entries) {
                entries.forEach(
                  function (entry) {
                    var video = entry.target.querySelector('[data-vs-video]');
                    if (!video) return;
                    if (entry.isIntersecting) this.playVideo(video);
                    else video.pause();
                  }.bind(this)
                );
              }.bind(this),
              { root: this.viewport, rootMargin: '25% 0px', threshold: 0 }
            );
            this.slides.forEach(
              function (slide) {
                this.slideObserver.observe(slide);
              }.bind(this)
            );
          }

          if (this.reduced.addEventListener) this.reduced.addEventListener('change', this.onMotionChange);

          this.dataset.vsMode = 'drag';
          this.viewport.scrollLeft = 0;

          window.requestAnimationFrame(
            function () {
              this.setPosition(0, false);
              this.applyMotionPreference(false);
              this.sync();
            }.bind(this)
          );
        }

        disconnectedCallback() {
          this.stopTimer();
          if (this.frame) window.cancelAnimationFrame(this.frame);
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.sectionObserver) this.sectionObserver.disconnect();
          if (this.slideObserver) this.slideObserver.disconnect();
          document.removeEventListener('visibilitychange', this.onVisibility);
          if (this.reduced.removeEventListener) {
            this.reduced.removeEventListener('change', this.onMotionChange);
          }
        }

        /* ---------- 位置計算 ---------- */

        stepSize() {
          var width = this.slides[0].getBoundingClientRect().width;
          var styles = window.getComputedStyle(this.track);
          var gap = parseFloat(styles.columnGap || styles.gap) || 0;
          return width + gap;
        }

        maxPosition() {
          return Math.max(0, this.track.scrollWidth - this.viewport.clientWidth);
        }

        setPosition(value, animate) {
          var max = this.maxPosition();
          this.position = Math.max(0, Math.min(value, max));

          var run = animate && !this.reduced.matches;
          // 数値は CSS 側（--vs-dur-slide / --ease-out-quint）に置いたまま参照する
          this.track.style.transition = run
            ? 'transform var(--vs-dur-slide) var(--ease-out-quint)'
            : 'none';

          if (this.frame) window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(
            function () {
              this.frame = 0;
              this.track.style.transform = 'translate3d(' + -this.position + 'px, 0, 0)';
            }.bind(this)
          );
        }

        /* ---------- ドラッグ ---------- */

        onPointerDown(event) {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          if (event.target.closest('a, button')) return;

          this.dragging = true;
          this.moved = false;
          this.startX = event.clientX;
          this.startPosition = this.position;

          this.viewport.setAttribute('data-vs-dragging', '');
          this.track.style.transition = 'none';

          if (this.viewport.setPointerCapture && event.pointerId !== undefined) {
            try {
              this.viewport.setPointerCapture(event.pointerId);
            } catch (error) {
              /* 捕捉できない環境では素の pointermove で追う */
            }
          }
          event.preventDefault();
        }

        onPointerMove(event) {
          if (!this.dragging) return;
          var distance = event.clientX - this.startX;
          if (Math.abs(distance) > 3) this.moved = true;
          this.setPosition(this.startPosition - distance, false);
          event.preventDefault();
        }

        onPointerUp() {
          if (!this.dragging) return;
          this.dragging = false;
          this.viewport.removeAttribute('data-vs-dragging');

          if (this.moved) {
            var step = this.stepSize();
            if (step > 0) this.setPosition(Math.round(this.position / step) * step, true);
            // 直後に発火するクリックはドラッグの余韻なので飲み込む
            this.suppressClick = true;
            window.setTimeout(
              function () {
                this.suppressClick = false;
              }.bind(this),
              0
            );
          }
        }

        onClickCapture(event) {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        }

        /* ---------- キーボード ---------- */

        onFocusIn(event) {
          this.focusPaused = true;
          this.sync();

          var slide = event.target.closest('[data-vs-slide]');
          if (!slide) return;

          // overflow:clip 未対応ブラウザ対策。カードが内部スクロールしてしまうのを戻す
          var card = event.target.closest('.vslider__card');
          if (card) {
            card.scrollTop = 0;
            card.scrollLeft = 0;
          }

          var index = this.slides.indexOf(slide);
          if (index < 0) return;

          var step = this.stepSize();
          var width = slide.getBoundingClientRect().width;
          var left = index * step;
          var visible = this.viewport.clientWidth;

          if (left < this.position) this.setPosition(left, true);
          else if (left + width > this.position + visible) this.setPosition(left + width - visible, true);
        }

        onFocusOut(event) {
          if (this.contains(event.relatedTarget)) return;
          this.focusPaused = false;
          this.sync();
        }

        /* ---------- 自動送り ---------- */

        onMouseEnter() {
          this.hoverPaused = true;
          this.sync();
        }

        onMouseLeave() {
          this.hoverPaused = false;
          this.sync();
        }

        onToggle() {
          this.userPaused = !this.userPaused;
          this.sync();
        }

        onVisibility() {
          this.sync();
        }

        onResize() {
          this.setPosition(this.position, false);
        }

        onMotionChange() {
          this.applyMotionPreference(true);
          this.sync();
        }

        /**
         * resume = true のときだけ再生を戻す。初期化時に呼ぶと画面外の動画まで
         * 読み込みが始まってしまうので、初回は「止める側」だけを適用する。
         */
        applyMotionPreference(resume) {
          var stop = this.reduced.matches;
          this.videos.forEach(
            function (video) {
              if (stop) {
                video.autoplay = false;
                video.pause();
                // load() し直すと poster（静止画）に戻る
                try {
                  video.load();
                } catch (error) {
                  /* 読み込み中に呼ぶと例外になる環境がある。表示は poster のまま */
                }
                return;
              }
              // 設定を戻した人には再生も戻す（IO は既に交差済みの要素には再通知しない）
              if (resume) this.playVideo(video);
            }.bind(this)
          );
        }

        playVideo(video) {
          if (this.reduced.matches) return;
          var attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(function () {});
        }

        canRun() {
          return (
            this.autoplay &&
            !this.reduced.matches &&
            this.inView &&
            !this.userPaused &&
            !this.hoverPaused &&
            !this.focusPaused &&
            !document.hidden
          );
        }

        sync() {
          if (this.toggle) {
            if (this.userPaused) this.setAttribute('data-vs-paused', '');
            else this.removeAttribute('data-vs-paused');
            if (this.toggleLabel) {
              this.toggleLabel.textContent = this.userPaused ? '自動送りを再開' : '自動送りを一時停止';
            }
          }

          if (this.canRun()) this.startTimer();
          else this.stopTimer();
        }

        startTimer() {
          if (this.timer) return;
          this.timer = window.setInterval(
            function () {
              if (this.dragging) return;
              var step = this.stepSize();
              var max = this.maxPosition();
              if (step <= 0 || max <= 0) return;
              var next = this.position + step;
              // 右端まで来たら先頭へ戻す（クローン無しの素直な巻き戻し）
              if (next >= max - 5) next = 0;
              this.setPosition(next, true);
            }.bind(this),
            this.speed
          );
        }

        stopTimer() {
          if (!this.timer) return;
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
